/* eslint-disable */
// AUTO-GENERATED by type-utils/combineApiTypes.ts — do not edit by hand.

// Combined API Types

import { LoanTermsOption, PrequalDecisionData, CreditLimitIncreaseRequest, VehicleLocation, TrucksCurrentMileageBackfillBackup_20260903120000, SequelizeMeta, Driver, TruckOutOfServiceLog, PendingTransaction, PartnerAgent, InternalBankAccount, ReferralInvite, MotiveELDInfo, AchAuthorization, VendorBusinessLocation, UnderwritingDecisionData, DocumentRequest, Notification, DebitCard, Payment, Customer, EmailSend, MilesConversation, FollowupEvent, MilesPresetPrompt, DepositInvoice, TransactionTruckAttribution, Application, Partner, LinkedAccount, LoanRequest, SamsaraELDInfo, Loan, CustomerBalanceSnapshot, BrokerContact, CarrierPainPoint, BudgetItem, BudgetAllocation, FeatureFlagAssignment, RolloutPhaseTransition, ScheduledWithdrawal, FeatureFlag, FeatureFlagRolloutSchedule, SystemAlert, Transaction, Bill, Deal, ThirdPartyLogistic, MaintenanceRecord, Lock, CatenaConnection, FuelTransaction, Unload, HighwayCarrierAlert, ELDWebhookEvent, Settlement, DriverInvite, Trailer, MaintenanceReminder, Address, CardDecline, PartnerAgentInvite, Deposit, OnboardingStep, TruckDriverAssignment, AccountDeletionRequest, Vendor, UserDevice, DataExport, DealVendorBusinessLocation, TruckMileageSnapshot, BudgetItemSnapshot, PartnerContactInfo, Event, MonthlyStatement, CustomerCreditEstimation, VendorContactInfo, CorporateBillingApplication, CustomerFinancialHealthReport, MilesMessage, Truck, CustomerTier, FeatureFlagMetric, LiquidityPoolReplenishment, ReportPack, LiquidityPoolLedgerEntry } from './dbTypes';
import { Employee, BrokerLead, MarketingEvent, CarrierLead, ApplicationNote } from './adminDbTypes';

// Types
// From common/types-and-constants/src/types/appVersionPolicy.ts
/**
 * App upgrade version policy — the shared, server-driven contract behind the
 * mobile "update available / update required" prompt. `latest` and `previous` per
 * platform are SSM parameters written at go-live by the mobile release script
 * (`previous` is the `latest` it is about to overwrite); the forced-update floor
 * is derived from them; feature-flags serves the result.
 *
 * These constants and DTOs are the single source of truth so platform values,
 * parameter paths and field names never drift into string literals.
 */

/** The platforms a version policy can target. Stored verbatim in `platform`. */
export enum AppPlatform {
  IOS = 'ios',
  ANDROID = 'android'
}

/** Every supported platform, in a stable iteration order. */
export const APP_PLATFORMS: AppPlatform[] = [AppPlatform.IOS, AppPlatform.ANDROID]

/**
 * Semantic-version matcher (MAJOR.MINOR.PATCH, digits only). Shared by every
 * runtime guard so they can never disagree on "valid".
 */
export const SEMVER_REGEX = /^\d+\.\d+\.\d+$/

/**
 * Store listing each platform's "Update" button opens (the production listings
 * behind the `eas.json` production submit). Broadcast to every install in the
 * DTO, so they live here as constants rather than in configuration anyone can edit.
 */
export const APP_STORE_URLS: Record<AppPlatform, string> = {
  [AppPlatform.IOS]: 'https://apps.apple.com/app/id6738364119',
  [AppPlatform.ANDROID]: 'https://play.google.com/store/apps/details?id=com.tach.money.prod'
}

/** The SSM parameters kept per platform under `/{stage}/app-version/{platform}/`. */
export const APP_VERSION_PARAMETER_KEYS = {
  LATEST: 'latest',
  PREVIOUS: 'previous',
  MIN_SUPPORTED_OVERRIDE: 'min-supported-override'
} as const

export type AppVersionParameterKey =
  (typeof APP_VERSION_PARAMETER_KEYS)[keyof typeof APP_VERSION_PARAMETER_KEYS]

/** SSM parameter name for one of a platform's version parameters. */
export function appVersionParameterPath(
  stage: string,
  platform: AppPlatform,
  key: AppVersionParameterKey
): string {
  return `/${stage}/app-version/${platform}/${key}`
}

/**
 * A single platform's version policy, as returned to clients.
 *
 * `min_supported_version` is the EFFECTIVE forced-update floor, computed on the
 * server (see `resolveAppVersionPolicy`); it never exceeds `latest_version`.
 */
export interface AppVersionPolicyDTO {
  platform: AppPlatform
  latest_version: string
  min_supported_version: string
  store_url: string
}

/**
 * Response shape of `GET /featureFlags/appVersionPolicy`. A platform whose
 * `latest` parameter is missing or malformed is `null` (no prompt).
 */
export interface AppVersionPolicyResponse {
  policies: Record<AppPlatform, AppVersionPolicyDTO | null>
}


// From common/types-and-constants/src/types/applicationSteps.ts
export enum ApplicationStep {
  PersonalInfo = 'personal_info',
  BusinessInfo = 'business_info',
  BusinessDebt = 'business_debt',
  /** Tier decision step between `personal_info` and `review`, THT-770..775. */
  ChoosePlan = 'choose_plan',
  Review = 'review',
  /**
   * Presents the Master Services Agreement and the BluePenguin/Pathward bank agreement together.
   * The two agreements remain legally distinct — separate signature records, versions and PDFs —
   * but they are signed on one step. See docs/combined-agreements-step-feature-spec.md.
   */
  MasterServiceAgreement = 'master_service_agreement',
  /**
   * @deprecated Folded into `MasterServiceAgreement`. Retained for historical rows, in-flight
   * applications parked on it, and old mobile binaries that still walk the two-step flow. Do not
   * route new clients here.
   */
  BankAgreement = 'bank_agreement',
  /**
   * @deprecated Removed from the signup flow. The prequalification workflow itself is unchanged —
   * it is started asynchronously by the Highway lookup on the `master_service_agreement`
   * transition, not by this step. The step was only a wait-and-confetti screen that advanced to
   * `Assets` on approval AND rejection alike, so nothing gated on it. Retained for historical
   * rows, in-flight applications parked on it, and old mobile binaries that still walk the old
   * flow. Do not route new clients here.
   */
  PrequalDecision = 'prequal_decision',
  Assets = 'assets',
  PlaidLink = 'plaid_link',
  PlaidIDV = 'plaid_idv',
  PendingReview = 'pending_review',
  ManualDocumentUpload = 'manual_document_upload',
  FinalConsent = 'final_consent',
  PlaidLinkRetry = 'plaid_link_retry',
  Complete = 'complete'
}

export enum ApplicationStatus {
  ERROR_FINAL_UNDERWRITING = 'error#final_underwriting',
  ERROR_PREQUAL = 'error#prequal',
  PROCESSING_FINAL_UNDERWRITING = 'processing#final_underwriting',
  PROCESSING_PREQUAL = 'processing#prequal',
  COMPLETE_FINAL_UNDERWRITING = 'complete#final_underwriting',
  COMPLETE_PREQUAL = 'complete#prequal',
  PROCESSING_PLAID_LINK_RETRY = 'processing#plaid_link_retry',
  AWAITING_PLAID_LINK_RETRY = 'awaiting#plaid_link_retry',
  COMPLETE_PLAID_LINK_RETRY = 'complete#plaid_link_retry',
  AWAITING_DOCUMENT_REQUEST = 'awaiting#document_request',
  COMPLETE_DOCUMENT_REQUEST = 'complete#document_request',
  AWAITING_PLAID_WEBHOOKS = 'awaiting#plaid_webhooks',
  COMPLETE_PLAID_WEBHOOKS = 'complete#plaid_webhooks',
  COMPLETE_MANUAL_APPLICATION_APPROVAL = 'complete#manual_application_approval',
  COMPLETE_MANUAL_APPLICATION_REJECTION = 'complete#manual_application_rejection',
  REJECTED_BLUE_PENGUIN = 'rejected#blue_penguin',
  PROCESSING_NEW_CUSTOMER_WORKFLOW = 'processing#new_customer_workflow',
  ERROR_NEW_CUSTOMER_WORKFLOW = 'error#new_customer_workflow',
  PROCESSING_BLUE_PENGUIN = 'processing#blue_penguin',
  ERROR_BLUE_PENGUIN = 'error#blue_penguin',
  AWAITING_FINAL_CONSENT = 'awaiting#final_consent',
  COMPLETE_FINAL_CONSENT = 'complete#final_consent',
  CUSTOMER_ACTIVE = 'customer_active',
  AWAITING_BLUE_PENGUIN_DOCUMENTS = 'awaiting#blue_penguin_documents',
  COMPLETE_BLUE_PENGUIN_DOCUMENTS = 'complete#blue_penguin_documents',
  REJECTED_BY_CORPORATE_BILLING = 'rejected#corporate_billing',
  ERROR_SILA_KYC = 'error#sila_kyc',
  SILA_KYC_COMPLETE = 'complete#sila_kyc',
  INSURANCE_MANUAL_OVERRIDE = 'complete#insurance_manual_override',
  REVENUE_MANUAL_OVERRIDE = 'complete#revenue_manual_override',
  COMPLETE_HIGHWAY_CARRIER_DETAILS = 'complete#highway_carrier_details',
  ERROR_HIGHWAY_CARRIER_DETAILS = 'error#highway_carrier_details'
}

export const ApplicationStatusLabels: Record<ApplicationStatus, string> = {
  [ApplicationStatus.ERROR_FINAL_UNDERWRITING]: 'Final Underwriting Error',
  [ApplicationStatus.ERROR_PREQUAL]: 'Prequalification Error',
  [ApplicationStatus.PROCESSING_FINAL_UNDERWRITING]: 'Processing Final Underwriting',
  [ApplicationStatus.PROCESSING_PREQUAL]: 'Processing Prequalification',
  [ApplicationStatus.COMPLETE_FINAL_UNDERWRITING]: 'Final Underwriting Complete',
  [ApplicationStatus.COMPLETE_PREQUAL]: 'Prequalification Complete',
  [ApplicationStatus.PROCESSING_PLAID_LINK_RETRY]: 'Processing Plaid Link Retry',
  [ApplicationStatus.AWAITING_PLAID_LINK_RETRY]: 'Awaiting Plaid Link Retry',
  [ApplicationStatus.COMPLETE_PLAID_LINK_RETRY]: 'Plaid Link Retry Complete',
  [ApplicationStatus.AWAITING_DOCUMENT_REQUEST]: 'Awaiting Document Upload',
  [ApplicationStatus.COMPLETE_DOCUMENT_REQUEST]: 'Document Upload Complete',
  [ApplicationStatus.AWAITING_PLAID_WEBHOOKS]: 'Awaiting Plaid Webhooks',
  [ApplicationStatus.COMPLETE_PLAID_WEBHOOKS]: 'Plaid Webhooks Complete',
  [ApplicationStatus.REJECTED_BLUE_PENGUIN]: 'Rejected by Blue Penguin',
  [ApplicationStatus.PROCESSING_BLUE_PENGUIN]: 'Being Processed by Blue Penguin',
  [ApplicationStatus.PROCESSING_NEW_CUSTOMER_WORKFLOW]: 'Processing New Customer Workflow',
  [ApplicationStatus.ERROR_NEW_CUSTOMER_WORKFLOW]: 'Error in New Customer Workflow',
  [ApplicationStatus.ERROR_BLUE_PENGUIN]: 'Blue Penguin Customer Decision Error',
  [ApplicationStatus.AWAITING_FINAL_CONSENT]: 'Awaiting Final Consent',
  [ApplicationStatus.COMPLETE_FINAL_CONSENT]: 'Final Consent Complete',
  [ApplicationStatus.CUSTOMER_ACTIVE]: 'Customer Active',
  [ApplicationStatus.AWAITING_BLUE_PENGUIN_DOCUMENTS]: 'Awaiting Blue Penguin Documents',
  [ApplicationStatus.COMPLETE_BLUE_PENGUIN_DOCUMENTS]: 'Blue Penguin Documents Complete',
  [ApplicationStatus.COMPLETE_MANUAL_APPLICATION_APPROVAL]: 'Application Manually Approved',
  [ApplicationStatus.COMPLETE_MANUAL_APPLICATION_REJECTION]: 'Application Manually Rejected',
  [ApplicationStatus.REJECTED_BY_CORPORATE_BILLING]: 'Rejected by Corporate Billing',
  [ApplicationStatus.ERROR_SILA_KYC]: 'Sila KYC Error',
  [ApplicationStatus.INSURANCE_MANUAL_OVERRIDE]: 'Insurance Manual Override Complete',
  [ApplicationStatus.REVENUE_MANUAL_OVERRIDE]: 'Revenue Manual Override Complete',
  [ApplicationStatus.SILA_KYC_COMPLETE]: 'Sila KYC Complete',
  [ApplicationStatus.COMPLETE_HIGHWAY_CARRIER_DETAILS]: 'Highway Carrier Details Complete',
  [ApplicationStatus.ERROR_HIGHWAY_CARRIER_DETAILS]: 'Highway Carrier Details Error'
}


// From common/types-and-constants/src/types/assetReportAnalysis.ts
/**
 * Type definitions for comprehensive asset report analysis
 * These types support income analysis, expense tracking, and recurring payment detection
 */

// Individual transaction from Plaid asset report (simplified)
export interface AssetReportTransaction {
  transactionId: string
  accountId: string
  date: string // ISO date
  amount: number // Positive for debits, negative for credits in Plaid
  merchantName: string
  description: string
  category?: string
  type: 'debit' | 'credit' | 'transfer'
  pending: boolean
}

// Income analysis results
export interface IncomeAnalysis {
  averageMonthlyIncome: number
  estimatedAnnualRevenue: number
  confidenceLevel: 'low' | 'medium' | 'high'
  dataPoints: number
  accountBreakdown: Array<{
    plaidAccountId: string
    accountName: string
    monthlyIncome: number
    confidenceLevel: string
  }>
}

// Expense analysis results
export interface ExpenseAnalysis {
  averageMonthlyExpenses: number
  estimatedAnnualExpenses: number
  confidenceLevel: 'low' | 'medium' | 'high'
  dataPoints: number
  // Group by amount ranges for insights
  expenseByAmountRange: {
    under50: number // avg monthly
    range50to200: number
    range200to500: number
    range500to1000: number
    over1000: number
  }
}

// Detected recurring payment
export interface RecurringPayment {
  merchantName: string
  averageAmount: number
  amountVariance: number // percentage (0-100)
  frequency: 'weekly' | 'bi-weekly' | 'monthly' | 'quarterly' | 'irregular'
  occurrences: number
  confidenceScore: number // 0-100
  dates: string[] // ISO dates of occurrences
  nextExpectedDate?: string
  totalAnnualAmount: number // projected annual cost
}

// Summary statistics for the analysis
export interface AnalysisSummary {
  totalAccounts: number
  rawTransactionDateRange: {
    start: string
    end: string
    daysAnalyzed: number
  }
  netCashFlow: number // monthly average (income - expenses)
  recurringExpensesTotalMonthly: number
  dataQuality: 'excellent' | 'good' | 'fair' | 'poor'
}

// Complete asset report analysis structure
export interface AssetReportAnalysis {
  // Metadata
  customerId: string
  assetReportId: string
  analysisDate: string // ISO date
  processingVersion: string // For future schema migrations

  // Analysis results
  incomeAnalysis: IncomeAnalysis
  expenseAnalysis: ExpenseAnalysis
  recurringPayments: RecurringPayment[]

  // Raw transaction data (last 90 days)
  rawTransactions: AssetReportTransaction[]

  // Summary statistics
  summary: AnalysisSummary
}

// From common/types-and-constants/src/types/assets.ts
export enum TruckType {
  DayCab = 'day_cab',
  Sleeper = 'sleeper',
  BoxTruck = 'box_truck',
  DumpTruck = 'dump_truck',
  Other = 'other'
}

export enum TrailerType {
  Reefer = 'reefer',
  Flatbed = 'flatbed',
  Tanker = 'tanker',
  Intermodal = 'intermodal',
  Pneumatic = 'pneumatic',
  Dump = 'dump',
  CarHauler = 'car_hauler',
  DoubleDropDeck = 'double_drop_deck',
  Lowboy = 'lowboy',
  Grain = 'grain',
  Livestock = 'livestock',
  HeavyHaul = 'heavy_haul',
  DropDeck = 'drop_deck',
  RefuseTransfer = 'refuse_transfer',
  Forestry = 'forestry',
  DryVan = 'dry_van',
  StepDeck = 'step_deck',
  Other = 'other'
}

export const TruckTypeDisplayNames: Record<TruckType, string> = {
  [TruckType.DayCab]: 'Day Cab',
  [TruckType.Sleeper]: 'Sleeper',
  [TruckType.BoxTruck]: 'Box Truck',
  [TruckType.DumpTruck]: 'Dump Truck',
  [TruckType.Other]: 'Other'
}

export const TrailerTypeDisplayNames: Record<TrailerType, string> = {
  [TrailerType.Reefer]: 'Reefer',
  [TrailerType.Flatbed]: 'Flatbed',
  [TrailerType.Tanker]: 'Tanker',
  [TrailerType.Intermodal]: 'Intermodal',
  [TrailerType.Pneumatic]: 'Pneumatic',
  [TrailerType.Dump]: 'Dump',
  [TrailerType.CarHauler]: 'Car Hauler',
  [TrailerType.DoubleDropDeck]: 'Double Drop Deck',
  [TrailerType.Lowboy]: 'Lowboy',
  [TrailerType.Grain]: 'Grain',
  [TrailerType.Livestock]: 'Livestock',
  [TrailerType.HeavyHaul]: 'Heavy Haul',
  [TrailerType.DropDeck]: 'Drop Deck',
  [TrailerType.RefuseTransfer]: 'Refuse Transfer',
  [TrailerType.Forestry]: 'Forestry',
  [TrailerType.DryVan]: 'Dry Van',
  [TrailerType.StepDeck]: 'Step Deck',
  [TrailerType.Other]: 'Other'
}


// From common/types-and-constants/src/types/budgeting.ts
export interface BudgetItemComputed {
  category: string
  category_display_name: string
  budget_bucket_limit: number
  amount: number
  time_window_in_months: number
  emoji_unicode: string
  rollover: number
  spent: number
  saved: number
  isCustom: boolean
  customer_selected_amount?: number
  monthly_goal: number
}

export interface BudgetCategory {
  categoryName: string
  emoji_unicode: string
  displayName: string
}


// From common/types-and-constants/src/types/cashAdvances.ts
export enum CashAdvanceRejectionReason {
  INCONSISTENT_REVENUE = 'inconsistent_revenue',
  NO_INCOME_LAST_30_DAYS = 'no_income_last_30_days'
}

export const CashAdvanceRejectionReasonLabels: Record<CashAdvanceRejectionReason, string> = {
  [CashAdvanceRejectionReason.INCONSISTENT_REVENUE]: 'Inconsistent Revenue',
  [CashAdvanceRejectionReason.NO_INCOME_LAST_30_DAYS]: 'No Income in Last 30 Days'
}

export enum LoanType {
  CASH_ADVANCE = 'cash_advance',
  FUEL_ADVANCE = 'fuel_advance'
}

export enum FuelAdvanceStatus {
  PENDING_REVIEW = 'pending_review',
  APPROVED = 'approved',
  FUNDED = 'funded',
  ACTIVE = 'active',
  REPAID = 'repaid',
  REJECTED = 'rejected',
  PAST_DUE = 'past_due',
  DEFAULTED = 'defaulted'
}

export enum FuelAdvanceRejectionReason {
  DOC_ILLEGIBLE = 'doc_illegible',
  DOC_INCOMPLETE = 'doc_incomplete',
  DOC_MISMATCH = 'doc_mismatch',
  CARRIER_MISMATCH = 'carrier_mismatch',
  AMOUNT_EXCEEDS_CAP = 'amount_exceeds_cap',
  SUSPECTED_FRAUD = 'suspected_fraud',
  DUPLICATE_LOAD = 'duplicate_load',
  STALE_BOL = 'stale_bol',
  RISK_DENIAL = 'risk_denial',
  OTHER = 'other'
}

export const FuelAdvanceRejectionReasonLabels: Record<FuelAdvanceRejectionReason, string> = {
  [FuelAdvanceRejectionReason.DOC_ILLEGIBLE]: 'Document Illegible',
  [FuelAdvanceRejectionReason.DOC_INCOMPLETE]: 'Document Incomplete',
  [FuelAdvanceRejectionReason.DOC_MISMATCH]: 'Document Mismatch',
  [FuelAdvanceRejectionReason.CARRIER_MISMATCH]: 'Carrier Mismatch',
  [FuelAdvanceRejectionReason.AMOUNT_EXCEEDS_CAP]: 'Amount Exceeds Cap',
  [FuelAdvanceRejectionReason.SUSPECTED_FRAUD]: 'Suspected Fraud',
  [FuelAdvanceRejectionReason.DUPLICATE_LOAD]: 'Duplicate Load',
  [FuelAdvanceRejectionReason.STALE_BOL]: 'Stale BOL',
  [FuelAdvanceRejectionReason.RISK_DENIAL]: 'Risk Denial',
  [FuelAdvanceRejectionReason.OTHER]: 'Other'
}

export interface FuelAdvanceEligibilityResponse {
  eligible: boolean
  reason?: string
  customer_tier?: string
}

export interface FuelAdvanceLoanRequestDetails {
  request_id: string
  customer_id: string
  amount: number
  load_value_cents: number | null
  fee_rate_basis_points: number | null
  fee_amount_cents: number | null
  fuel_advance_status: string | null
  rejection_reason: string | null
  delivery_date: string | null
  created_at: string | null
  decided_at: string | null
  decided_by: string | null
  funded_at: string | null
  mercury_transaction_id: string | null
  high_risk_flagged_at: string | null
  info_requested_at: string | null
  info_requested_note: string | null
  type: string
  customer: {
    business_name: string
    email: string
    phone_number: string
  }
}

export interface FuelAdvanceRepaymentTransaction {
  transaction_id: string
  amount: number
  description: string | null
  type: string | null
  category: string | null
  transaction_timestamp: string | null
  merchant_name: string | null
}

export interface FuelAdvanceRepayment {
  payment_id: string
  amount: number
  payment_status: string
  payment_context: string
  created_at: string | null
  loan_id: string
  transaction: FuelAdvanceRepaymentTransaction | null
}

export interface FuelAdvanceRepaymentLoan {
  loan_id: string
  current_balance: number
  cash_to_customer: number
  total_cost_of_loan: number
  fees_set_at_origination: number
  status: string
  originated_at: string | null
  delivery_date: string | null
  due_date: string | null
  is_greedy_repayment: boolean
  is_funded: boolean
  funded_timestamp: string | null
  type: string
}

export interface FuelAdvanceRepaymentSummary {
  total_repaid_cents: number
  total_repaid_dollars: number
  remaining_balance_cents: number
  remaining_balance_dollars: number
  original_amount_cents: number
  original_amount_dollars: number
  repayment_count: number
  repayment_percentage: number
}

export interface FuelAdvanceRepaymentData {
  loan: FuelAdvanceRepaymentLoan | null
  repayments: FuelAdvanceRepayment[]
  summary: FuelAdvanceRepaymentSummary
}


// From common/types-and-constants/src/types/catenaTypes.ts
export enum CatenaConnectionStatus {
  Invited = 'invited',
  Viewed = 'viewed',
  Accepted = 'accepted',
  Connected = 'connected',
  Declined = 'declined',
  Expired = 'expired',
  Staled = 'staled',
  // Customer-initiated disconnect: we cancelled the Catena share agreement and tore down our
  // links. Kept (not deleted) for audit; the FE treats it as "not connected".
  Disconnected = 'disconnected'
}

// Catena webhook event_name values we handle. Wildcards are subscribed at
// registration time; these are the concrete names that arrive in payloads.
export enum CatenaWebhookEventName {
  InvitationViewed = 'invitation.viewed',
  InvitationAccepted = 'invitation.accepted',
  InvitationDeclined = 'invitation.declined',
  InvitationExpired = 'invitation.expired',
  ShareAgreementCreated = 'share_agreement.created',
  ConnectionCreated = 'connection.created',
  ConnectionStaled = 'connection.staled',
  FleetConnectionCreated = 'fleet_connection.created',
  VehicleAdded = 'vehicle.added',
  VehicleModified = 'vehicle.modified',
  VehicleRemoved = 'vehicle.removed',
  // NOTE: Catena's WebhookEventNameEnum uses underscores within resource names
  // (vehicle_location, engine_log, fuel_transaction) — not hyphens.
  VehicleLocationAdded = 'vehicle_location.added',
  EngineLogAdded = 'engine_log.added',
  EngineLogModified = 'engine_log.modified',
  FuelTransactionAdded = 'fuel_transaction.added',
  FuelTransactionModified = 'fuel_transaction.modified',
  // Catena's own scheduled pull from the TSP failed. Says WHICH pull, never why.
  ExecutionFailed = 'execution.failed'
}

// event_name prefixes used when registering org-wide subscriptions.
// We subscribe to Catena's full catalog: families with dedicated processing are routed in
// processCatenaWebhook; everything else is stored to ELDWebhookEvents (stored_only) for later
// use. Events that can't be mapped to a customer (tsp.*, webhook.*, unconnected fleets) are
// logged and dropped — ELDWebhookEvents.customer_id is NOT NULL.
export const CATENA_WEBHOOK_SUBSCRIPTIONS: string[] = [
  // Lifecycle / org
  'webhook.*',
  'invitation.*',
  'share_agreement.*',
  'connection.*',
  'fleet_connection.*',
  'fleet_info.*',
  // Single-event family — Catena's WebhookEventNameEnum has no 'tsp.*' wildcard entry (422)
  'tsp.created',
  // Sync health
  'execution.*',
  'schedule.*',
  'resource_operation.*',
  // Vehicles
  'vehicle.*',
  'vehicle_location.added',
  'engine_log.*',
  'engine_status.*',
  'fuel_transaction.*',
  'driver_vehicle_association.*',
  // Trailers
  'trailer.*',
  'trailer_status.*',
  'trailer_location.*',
  'trailer_vehicle_association.*',
  // Compliance
  'dvir_log.*',
  'ifta_summary.*',
  'hos_availability.*',
  'hos_daily_snapshot.*',
  'hos_event.*',
  'hos_violation.*',
  // People / comms
  'user.*',
  'workflow.*',
  'message.*',
  'group_message.*'
]

/**
 * The Catena `resource` values `processCatenaWebhook` actually acts on. Everything else it receives
 * is archived with `no_processor` and never read, so a failed pull of it costs us nothing.
 *
 * Keep this in step with `handleDataItem`:
 *   `vehicle.*`              -> handleCatenaVehicleEvent (creates/links trucks)
 *   `vehicle_location.added` -> processCatenaLocation (mileage)
 *   `engine_log.*`           -> processCatenaFaultCode
 *   `fuel_transaction.*`     -> handleCatenaFuelTransaction
 */
export const CATENA_CONSUMED_RESOURCES: string[] = [
  'vehicle',
  'vehicle_location',
  'engine_log',
  'fuel_transaction'
]

/**
 * Per-subscription delivery filters, applied at Catena's end so undeliverable noise never reaches us.
 *
 * Catena schedules a pull for every resource in their catalogue regardless of what we subscribe to,
 * and emits `execution.failed` for each one that fails — so **81% of the failures we received were
 * for resources we never consume** (`message`, `workflow`, `ifta_summary`, `hos_*`, `trailer_*`,
 * `user`, `dvir_log`, `driver_safety_event`). That ratio is why nobody could act on the event: any
 * alert built on it would have been mostly false positives.
 *
 * Filtering server-side rather than ignoring events on arrival is deliberate — it is the difference
 * between an alertable signal and a log line.
 */
export const CATENA_WEBHOOK_SUBSCRIPTION_FILTERS: Record<string, { content: Record<string, string[]> }> = {
  'execution.failed': { content: { resource: CATENA_CONSUMED_RESOURCES } }
}

/**
 * Traffic-light severity for a customer's Catena connection, as rendered by the admin portal chip.
 *
 * The colours grade the CONNECTION, not ops urgency. The dividing line between Gray and everything
 * else is whether a provider link has ever existed (axis 2 of the three-axis model below): consent
 * on its own yields no data, so an `accepted` row that never signed in to its TSP is Gray, not
 * Yellow. Which action an admin should take rides on `CatenaHealthReason`, not on the colour.
 *
 * Named for the colours rather than semantically ("degraded", "critical") because the product
 * decision this encodes is literally "what colour does the chip show", and the frontend maps 1:1.
 */
export enum CatenaHealthSeverity {
  // Data is flowing.
  Green = 'green',
  // A provider link exists; data is degraded or has not started arriving yet.
  Yellow = 'yellow',
  // A provider link exists, data should be arriving, and it is not.
  Red = 'red',
  // No working connection. Nothing will arrive until a human does something.
  Gray = 'gray'
}

/**
 * Why a connection landed on its severity — the precise state, and what the chip label says.
 *
 * A Catena link is THREE independent async completions, not one linear status: consent (the share
 * agreement), the provider link (they signed in to their TSP), and the roster (Catena finished
 * pulling vehicles, 3-7 minutes later). `CatenaConnection.status` flattens all three into one enum,
 * which is why `connected` alone cannot distinguish a healthy 15-truck feed from one that has been
 * silent for a week. These reasons unflatten it, and add the fourth thing the status never captured:
 * whether telemetry is actually arriving.
 *
 * Evaluated in the precedence order documented on `deriveCatenaHealth` in catena-utils.
 */
export enum CatenaHealthReason {
  // --- Gray: no provider link has ever existed, so no data can arrive ---
  /** No CatenaConnection row at all — never started. */
  NeverConnected = 'never_connected',
  /** Customer declined the share agreement. */
  Declined = 'declined',
  /** Customer disconnected; we cancelled the share agreement at Catena. */
  Disconnected = 'disconnected',
  /** Our expiry sweep terminalized an invitation that idled out. */
  Expired = 'expired',
  /** Still in-flight but idle past the expiry cutoff — the sweep has not caught it yet. */
  SetupStalled = 'setup_stalled',
  /** Approved TACH but never signed in to their ELD provider. The admin's cue to call them. */
  AwaitingProviderLogin = 'awaiting_provider_login',
  /** Invitation sent, not yet accepted. */
  AwaitingConsent = 'awaiting_consent',

  // --- Yellow: a provider link exists, data imperfect ---
  /**
   * Catena delivered a roster and every vehicle on it is still awaiting admin approval. Telemetry
   * provably cannot flow yet — the location ingest resolves trucks through Truck's default scope,
   * which hides `pending_approval` — so this is graded ABOVE the feed checks and never on silence.
   * The action is to approve them in the admin Pending Trucks tab, not to re-audit the fleet.
   */
  RosterPendingApproval = 'roster_pending_approval',
  /** Connected within the grace window; roster and first telemetry have not landed yet. */
  WarmingUp = 'warming_up',
  /** Telemetry has gone quiet, but not long enough to call the feed dead. */
  FeedQuiet = 'feed_quiet',
  /** Catena marked the provider link staled, but data is still arriving. */
  NeedsReconnect = 'needs_reconnect',

  // --- Red: a provider link exists, data should be arriving, and it is not ---
  /** Connected past the grace window with an empty roster — Catena returned no vehicles. */
  NoVehiclesLinked = 'no_vehicles_linked',
  /** Telemetry silent past the dead cutoff. The failure that is otherwise invisible from inside TACH. */
  FeedDead = 'feed_dead',

  // --- Green ---
  /** Linked roster, telemetry arriving. */
  Connected = 'connected'
}

/** A customer's Catena connection health, as returned by the admin API and rendered by the chip. */
export interface CatenaHealth {
  customer_id: string
  severity: CatenaHealthSeverity
  reason: CatenaHealthReason
  /** The selected row's status, or null when the customer has no connection row at all. */
  status: CatenaConnectionStatus | null
  connected_tsps: string[]
  /**
   * ACTIVE trucks linked to a vehicle on Catena's roster (`eld_type = catena` AND an
   * `external_eld_vehicle_id`). The `eld_type` guard is load-bearing: the retired Motive/Samsara
   * linkers wrote `external_eld_vehicle_id` too, so counting the column alone lets a customer's old
   * Motive links stand in for a Catena roster that is actually empty.
   */
  linked_truck_count: number
  /**
   * Catena-linked trucks still in `pending_approval` — the roster arrived but nobody has accepted
   * it. Counted separately because they carry no telemetry and call for a different action.
   */
  pending_truck_count: number
  /** Active, non-deleted trucks in TACH (any ELD or none), so the tooltip can render "2/3 linked". */
  active_truck_count: number
  /** Most recent Catena-sourced vehicle location (ISO), or null if none has ever arrived. */
  last_telemetry_at: string | null
  /**
   * The instant the silence clock runs from (ISO) — `last_telemetry_at`, falling back to when the
   * connection went live. Returned so the tooltip renders the SAME number the severity was derived
   * from rather than recomputing the fallback and drifting from it.
   */
  silence_since: string | null
  connected_at: string | null
  invited_at: string | null
  /**
   * When we last reconciled this row against Catena. Surfaced because the health read is DB-only:
   * an in-flight row only advances on webhooks (bounded by the nightly reconcile), so an admin
   * about to act on `awaiting_provider_login` can see how fresh that claim is.
   */
  last_synced_at: string | null
}


// From common/types-and-constants/src/types/clientContext.ts
/**
 * Where a request originated — which TACH client app made the call.
 *
 * Populated from the `X-App-Client` request header (see `extractClientContext`
 * in `http-utils`) and stored on application `Event.metadata.client`, so the
 * signup funnel can be broken down by channel. Falls back to `UNKNOWN` when the
 * header is absent (e.g. older app builds that predate the header, or direct
 * API calls).
 */
export enum ClientChannel {
  WEB = 'web',
  IOS = 'ios',
  ANDROID = 'android',
  UNKNOWN = 'unknown'
}

/**
 * Maps the raw `X-App-Client` header value (lowercased) to a normalized channel.
 * The clients send `tach-web` / `tach-ios` / `tach-android`.
 *
 * A `Map` (not an object) so lookups on attacker-controlled header values can't
 * hit inherited `Object.prototype` keys (e.g. `constructor`, `__proto__`).
 */
export const CLIENT_HEADER_TO_CHANNEL = new Map<string, ClientChannel>([
  ['tach-web', ClientChannel.WEB],
  ['tach-ios', ClientChannel.IOS],
  ['tach-android', ClientChannel.ANDROID]
])

/**
 * Normalized "where did this request come from" context, extracted from request
 * headers at the HTTP entry point and threaded down to event tracking.
 *
 * `channel` is the queryable signal; `userAgent` is the raw backstop for device
 * spelunking and is captured even before a client sends the explicit header.
 */
export interface ClientContext {
  /** Normalized client channel (web / ios / android); `UNKNOWN` if not declared. */
  channel: ClientChannel
  /** Client-declared app/build version (`X-App-Version`); `null` if not sent. */
  appVersion: string | null
  /** Raw `User-Agent` header; `null` if absent. */
  userAgent: string | null
}


// From common/types-and-constants/src/types/credit.ts
export enum LoanRequestDecision {
  APPROVED = 'approved',
  DECLINED = 'declined'
}

export enum LoanRequestEventSubType {
  CREDIT_CHECK_CALLBACK = 'credit_check_callback#corporate_billing',
  INVOICE_CALLBACK = 'invoice_callback#corporate_billing',
  SELECT_LOAN_TERMS_OPTION = 'complete#select_loan_terms_option',
  CREDIT_CHECK_RESPONSE = 'credit_check_result_update#corporate_billing',
  CB_INVOICE_SUBMISSION_RESPONSE = 'invoice_submission_response#corporate_billing',
  CB_INVOICE_FILE_SUBMITTED = 'invoice_file_submitted#corporate_billing',
  CB_DECISION_RESPONSE = 'invoice_decision_response#corporate_billing',
  LOAN_CREATED = 'loan_created',
  OPTIONS_PRESENTED = 'options_presented#admin_portal',
  OPTIONS_SELECTED_BY_CUSTOMER = 'options_selected_by_customer#credit_service',
  OPTIONS_DECLINED_BY_CUSTOMER = 'options_declined_by_customer#credit_service',
  OPTIONS_EXPIRED = 'options_expired#credit_workflow'
}

export enum LoanRequestEventCreatedBy {
  CORPORATE_BILLING_WEBHOOK = 'corporate_billing_webhook',
  ADMIN_CASH_ADVANCES_SERVICE = 'admin_cash_advances_service',
  CB_CREDIT_CHECK_WORKFLOW = 'cb_credit_check_workflow',
  CB_SUBMIT_LOAN_REQUEST_INVOICE_WORKFLOW = 'cb_submit_loan_request_invoice_workflow',
  FINALIZE_TACH_FUNDED_CASH_ADVANCE_WORKFLOW = 'finalize_tach_funded_cash_advance_workflow',
  CREDIT_SERVICE = 'credit_service',
  PRESENT_CASH_ADVANCE_OPTIONS_WORKFLOW = 'present_cash_advance_options_workflow'
}

export enum LoanTermsOptionEventSubType {
  OPTION_SELECTED = 'option_selected#admin_portal',
  CONSENT_SIGNED = 'consent_signed#dropbox_sign_webhook',
  AWAITING_CONSENT = 'awaiting_consent',
  OPTION_PRESENTED = 'option_presented#admin_portal',
  CUSTOMER_OPTION_SELECTED = 'customer_option_selected#credit_service',
  OPTIONS_DECLINED = 'options_declined#credit_service',
  OPTIONS_EXPIRED = 'options_expired#credit_workflow'
}

export enum LoanTermsOptionEventCreatedBy {
  ADMIN_CASH_ADVANCES_SERVICE = 'admin_cash_advances_service',
  FINALIZE_TACH_FUNDED_CASH_ADVANCE_WORKFLOW = 'finalize_tach_funded_cash_advance_workflow',
  SUBMIT_LOAN_REQUEST_INVOICE_WORKFLOW = 'submit_loan_request_invoice_workflow',
  CREDIT_SERVICE = 'credit_service',
  PRESENT_CASH_ADVANCE_OPTIONS_WORKFLOW = 'present_cash_advance_options_workflow'
}


// From common/types-and-constants/src/types/customers.ts
export enum CustomerStatus {
  Pending = 'pending',
  PreActive = 'pre_active',
  Active = 'active',
  Terminated = 'terminated'
}

/**
 * How a customer's insurance premium is captured (THT-675).
 *
 * `PerAsset` (the default, and today's behavior) sums `insurance_payment_amount`
 * across the customer's trucks and trailers. `Fleet` ignores those per-asset values
 * and uses the single customer-level `fleet_insurance_premium_amount_cents` instead.
 * Switching back to `PerAsset` is lossless — per-asset amounts are never destroyed.
 */
export enum InsurancePremiumMode {
  PerAsset = 'per_asset',
  Fleet = 'fleet'
}

/** Every valid InsurancePremiumMode value — the source of truth for joi `.valid(...)`. */
export const INSURANCE_PREMIUM_MODE_VALUES = Object.values(InsurancePremiumMode)

/**
 * Upper bound for `fleet_insurance_premium_amount_cents`.
 *
 * This is the column ceiling, NOT a business one: `Customers.fleet_insurance_premium_amount_cents`
 * is a Postgres INTEGER, so anything above this fails at INSERT time with "value out of range for
 * type integer" (a 500) instead of a validation error. Every joi schema accepting the field caps at
 * this value so an oversized amount comes back as a 400 naming the field. A tighter, product-owned
 * ceiling (this one accepts ~$21.4M/month) would belong here too.
 */
export const MAX_FLEET_INSURANCE_PREMIUM_AMOUNT_CENTS = 2147483647


// From common/types-and-constants/src/types/dispatchPricing.ts
/**
 * Dispatch-pricing types (THT-691) — carrier authority age + the pricing
 * payload. Pure types/constants only; the resolution logic lives in
 * `functions/dispatchPricing.ts` and the fee matrix in
 * `constants/dispatchPricing.ts`.
 */

/**
 * Where a carrier's authority age was resolved from — reported to the API
 * consumer as `authority_source`.
 *  - `highway`: the Highway continuous-authority grant date we cached on the
 *    customer (`Customer.authority_grant_date`, populated during the prequal
 *    carrier-details pull). The value originates from Highway — pricing reads
 *    it from our own column, never a live Highway call.
 *  - `business_start_date`: the customer's business start date — the fallback
 *    when no grant date is stored.
 *  - `default`: nothing known — presumed UNDER 1 yr (conservative; quotes the
 *    higher fee).
 */
export const AUTHORITY_SOURCES = ['highway', 'business_start_date', 'default'] as const
export type AuthoritySource = (typeof AUTHORITY_SOURCES)[number]

/** A resolved authority age: which side of the 1-year line, and the source. */
export interface AuthorityAge {
  authorityOver1yr: boolean
  authoritySource: AuthoritySource
}

/**
 * The pricing payload returned by GET /load-request/pricing — contract shared
 * with mobile (docs/spec-dispatch-pricing-mobile.md), hence the snake_case.
 */
export interface DispatchPricing {
  standard_pct: number
  box_hotshot_pct: number
  authority_over_1yr: boolean
  authority_source: AuthoritySource
}


// From common/types-and-constants/src/types/documentObjects.ts
export enum DocumentObjectType {
  Truck = 'truck',
  Trailer = 'trailer',
  Driver = 'driver',
  Customer = 'customer',
  MaintenanceRecord = 'maintenanceRecord',
  Vendor = 'vendor',
  VendorBusinessLocation = 'vendorBusinessLocation',
  DataExport = 'dataExport',
  MonthlyStatement = 'monthlyStatement',
  CashAdvanceInvoice = 'cashAdvanceInvoice',
  FuelAdvanceDocument = 'fuelAdvanceDocument',
  VoidedCheck = 'voidedCheck'
}

export enum VendorDocumentSubType {
  Logo = 'logo'
}

export enum VendorBusinessLocationDocumentSubType {
  Images = 'images'
}

export enum TruckDocumentSubType {
  Images = 'images',
  MaintenanceRecords = 'maintenanceRecords'
}

export enum TrailerDocumentSubType {
  Images = 'images',
  MaintenanceRecords = 'maintenanceRecords'
}

export enum DocumentObjectKeyTypes {
  MaintenanceRecord = 'maintenanceRecord',
  DataExport = 'dataExport',
  MonthlyStatement = 'monthlyStatement'
}

export enum CashAdvanceInvoiceDocumentSubType {
  Invoice = 'invoice'
}

export enum FuelAdvanceDocumentSubType {
  BOL = 'bol',
  RateConfirmation = 'rateConfirmation'
}

export enum DropboxSignTemplateType {
  MembershipAgreement = 'membershipAgreement',
  CashAdvanceAgreement = 'cashAdvanceAgreement',
  CustomerAgreement = 'customerAgreement'
}


// From common/types-and-constants/src/types/driverInvites.ts
export enum DriverInviteStatus {
  PENDING = 'pending',
  STARTED_ONBOARDING = 'started_onboarding',
  ACTIVE = 'active',
  CANCELLED = 'cancelled'
}


// From common/types-and-constants/src/types/drivers.ts
export enum DriverStatus {
  PENDING = 'pending',
  ACTIVE = 'active',
  INACTIVE = 'terminated'
}


// From common/types-and-constants/src/types/eldTypes.ts
export enum ELDTypes {
  Samsara = 'samsara',
  Motive = 'motive',
  Catena = 'catena'
}

export enum TruckMileageSnapshotStatus {
  Pending = 'pending',
  Submitted = 'submitted',
  Completed = 'completed'
}

export enum TruckMileageSnapshotSource {
  ManualRequest = 'manual_request',
  MotiveWebhook = 'motive_webhook',
  CatenaWebhook = 'catena_webhook',
  CatenaReconciliation = 'catena_reconciliation',
  SamsaraPoll = 'samsara_poll'
}

export enum TruckCurrentMileageSource {
  Eld = 'eld',
  Manual = 'manual'
}

export enum VehicleLocationSource {
  MotiveWebhook = 'motive_webhook',
  CatenaWebhook = 'catena_webhook',
  CatenaReconciliation = 'catena_reconciliation',
  SamsaraPoll = 'samsara_poll'
}

export enum TruckMileageSnapshotSubmittedByType {
  PRIMARY_OWNER = 'primary_owner',
  DRIVER = 'driver'
}

export enum FaultCodeAction {
  Opened = 'fault_code_opened',
  Closed = 'fault_code_closed'
}

export enum SpeedingEventType {
  Posted = 'posted',
  Personal = 'personal'
}

export enum InspectionType {
  PreTrip = 'pre_trip',
  PostTrip = 'post_trip',
  Periodic = 'periodic'
}

export enum InspectionStatus {
  Satisfactory = 'satisfactory',
  Unsatisfactory = 'unsatisfactory'
}

export enum SamsaraWebhookEventType {
  // Vehicles & Drivers
  VehicleCreated = 'VehicleCreated',
  VehicleUpdated = 'VehicleUpdated',
  DriverCreated = 'DriverCreated',
  DriverUpdated = 'DriverUpdated',
  // Engine Diagnostics
  EngineFaultOn = 'EngineFaultOn',
  EngineFaultOff = 'EngineFaultOff',
  // Geofence
  GeofenceEntry = 'GeofenceEntry',
  GeofenceExit = 'GeofenceExit',
  // Speeding
  SpeedingEventStarted = 'SpeedingEventStarted',
  SpeedingEventEnded = 'SpeedingEventEnded',
  SevereSpeedingStarted = 'SevereSpeedingStarted',
  SevereSpeedingEnded = 'SevereSpeedingEnded',
  // Inspections & Safety
  DvirSubmitted = 'DvirSubmitted',
  IssueCreated = 'IssueCreated',
  // Addresses
  AddressCreated = 'AddressCreated',
  AddressUpdated = 'AddressUpdated',
  AddressDeleted = 'AddressDeleted',
  // Documents & Forms
  DocumentSubmitted = 'DocumentSubmitted',
  FormSubmitted = 'FormSubmitted',
  FormUpdated = 'FormUpdated',
  // Maintenance
  PredictiveMaintenanceAlert = 'PredictiveMaintenanceAlert',
  // Hardware
  GatewayUnplugged = 'GatewayUnplugged',
  // Routes
  RouteStopArrival = 'RouteStopArrival',
  RouteStopDeparture = 'RouteStopDeparture',
  RouteStopEarlyLateArrival = 'RouteStopEarlyLateArrival',
  RouteStopEtaUpdated = 'RouteStopEtaUpdated',
  RouteStopResequence = 'RouteStopResequence'
}

export const SamsaraWebhookEventTypes = Object.values(SamsaraWebhookEventType)

export enum TruckStatus {
  Active = 'active',
  PendingApproval = 'pending_approval',
}


// From common/types-and-constants/src/types/employees.ts
/**
 * Outcome of `authorizeEmployee` (auth-utils). The result is an object and therefore always truthy,
 * so callers must compare its `status` against these members rather than test the result itself.
 */
export enum EmployeeAuthorizationStatus {
  AUTHORIZED = 'authorized',
  UNAUTHORIZED = 'unauthorized'
}

/**
 * Why `authorizeEmployee` returned UNAUTHORIZED — lets a caller pick the right 403 body: a
 * `no_employee` denial (no employee row at all) vs a `missing_permission` denial (the caller's
 * role lacks the requested permission).
 */
export enum EmployeeAuthorizationDenialReason {
  NO_EMPLOYEE = 'no_employee',
  MISSING_PERMISSION = 'missing_permission'
}

/** Actions an admin route can require the caller's role to grant. */
export enum AdminPermission {
  CARDS_MANAGE = 'cards:manage',
  ADDRESSES_MANAGE = 'addresses:manage',
  BUDGET_MANAGE = 'budget:manage'
}


// From common/types-and-constants/src/types/entities.ts
export enum Entity {
  Customer = 'customer',
  Vendor = 'vendor',
  Partner = 'partner',
  Driver = 'driver',
  PartnerAgent = 'partnerAgent'
}

export enum VendorType {
  FuelStation = 'fuel_station',
  TireSupplier = 'tire_supplier',
  RepairShop = 'repair_shop',
  TowingService = 'towing_service',
  TruckRental = 'truck_rental',
  PreventativeMaintenance = 'preventative_maintenance',
  TruckStop = 'truck_stop',
  Other = 'other'
}

export const VendorTypeDisplayNames: Record<VendorType, string> = {
  [VendorType.FuelStation]: 'Fuel Station',
  [VendorType.TireSupplier]: 'Tire Supplier',
  [VendorType.RepairShop]: 'Repair Shop',
  [VendorType.TowingService]: 'Towing Service',
  [VendorType.TruckRental]: 'Truck Rental',
  [VendorType.PreventativeMaintenance]: 'PMs',
  [VendorType.TruckStop]: 'Truck Stop',
  [VendorType.Other]: 'Other'
}


// From common/types-and-constants/src/types/featureFlags.ts
export enum FlagType {
  BOOLEAN = 'boolean',
  PERCENTAGE = 'percentage',
  VARIANT = 'variant'
}

/**
 * How a FeatureFlagAssignment row came to exist. Load-bearing in the evaluator
 * (override vs percentage branching) and in the admin invalidation filters, so
 * it's a shared enum rather than scattered string literals.
 */
export enum AssignmentReason {
  PERCENTAGE = 'percentage',
  MANUAL_OVERRIDE = 'manual_override'
}

export enum RolloutType {
  INSTANT = 'instant',
  GRADUAL = 'gradual',
  SCHEDULED = 'scheduled'
}

export enum TargetType {
  ALL = 'all',
  AFFECTED_USERS = 'affected_users'
}

export enum RolloutScheduleStatus {
  PENDING = 'pending',
  ACTIVE = 'active',
  PAUSED = 'paused',
  COMPLETED = 'completed',
  FAILED = 'failed'
}

export enum PhaseTransitionTrigger {
  SCHEDULED = 'scheduled',
  ROLLBACK = 'rollback',
  EMERGENCY_ABORT = 'emergency_abort'
}

export enum FeatureFlagNotificationEventType {
  APPROVAL_REQUIRED = 'approval_required',
  METRICS_FAILED = 'metrics_failed',
  TRANSITION_COMPLETE = 'transition_complete',
  TRANSITION_FAILED = 'transition_failed',
  ROLLBACK_COMPLETED = 'rollback_completed',
  ROLLOUT_FAILED = 'rollout_failed',
  EMERGENCY_ABORT = 'emergency_abort'
}

export enum FlagErrorType {
  EVALUATION = 'evaluation',
  FEATURE = 'feature'
}

export enum RolloutTerminatedReason {
  COMPLETED = 'completed',
  ROLLBACK = 'rollback',
  EMERGENCY_ABORT = 'emergency_abort',
  FAILED = 'failed'
}

export enum FeatureFlagSignalNames {
  PauseRollout = 'PauseRollout',
  ResumeRollout = 'ResumeRollout',
  ApprovePhase = 'ApprovePhase',
  RollbackPhase = 'RollbackPhase',
  EmergencyAbort = 'EmergencyAbort'
}

export enum SystemAlertSeverity {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  CRITICAL = 'critical'
}

export enum SystemAlertType {
  OUTAGE = 'outage',
  MAINTENANCE = 'maintenance',
  WARNING = 'warning'
}

export interface EvaluationContext {
  customerId?: string
  driverId?: string
  partnerId?: string
  vendorId?: string
  attributes?: Record<string, any>
  environment: 'dev' | 'staging' | 'prod'
}

export interface FlagEvaluation {
  flagKey: string
  value: boolean | string | number
  reason: string
  assignment?: {
    bucket: number
    percentage: number
  }
}

export interface FlagSet {
  [flagKey: string]: boolean | string | number
}

export interface BatchEvaluationRequest {
  flagKeys?: string[]
  context: EvaluationContext
}

export interface BatchEvaluationResponse {
  flags: FlagSet
  evaluations: FlagEvaluation[]
}


// From common/types-and-constants/src/types/internalBankAccounts.ts
export enum BankSponsors {
  bluePenguin = 'blue_penguin'
}


// From common/types-and-constants/src/types/onboardingSteps.ts
export enum OnboardingStepId {
  FINAL_CONSENT = 'final_consent_completed',
  DIRECT_DEPOSIT = 'direct_deposit_verified',
  ASSET_INFO = 'asset_info_added',
  PENSKE_CERTIFICATE_OF_INSURANCE = 'penske_certificate_of_insurance_added',
  DEBIT_CARD = 'physical_debit_card_activated',
  RYDER_CERTIFICATE_OF_INSURANCE = 'ryder_certificate_of_insurance_added'
}

export interface OnboardingStepUI {
  id: OnboardingStepId
  title: string
  description: string
  route: string
  route2?: string
}

export const ONBOARDING_STEPS: OnboardingStepUI[] = [
  {
    id: OnboardingStepId.DIRECT_DEPOSIT,
    title: 'Set Up Direct Deposit',
    description: 'Get paid directly into your TACH account.',
    route: '/dashboard/banking/overview'
  },
  {
    id: OnboardingStepId.ASSET_INFO,
    title: 'Add Asset Info',
    description: 'Provide all of your asset information regarding your trucks and trailers.',
    route: '/dashboard/assets'
  },
  {
    id: OnboardingStepId.PENSKE_CERTIFICATE_OF_INSURANCE,
    title: 'Truck Rental Insurance Certificates',
    description: 'Complete your Penske truck rentals onboarding.',
    route:
      'https://prod-public-images-m6zzcoyk.s3.us-east-2.amazonaws.com/TACH-Penske-Certificate-of-Insurance.pdf'
  },
  {
    id: OnboardingStepId.RYDER_CERTIFICATE_OF_INSURANCE,
    title: 'Ryder certificate of insurance',
    description: 'Complete your Ryder truck rentals onboarding.',
    route:
      'https://prod-public-images-m6zzcoyk.s3.us-east-2.amazonaws.com/TACH-Ryder-Certificate-of-Insurance.pdf',
    route2:
      'https://prod-public-images-m6zzcoyk.s3.us-east-2.amazonaws.com/TACH-Ryder-Certificate-of-Insurance.pdf'
  },
  {
    id: OnboardingStepId.DEBIT_CARD,
    title: 'Activate Debit Card',
    description: 'Activate your physical debit card.',
    route: '/dashboard/banking/overview'
  }
]

export interface OnboardingSteps {
  [OnboardingStepId.FINAL_CONSENT]?: boolean
  [OnboardingStepId.DIRECT_DEPOSIT]?: boolean
  [OnboardingStepId.ASSET_INFO]?: boolean
  [OnboardingStepId.PENSKE_CERTIFICATE_OF_INSURANCE]?: boolean
  [OnboardingStepId.RYDER_CERTIFICATE_OF_INSURANCE]?: boolean
  [OnboardingStepId.DEBIT_CARD]?: boolean
}

// Helper function to check if a step is completed
export const isStepCompleted = (
  steps: OnboardingSteps | undefined,
  stepId: OnboardingStepId
): boolean => {
  if (!steps) return false
  return Boolean(steps[stepId])
}


// From common/types-and-constants/src/types/ownershipStatus.ts
export enum OwnershipStatus {
  Owned = 'owned',
  Leased = 'leased',
  Financing = 'financing'
}

export enum TruckClassCategories {
  HeavyDuty = 'Heavy Duty',
  MediumDuty = 'Medium Duty',
  LightDuty = 'Light Duty'
}

export enum TireBrandQuality {
  Premium = 'premium',
  Budget = 'budget'
}

export enum EngineCondition {
  Unmodified = 'unmodified',
  Rebuilt = 'rebuilt'
}

export enum TruckOutOfServiceReason {
  PreventativeMaintenance = 'preventative_maintenance',
  Repairs = 'repairs',
  SlowBusiness = 'slow_business',
  DriverUnavailable = 'driver_unavailable',
  RegulatoryHold = 'regulatory_hold'
}


// From common/types-and-constants/src/types/pagination.ts
export interface PaginatedRequest {
  limit?: number
  offset?: number
}


// From common/types-and-constants/src/types/partnerAgentInvites.ts
export enum PartnerAgentInviteStatus {
  PENDING = 'pending',
  STARTED_ONBOARDING = 'started_onboarding',
  ACTIVE = 'active',
  CANCELLED = 'cancelled'
}


// From common/types-and-constants/src/types/partnerAgents.ts
export enum PartnerAgentStatus {
  PENDING = 'pending',
  ACTIVE = 'active',
  INACTIVE = 'terminated'
}


// From common/types-and-constants/src/types/partnerSignupSteps.ts
export enum PartnerSignupStep {
  PartnerBusinessInfo = 'partner_business_info',
  PartnerPersonalInfo = 'partner_personal_info',
  PartnerManagementContact = 'partner_management_contact',
  PartnerContract = 'partner_contract',
  PartnerPendingReview = 'partner_pending_review'
}


// From common/types-and-constants/src/types/payments.ts
// This prefix must match as the prefix for all loan-related payment contexts
// Unfortunately can't pass dynamically to PaymentContexts
export const loanRepaymentPrefix = 'loanRepayment'

// This prefix must match as the prefix for all tach-fee-related payment contexts
export const tachFeePrefix = 'tachFee'

export enum PaymentContexts {
  tachFee = 'tachFee',
  tachFeeDeposit = 'tachFee#depositFee',
  tachFeeAppFee = 'tachFee#appFee',
  tachFeeMonthly = 'tachFee#monthlyFee',
  loanRepaymentManual = `loanRepayment#manual`,
  loanRepaymentDD = `loanRepayment#directDeposit`,
  loanRepaymentReserves = `loanRepayment#reserves`,
  grossProfitTransfer = 'grossProfitTransfer',
  withdrawal = 'withdrawal'
}

export const PaymentContextDisplayNames: { [key in PaymentContexts]: string } = {
  [PaymentContexts.tachFee]: 'TACH Fee',
  [PaymentContexts.tachFeeDeposit]: 'TACH Fee',
  [PaymentContexts.tachFeeAppFee]: 'TACH Application Fee',
  [PaymentContexts.tachFeeMonthly]: 'TACH Fee',
  [PaymentContexts.loanRepaymentDD]: 'Cash Advance Repayment',
  [PaymentContexts.loanRepaymentManual]: 'Cash Advance Repayment',
  [PaymentContexts.loanRepaymentReserves]: 'Cash Advance Initial Repayment',
  [PaymentContexts.grossProfitTransfer]: 'Net Take Home Transfer',
  [PaymentContexts.withdrawal]: 'Withdrawal'
}

export function isPaymentContextForATachFee(context: string): boolean {
  return context.startsWith(tachFeePrefix)
}

export enum PaymentStatuses {
  SettledSwept = 'settled#swept',
  InitiatedUnswept = 'initiated#unswept',
  SettledUnswept = 'settled#unswept',
  InitiatedSwept = 'initiated#swept',
  Failed = 'failed'
}

export enum PaymentStatusDisplayNames {
  Processed = 'Processed',
  Initiated = 'Initiated',
  Failed = 'Failed'
}

export const PaymentStatusDisplayNamesMapping: {
  [key in PaymentStatuses]: PaymentStatusDisplayNames
} = {
  [PaymentStatuses.SettledSwept]: PaymentStatusDisplayNames.Processed,
  [PaymentStatuses.InitiatedUnswept]: PaymentStatusDisplayNames.Initiated,
  [PaymentStatuses.SettledUnswept]: PaymentStatusDisplayNames.Processed,
  [PaymentStatuses.InitiatedSwept]: PaymentStatusDisplayNames.Initiated,
  [PaymentStatuses.Failed]: PaymentStatusDisplayNames.Failed
}


// From common/types-and-constants/src/types/pendingTruck.ts


export interface ApprovePendingTruckRequest {
  ownership_status: OwnershipStatus
  starting_mileage: number
  current_mileage: number
  typical_annual_mileage: number
  truck_payment_amount: number
  insurance_payment_amount: number
  truck_class_number: number
  pay_for_repairs: boolean
  tire_brand_quality: TireBrandQuality
  engine_condition: EngineCondition
  truck_display_name?: string
  truck_make?: string
  truck_model?: string
  truck_year?: number
  vehicle_id_number?: string
  // Optional maintenance dates (YYYY-MM-DD), same semantics as create/patch truck.
  date_of_last_pm?: string
  date_of_last_repair?: string
}


// From common/types-and-constants/src/types/presignedUrlObject.ts
export interface PresignedUrlObject {
  fileKey: string
  presignedUrl: string
}


// From common/types-and-constants/src/types/scheduledWithdrawals.ts
// Domain types for scheduled withdrawals (recurring customer-initiated ACH withdrawals).
// These live here — not in rds-utils — because the pure recurrence/memo functions in
// functions/scheduledWithdrawals.ts consume them, and workflow-side Temporal code can only
// import from a package's pure surface. Model-lifecycle enums (status, paused_reason,
// created_by) stay in rds-utils/src/types/scheduledWithdrawals.ts per house convention.
// Design doc: docs/scheduled-withdrawals-feature-spec.md

export enum ScheduledWithdrawalFrequency {
  Daily = 'daily',
  Weekly = 'weekly',
  Biweekly = 'biweekly',
  Monthly = 'monthly'
}

export enum ScheduledWithdrawalAmountType {
  /** Withdraw a configured amount_in_cents (>= the $50 creation-time floor). */
  Fixed = 'fixed',
  /** Withdraw whatever the source bucket holds at execution time (>= the $10 floor). */
  BucketBalance = 'bucket_balance'
}

/**
 * The recurrence definition a schedule row carries. All dates are DATEONLY strings
 * ('YYYY-MM-DD') in the business timezone (Eastern) — occurrences are calendar dates,
 * not times; the sweep supplies the time of day.
 */
export interface ScheduledWithdrawalRecurrence {
  frequency: ScheduledWithdrawalFrequency
  /** ISO weekdays 1–7 (Mon=1). Required non-empty for weekly/biweekly, null otherwise. */
  days_of_week: number[] | null
  /** 1–31; 29–31 clamp to the month's last day. Required for monthly, null otherwise. */
  day_of_month: number | null
  /**
   * The schedule's first occurrence date. Server-validated to satisfy the recurrence
   * (weekday in days_of_week / matches day_of_month modulo clamp), so an off-pattern
   * anchor is impossible. Defines biweekly parity via weeks elapsed since its week —
   * deliberately NOT ISO week number, which breaks at 53-week ISO years (e.g. 2026).
   */
  anchor_date: string
}


// From common/types-and-constants/src/types/timezones.ts
/**
 * US State abbreviation to IANA timezone mapping
 *
 * Used for determining customer local time based on their address state.
 * Some states span multiple timezones - we use the most populous timezone for each.
 *
 * @example
 * const timezone = STATE_TIMEZONE_MAP['TX'] // 'America/Chicago'
 * const localTime = new Date().toLocaleString('en-US', { timeZone: timezone })
 */
export const STATE_TIMEZONE_MAP: Record<string, string> = {
  // Eastern Time Zone (UTC-5/-4)
  CT: 'America/New_York',
  DE: 'America/New_York',
  FL: 'America/New_York', // Most of FL is Eastern
  GA: 'America/New_York',
  IN: 'America/Indiana/Indianapolis',
  KY: 'America/Kentucky/Louisville', // Most of KY is Eastern
  MA: 'America/New_York',
  MD: 'America/New_York',
  ME: 'America/New_York',
  MI: 'America/Detroit',
  NC: 'America/New_York',
  NH: 'America/New_York',
  NJ: 'America/New_York',
  NY: 'America/New_York',
  OH: 'America/New_York',
  PA: 'America/New_York',
  RI: 'America/New_York',
  SC: 'America/New_York',
  VA: 'America/New_York',
  VT: 'America/New_York',
  WV: 'America/New_York',
  DC: 'America/New_York',

  // Central Time Zone (UTC-6/-5)
  AL: 'America/Chicago',
  AR: 'America/Chicago',
  IA: 'America/Chicago',
  IL: 'America/Chicago',
  KS: 'America/Chicago', // Most of KS is Central
  LA: 'America/Chicago',
  MN: 'America/Chicago',
  MO: 'America/Chicago',
  MS: 'America/Chicago',
  ND: 'America/Chicago', // Most of ND is Central
  NE: 'America/Chicago', // Most of NE is Central
  OK: 'America/Chicago',
  SD: 'America/Chicago', // Most of SD is Central
  TN: 'America/Chicago', // Most of TN is Central
  TX: 'America/Chicago', // Most of TX is Central
  WI: 'America/Chicago',

  // Mountain Time Zone (UTC-7/-6)
  AZ: 'America/Phoenix', // No DST in most of AZ
  CO: 'America/Denver',
  ID: 'America/Boise', // Most of ID is Mountain
  MT: 'America/Denver',
  NM: 'America/Denver',
  UT: 'America/Denver',
  WY: 'America/Denver',

  // Pacific Time Zone (UTC-8/-7)
  CA: 'America/Los_Angeles',
  NV: 'America/Los_Angeles',
  OR: 'America/Los_Angeles', // Most of OR is Pacific
  WA: 'America/Los_Angeles',

  // Alaska Time Zone (UTC-9/-8)
  AK: 'America/Anchorage',

  // Hawaii-Aleutian Time Zone (UTC-10)
  HI: 'Pacific/Honolulu'
} as const

/**
 * Default timezone when customer's state is unknown or not in the US
 * Central time is a reasonable middle-ground for US trucking operations
 */
export const DEFAULT_TIMEZONE = 'America/Chicago'

/**
 * Gets the IANA timezone for a US state abbreviation
 *
 * @param stateAbbreviation - Two-letter US state code (e.g., 'TX', 'CA')
 * @returns IANA timezone identifier, or DEFAULT_TIMEZONE if state not found
 *
 * @example
 * getTimezoneForState('TX') // 'America/Chicago'
 * getTimezoneForState(null) // 'America/Chicago' (default)
 * getTimezoneForState('XX') // 'America/Chicago' (unknown state)
 */
export function getTimezoneForState(stateAbbreviation: string | null | undefined): string {
  if (!stateAbbreviation) {
    return DEFAULT_TIMEZONE
  }
  return STATE_TIMEZONE_MAP[stateAbbreviation.toUpperCase()] || DEFAULT_TIMEZONE
}

/**
 * Checks if a given hour is within business hours in a specific timezone
 *
 * @param timezone - IANA timezone identifier
 * @param startHour - Business hours start (0-23), default 9 (9am)
 * @param endHour - Business hours end (0-23), default 19 (7pm)
 * @returns true if current time is within business hours
 */
export function isWithinBusinessHours(
  timezone: string,
  startHour: number = 9,
  endHour: number = 19
): boolean {
  const now = new Date()
  const localTimeStr = now.toLocaleString('en-US', {
    timeZone: timezone,
    hour: 'numeric',
    hour12: false
  })
  const hour = parseInt(localTimeStr, 10)
  return hour >= startHour && hour < endHour
}

/**
 * Gets the next business hours start time in a specific timezone
 *
 * If currently within business hours, returns the current time.
 * Otherwise, returns the next 9am in that timezone.
 *
 * @param timezone - IANA timezone identifier
 * @param startHour - Business hours start (0-23), default 9 (9am)
 * @param endHour - Business hours end (0-23), default 19 (7pm)
 * @returns Date object for when business hours next begin
 */
export function getNextBusinessHoursStart(
  timezone: string,
  startHour: number = 9,
  endHour: number = 19
): Date {
  const now = new Date()

  // Get current time in the target timezone
  const options: Intl.DateTimeFormatOptions = {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }

  const localTimeStr = now.toLocaleString('en-US', options)
  const [datePart, timePart] = localTimeStr.split(', ')
  const [month, day, year] = datePart.split('/')
  const [hour, minute] = timePart.split(':')

  const currentHour = parseInt(hour, 10)

  // If within business hours, return now
  if (currentHour >= startHour && currentHour < endHour) {
    return now
  }

  // Calculate next business hours start
  const nextStart = new Date(now)

  if (currentHour >= endHour) {
    // After business hours today, schedule for tomorrow
    nextStart.setDate(nextStart.getDate() + 1)
  }

  // Set to start hour in the target timezone
  // This is approximate - for precise scheduling, use a proper timezone library
  const hourDiff = startHour - currentHour
  nextStart.setHours(nextStart.getHours() + hourDiff)
  nextStart.setMinutes(0, 0, 0)

  return nextStart
}


// From common/types-and-constants/src/types/vendorSignupSteps.ts
export enum VendorSignupStep {
  VendorBusinessInfo = 'vendor_business_info',
  VendorPersonalInfo = 'vendor_personal_info',
  VendorManagementContact = 'vendor_management_contact',
  VendorPendingReview = 'vendor_pending_review'
}


// From common/rds-utils/src/types/address.ts
/**
 * Event types for addresses
 */
export enum AddressEventCreatedBy {
  ADMIN_PORTAL = 'admin_portal'
}

export enum AddressEventSubtype {
  SET_PRIMARY = 'set_primary'
}


// From common/rds-utils/src/types/applications.ts
export interface ApplicationAssetSummary {
  num_trucks: number
  num_trailers: number
  has_old_or_high_mileage_trucks: boolean
  num_old_or_high_mileage_trucks: number
  has_inactive_or_reserve_trucks: boolean
  num_inactive_or_reserve_trucks: number
}

// From common/rds-utils/src/types/assets.ts
// TODO: AssetType = 'truck' | 'trailer'


// From common/rds-utils/src/types/budgetAllocations.ts
/**
 * Why a budget allocation exists.
 *
 * Stored as a plain STRING on `BudgetAllocations.reason` and enforced here rather than as a
 * Postgres enum type, matching `category` on the same table. Every allocation must declare one —
 * that is the whole point of the column, since a transaction-less allocation would otherwise be
 * indistinguishable from a stray write.
 */
export enum BudgetAllocationReason {
  /** Driven by a real transaction through the deposit or expense waterfall. Has a transaction_id. */
  Waterfall = 'waterfall',
  /** Redistribution of a deleted custom bucket's balance across the remaining buckets. */
  CustomBucketDeleted = 'custom_bucket_deleted',
  /**
   * An admin turning a bucket off, its balance swept through the other buckets — written by the
   * disable workflow (setBudgetBucketAdminOverride), carrying the audit Event in source_event_id.
   */
  AdminReallocation = 'admin_reallocation',
  /**
   * A rewind's residue on a disabled bucket, re-homed through the enabled ones — written by the
   * expense waterfall's rewind redirect (`redirectDisabledBucketRollbacks`). Positive rows are
   * credits a disabled bucket may not receive; negative rows collect the part of a rewind debit
   * its emptied holdings could not cover. Always DETACHED
   * (`transaction_id: null`), never carrying the originating transaction_id: a transaction's
   * allocations are fetched by transaction_id and consumed under the identity
   * `sum(allocations) === transaction.amount` (the next recategorization's rewind, settlement
   * adjustment weighting), and a redirect row inside that set breaks the sum and double-counts
   * the expense on the next rewind.
   */
  DisabledBucketRedirect = 'disabled_bucket_redirect'
}


// From common/rds-utils/src/types/budgetItems.ts


/**
 * Which columns a given write path is allowed to touch on `BudgetItems`.
 *
 * `saveBudgetItemToDB` is a find-or-update helper shared by two callers that mutate completely
 * different things, and it used to persist whatever the caller happened to be carrying. Since
 * every caller reads a full row, holds it across activity boundaries, and writes it back, any
 * column changed by someone else in the meantime was silently reverted — the balance paths would
 * undo a recompute, and both would undo an admin override.
 *
 * Passing one of these to Sequelize's `update(values, { fields })` keeps the other columns out of
 * the generated statement entirely, so a stale payload becomes inert rather than destructive.
 * Required at the call site on purpose: a default of "write everything" is what caused the bug,
 * and a new writer should have to say what it writes.
 */
export const BUDGET_ITEM_BALANCE_FIELDS: (keyof BudgetItem)[] = ['amount']

export const BUDGET_ITEM_RECOMPUTE_FIELDS: (keyof BudgetItem)[] = [
  'category_display_name',
  'system_recommended_amount',
  'system_recommended_amount_last_updated',
  'time_window_in_months',
  'emoji_unicode'
]

/**
 * The admin override columns. Separate from the two sets above because nothing else may write them:
 * the balance paths own `amount`, the recompute owns the system recommendation, and only an
 * explicit admin action touches these. Keeping them in their own set is what stops a waterfall or a
 * recompute reverting an override it never meant to touch.
 */
export const BUDGET_ITEM_ADMIN_OVERRIDE_FIELDS: (keyof BudgetItem)[] = [
  'admin_bucket_enabled',
  'admin_scale_bps',
  'admin_override_updated_at',
  'admin_override_updated_by'
]


// From common/rds-utils/src/types/cashAdvance.ts
export enum CashAdvanceMinHistoryDays {
  THIRTY_DAYS = 'THIRTY_DAYS',
  SIXTY_DAYS = 'SIXTY_DAYS',
  NINETY_DAYS = 'NINETY_DAYS',
  ONE_EIGHTY_DAYS = 'ONE_EIGHTY_DAYS',
  THREE_SIXTY_FIVE_DAYS = 'THREE_SIXTY_FIVE_DAYS'
}

export const CASH_ADVANCE_MIN_HISTORY_DAYS_TO_INT: Record<CashAdvanceMinHistoryDays, number> = {
  [CashAdvanceMinHistoryDays.THIRTY_DAYS]: 30,
  [CashAdvanceMinHistoryDays.SIXTY_DAYS]: 60,
  [CashAdvanceMinHistoryDays.NINETY_DAYS]: 90,
  [CashAdvanceMinHistoryDays.ONE_EIGHTY_DAYS]: 180,
  [CashAdvanceMinHistoryDays.THREE_SIXTY_FIVE_DAYS]: 365
}


// From common/rds-utils/src/types/debitCard.ts
/**
 * Event types for debit cards
 */
export enum DebitCardEventCreatedBy {
  ADMIN_PORTAL = 'admin_portal'
}

export enum DebitCardEventSubtype {
  FROZEN = 'frozen',
  UNFROZEN = 'unfrozen',
  CANCELLED = 'cancelled',
  ORDERED = 'ordered',
  ACTIVATED = 'activated',
  CONTROLS = 'controls'
}


// From common/rds-utils/src/types/depositInvoices.ts
/**
 * Deposit invoice types and enums
 */

/**
 * Event subtypes for deposit invoice events
 */
export enum DepositInvoiceEventSubtype {
  VIEWED = 'invoice_viewed',
  UNMARKED = 'invoice_unmarked'
}

/**
 * Who created the deposit invoice event
 */
export enum DepositInvoiceEventCreatedBy {
  ADMIN_PORTAL = 'admin_portal',
  SYSTEM = 'system'
}


// From common/rds-utils/src/types/documentRequests.ts
/**
 * Document request types and configurations for TACH applications
 */

/**
 * Enum representing all possible document types that can be requested from customers
 */
export enum DocumentRequestType {
  // Existing TACH document types
  INSURANCE = 'insurance',
  REVENUE = 'revenue',

  // Sila KYC document types
  BANK_STATEMENT = 'bank_statement',
  DDA = 'dda',
  DOC_ARTICLES_OF_INC = 'doc_articles_of_inc',
  // DOC_BANK_STATEMENT = 'doc_bank_statement', // duplicate of BANK_STATEMENT
  DOC_BUSINESS_LICENSE = 'doc_business_license',
  DOC_CERT_OF_FORMATION = 'doc_cert_of_formation',
  DOC_CERT_OF_GOOD_STANDING = 'doc_cert_of_good_standing',
  DOC_CREDIT_CARD_STATEMENT = 'doc_credit_card_statement',
  DOC_EIN_VERIFICATION = 'doc_ein_verification',
  DOC_GREEN_CARD = 'doc_green_card',
  DOC_LEASE = 'doc_lease',
  DOC_MORTGAGE = 'doc_mortgage',
  DOC_NAME_CHANGE = 'doc_name_change',
  DOC_PAYSTUB = 'doc_paystub',
  DOC_SSA = 'doc_ssa',
  DOC_SS_CARD = 'doc_ss_card',
  DOC_TAX_RETURN = 'doc_tax_return',
  DOC_TAX_SS4 = 'doc_tax_ss4',
  DOC_TAX_W9 = 'doc_tax_w9',
  DOC_TUITION = 'doc_tuition',
  DOC_UO_BENEFITS = 'doc_uo_benefits',
  DOC_UTILITY = 'doc_utility',
  FUNDS_FLOWS = 'funds_flows',
  ID_DRIVERS_LICENSE = 'id_drivers_license',
  ID_DRIVERS_PERMIT = 'id_drivers_permit',
  ID_MILITARY = 'id_military',
  ID_MILITARY_DEPENDENT = 'id_military_dependent',
  ID_NYC_ID = 'id_nyc_id',
  ID_PASSPORT = 'id_passport',
  ID_PASSPORT_CARD = 'id_passport_card',
  ID_SELFIE = 'id_selfie',
  ID_STATE = 'id_state',
  ID_TRIBAL = 'id_tribal',
  OTHER_DOC = 'other_doc',
  OTHER_ID = 'other_id',
  TAX_1040 = 'tax_1040',
  TAX_1095 = 'tax_1095',
  TAX_1099 = 'tax_1099',
  TAX_W2 = 'tax_w2',
  TAX_W4 = 'tax_W4',
  VERIFICATION_LETTER = 'verification_letter',
  VTL_BIRTH_CERTIFICATE = 'vtl_birth_certificate',
  VTL_DIVORCE = 'vtl_divorce',
  VTL_MARRIAGE = 'vtl_marriage'
}

/**
 * Interface defining the structure of a document requirement
 */
export interface DocumentRequirement {
  type: DocumentRequestType
  displayName: string
  description: string
  bulletPoints: string[]
  uploadPath: string // S3 path template, e.g., 'insuranceVerification' or 'revenueVerification'
  category: DocumentCategory
}

/**
 * Categories for grouping related document types
 */
export enum DocumentCategory {
  INSURANCE = 'Insurance Documentation',
  FINANCIAL = 'Financial Documentation',
  BUSINESS = 'Business Documentation',
  VEHICLE = 'Vehicle Documentation',
  COMPLIANCE = 'Compliance Documentation',
  IDENTITY = 'Identity Verification',
  TAX = 'Tax Documentation',
  LEGAL = 'Legal Documentation',
  PROOF_OF_RESIDENCE = 'Proof of Residence',
  OTHER = 'Other Documentation'
}

/**
 * Complete mapping of all document requirements with their details
 */
export const DOCUMENT_REQUIREMENTS: Record<DocumentRequestType, DocumentRequirement> = {
  // General
  [DocumentRequestType.INSURANCE]: {
    type: DocumentRequestType.INSURANCE,
    displayName: 'Insurance Documentation',
    description: 'Proof of active insurance coverage',
    bulletPoints: [
      'Proof of active insurance policies',
      'Include cargo liability coverage details',
      'Include automobile liability coverage details'
    ],
    uploadPath: 'insuranceVerification',
    category: DocumentCategory.INSURANCE
  },
  [DocumentRequestType.REVENUE]: {
    type: DocumentRequestType.REVENUE,
    displayName: 'Revenue Verification',
    description: 'Documentation to verify business revenue',
    bulletPoints: [
      'Most recent 3-6 months of business bank statements',
      'Must clearly show business name and revenue'
    ],
    uploadPath: 'revenueVerification',
    category: DocumentCategory.FINANCIAL
  },

  // Financial Documents
  [DocumentRequestType.BANK_STATEMENT]: {
    type: DocumentRequestType.BANK_STATEMENT,
    displayName: 'Bank Statement',
    description: '3-6 months of bank account statements',
    bulletPoints: [
      'Most recent 3-6 months of bank statements',
      'Statements must be from the operating / revenue account',
      'Must clearly show account holder name and account number'
    ],
    uploadPath: 'kycDocuments/bankStatement',
    category: DocumentCategory.FINANCIAL
  },
  // [DocumentRequestType.DOC_BANK_STATEMENT]: {
  //   type: DocumentRequestType.DOC_BANK_STATEMENT,
  //   displayName: 'Bank Statement',
  //   description: 'Bank account documentation',
  //   bulletPoints: [
  //     'Recent bank statements (within last 3 months)',
  //     'Must show full account details'
  //   ],
  //   uploadPath: 'kycDocuments/docBankStatement',
  //   category: DocumentCategory.FINANCIAL
  // },
  [DocumentRequestType.DOC_CREDIT_CARD_STATEMENT]: {
    type: DocumentRequestType.DOC_CREDIT_CARD_STATEMENT,
    displayName: 'Credit Card Statement',
    description: 'Credit card account statement',
    bulletPoints: ['Recent credit card statement', 'Must show cardholder name'],
    uploadPath: 'kycDocuments/creditCardStatement',
    category: DocumentCategory.FINANCIAL
  },
  [DocumentRequestType.DDA]: {
    type: DocumentRequestType.DDA,
    displayName: 'Signed Demand Deposit Agreement',
    description: 'Bank account agreement documentation',
    bulletPoints: [
      'Signed demand deposit agreement from your bank',
      'Must include all signature pages',
      'Should show account terms and conditions'
    ],
    uploadPath: 'kycDocuments/dda',
    category: DocumentCategory.FINANCIAL
  },
  [DocumentRequestType.FUNDS_FLOWS]: {
    type: DocumentRequestType.FUNDS_FLOWS,
    displayName: 'Funds Flows',
    description: 'Documentation of fund sources and movements',
    bulletPoints: [
      'Documentation showing source of funds',
      'Transaction history or wire transfer records',
      'May include bank statements or investment account statements'
    ],
    uploadPath: 'kycDocuments/fundsFlows',
    category: DocumentCategory.FINANCIAL
  },
  [DocumentRequestType.VERIFICATION_LETTER]: {
    type: DocumentRequestType.VERIFICATION_LETTER,
    displayName: 'Account Verification Letter',
    description: 'Official bank account verification',
    bulletPoints: [
      'Letter from bank confirming account ownership',
      'Must be on bank letterhead with full account details'
    ],
    uploadPath: 'kycDocuments/verificationLetter',
    category: DocumentCategory.FINANCIAL
  },

  // Business Documents
  [DocumentRequestType.DOC_ARTICLES_OF_INC]: {
    type: DocumentRequestType.DOC_ARTICLES_OF_INC,
    displayName: 'Articles of Incorporation',
    description: 'Business formation documents',
    bulletPoints: [
      'Filed articles of incorporation',
      'Must be stamped/certified by state',
      'Include any amendments or restatements'
    ],
    uploadPath: 'kycDocuments/articlesOfInc',
    category: DocumentCategory.BUSINESS
  },
  [DocumentRequestType.DOC_BUSINESS_LICENSE]: {
    type: DocumentRequestType.DOC_BUSINESS_LICENSE,
    displayName: 'Business License',
    description: 'Current business operating license',
    bulletPoints: ['Current and valid business license', 'Must show business name and address'],
    uploadPath: 'kycDocuments/businessLicense',
    category: DocumentCategory.BUSINESS
  },
  [DocumentRequestType.DOC_CERT_OF_FORMATION]: {
    type: DocumentRequestType.DOC_CERT_OF_FORMATION,
    displayName: 'Certificate of Formation',
    description: 'Business formation document',
    bulletPoints: ['Certificate of formation for your business', 'Must be filed with state'],
    uploadPath: 'kycDocuments/certOfFormation',
    category: DocumentCategory.BUSINESS
  },
  [DocumentRequestType.DOC_CERT_OF_GOOD_STANDING]: {
    type: DocumentRequestType.DOC_CERT_OF_GOOD_STANDING,
    displayName: 'Certificate of Good Standing',
    description: 'Business status verification',
    bulletPoints: [
      'Recent certificate of good standing from state',
      'Must be dated within last 90 days'
    ],
    uploadPath: 'kycDocuments/certOfGoodStanding',
    category: DocumentCategory.BUSINESS
  },
  [DocumentRequestType.DOC_EIN_VERIFICATION]: {
    type: DocumentRequestType.DOC_EIN_VERIFICATION,
    displayName: 'IRS EIN Verification Letter',
    description: 'Federal tax ID documentation',
    bulletPoints: [
      'IRS EIN assignment letter (CP 575)',
      'Must show business name and EIN',
      'SS-4 confirmation acceptable if CP 575 unavailable'
    ],
    uploadPath: 'kycDocuments/einVerification',
    category: DocumentCategory.BUSINESS
  },

  // Tax Documents
  [DocumentRequestType.DOC_TAX_RETURN]: {
    type: DocumentRequestType.DOC_TAX_RETURN,
    displayName: 'IRS Tax Return',
    description: 'Filed tax return documentation',
    bulletPoints: [
      'Complete tax return for most recent year',
      'Include all schedules and forms',
      'Must be signed and dated'
    ],
    uploadPath: 'kycDocuments/taxReturn',
    category: DocumentCategory.TAX
  },
  [DocumentRequestType.DOC_TAX_SS4]: {
    type: DocumentRequestType.DOC_TAX_SS4,
    displayName: 'IRS Form SS-4',
    description: 'EIN application form',
    bulletPoints: [
      'Completed Form SS-4',
      'Application for Employer Identification Number',
      'Must match business information on file'
    ],
    uploadPath: 'kycDocuments/taxSS4',
    category: DocumentCategory.TAX
  },
  [DocumentRequestType.DOC_TAX_W9]: {
    type: DocumentRequestType.DOC_TAX_W9,
    displayName: 'IRS Form W9',
    description: 'Tax identification certification',
    bulletPoints: ['Completed and signed W-9 form'],
    uploadPath: 'kycDocuments/taxW9',
    category: DocumentCategory.TAX
  },
  [DocumentRequestType.TAX_1040]: {
    type: DocumentRequestType.TAX_1040,
    displayName: '1040 Tax Return',
    description: 'Personal income tax return',
    bulletPoints: [
      'Complete Form 1040 for most recent tax year',
      'Include all schedules and attachments',
      'Must be signed and show filing status'
    ],
    uploadPath: 'kycDocuments/tax1040',
    category: DocumentCategory.TAX
  },
  [DocumentRequestType.TAX_1095]: {
    type: DocumentRequestType.TAX_1095,
    displayName: 'Tax Form 1095',
    description: 'Health coverage tax form',
    bulletPoints: [
      'Form 1095-A, 1095-B, or 1095-C',
      'Health Insurance Marketplace Statement',
      'Shows proof of health coverage'
    ],
    uploadPath: 'kycDocuments/tax1095',
    category: DocumentCategory.TAX
  },
  [DocumentRequestType.TAX_1099]: {
    type: DocumentRequestType.TAX_1099,
    displayName: 'Tax Form 1099',
    description: 'Income reporting form',
    bulletPoints: [
      'Most recent 1099 forms received',
      'Shows miscellaneous income',
      'Include 1099-MISC, 1099-NEC, or other variants'
    ],
    uploadPath: 'kycDocuments/tax1099',
    category: DocumentCategory.TAX
  },
  [DocumentRequestType.TAX_W2]: {
    type: DocumentRequestType.TAX_W2,
    displayName: 'IRS Form W2',
    description: 'Wage and tax statement',
    bulletPoints: [
      'Most recent W-2 form',
      'Shows wages and tax withholdings',
      'Must include all copies received'
    ],
    uploadPath: 'kycDocuments/taxW2',
    category: DocumentCategory.TAX
  },
  [DocumentRequestType.TAX_W4]: {
    type: DocumentRequestType.TAX_W4,
    displayName: 'W4 Withholding Allowance Certificate',
    description: 'Employee withholding certificate',
    bulletPoints: ['Completed Form W-4', "Employee's Withholding Certificate"],
    uploadPath: 'kycDocuments/taxW4',
    category: DocumentCategory.TAX
  },

  // Identity Documents
  [DocumentRequestType.ID_DRIVERS_LICENSE]: {
    type: DocumentRequestType.ID_DRIVERS_LICENSE,
    displayName: "State-issued Driver's License",
    description: "Valid driver's license for identity verification",
    bulletPoints: [
      "Current, valid driver's license",
      'Front and back of license required',
      'Must be clearly readable with no obstructions'
    ],
    uploadPath: 'kycDocuments/driversLicense',
    category: DocumentCategory.IDENTITY
  },
  [DocumentRequestType.ID_DRIVERS_PERMIT]: {
    type: DocumentRequestType.ID_DRIVERS_PERMIT,
    displayName: "Driver's Permit",
    description: "Learner's permit for identity verification",
    bulletPoints: [
      "Valid driver's permit",
      'Both sides of permit required',
      'Must show full name and date of birth'
    ],
    uploadPath: 'kycDocuments/driversPermit',
    category: DocumentCategory.IDENTITY
  },
  [DocumentRequestType.ID_MILITARY]: {
    type: DocumentRequestType.ID_MILITARY,
    displayName: 'Military ID',
    description: 'Active military identification',
    bulletPoints: [
      'Current military ID card',
      'Front and back required',
      'Common Access Card (CAC) accepted'
    ],
    uploadPath: 'kycDocuments/militaryId',
    category: DocumentCategory.IDENTITY
  },
  [DocumentRequestType.ID_MILITARY_DEPENDENT]: {
    type: DocumentRequestType.ID_MILITARY_DEPENDENT,
    displayName: "Military Dependent's ID Card",
    description: 'ID for military family members',
    bulletPoints: [
      'Valid military dependent ID',
      'Both sides of card required',
      'Must be current and not expired'
    ],
    uploadPath: 'kycDocuments/militaryDependentId',
    category: DocumentCategory.IDENTITY
  },
  [DocumentRequestType.ID_NYC_ID]: {
    type: DocumentRequestType.ID_NYC_ID,
    displayName: 'NYC ID Card',
    description: 'New York City municipal ID',
    bulletPoints: ['Valid NYC ID card', 'Front and back required', 'Must be current'],
    uploadPath: 'kycDocuments/nycId',
    category: DocumentCategory.IDENTITY
  },
  [DocumentRequestType.ID_PASSPORT]: {
    type: DocumentRequestType.ID_PASSPORT,
    displayName: 'Passport',
    description: 'Valid passport for identity verification',
    bulletPoints: [
      'Photo page of passport',
      'Must be valid (not expired)',
      'Signature page if separate'
    ],
    uploadPath: 'kycDocuments/passport',
    category: DocumentCategory.IDENTITY
  },
  [DocumentRequestType.ID_PASSPORT_CARD]: {
    type: DocumentRequestType.ID_PASSPORT_CARD,
    displayName: 'US Passport Card',
    description: 'Passport card for identity verification',
    bulletPoints: [
      'Front and back of passport card',
      'Must be valid and not expired',
      'US passport cards only'
    ],
    uploadPath: 'kycDocuments/passportCard',
    category: DocumentCategory.IDENTITY
  },
  [DocumentRequestType.ID_SELFIE]: {
    type: DocumentRequestType.ID_SELFIE,
    displayName: 'ID Selfie',
    description: 'Photo for identity verification',
    bulletPoints: ['Clear photo of your face', 'Well-lit with no obstructions'],
    uploadPath: 'kycDocuments/selfie',
    category: DocumentCategory.IDENTITY
  },
  [DocumentRequestType.ID_STATE]: {
    type: DocumentRequestType.ID_STATE,
    displayName: 'State ID Card',
    description: 'State-issued identification card',
    bulletPoints: [
      'Valid state-issued ID card',
      'Front and back required',
      'Must be current and clearly readable'
    ],
    uploadPath: 'kycDocuments/stateId',
    category: DocumentCategory.IDENTITY
  },
  [DocumentRequestType.ID_TRIBAL]: {
    type: DocumentRequestType.ID_TRIBAL,
    displayName: 'Tribal ID',
    description: 'Tribal government issued ID',
    bulletPoints: [
      'Valid tribal identification',
      'Must be government-issued',
      'Include both sides if applicable'
    ],
    uploadPath: 'kycDocuments/tribalId',
    category: DocumentCategory.IDENTITY
  },
  [DocumentRequestType.OTHER_ID]: {
    type: DocumentRequestType.OTHER_ID,
    displayName: 'Other ID',
    description: 'Alternative form of identification',
    bulletPoints: [
      'Government-issued identification',
      'Must show name and photo',
      'Contact TACH support if unsure about acceptability'
    ],
    uploadPath: 'kycDocuments/otherId',
    category: DocumentCategory.IDENTITY
  },
  [DocumentRequestType.DOC_GREEN_CARD]: {
    type: DocumentRequestType.DOC_GREEN_CARD,
    displayName: 'Permanent Resident Card (Green Card)',
    description: 'US permanent residency documentation',
    bulletPoints: [
      'Front and back of green card',
      'Must be valid and not expired',
      'Ensure all information is clearly visible'
    ],
    uploadPath: 'kycDocuments/greenCard',
    category: DocumentCategory.IDENTITY
  },
  [DocumentRequestType.DOC_SS_CARD]: {
    type: DocumentRequestType.DOC_SS_CARD,
    displayName: 'Social Security Card',
    description: 'Social Security identification',
    bulletPoints: [
      'Clear image of Social Security card',
      'Must show full name and SSN',
      'Ensure card is not damaged or altered'
    ],
    uploadPath: 'kycDocuments/ssCard',
    category: DocumentCategory.IDENTITY
  },

  // Legal Documents
  [DocumentRequestType.DOC_NAME_CHANGE]: {
    type: DocumentRequestType.DOC_NAME_CHANGE,
    displayName: 'Court Order for Name Change',
    description: 'Legal name change documentation',
    bulletPoints: [
      'Court-issued name change order',
      "Must include judge's signature and court seal",
      'All pages of the order required'
    ],
    uploadPath: 'kycDocuments/nameChange',
    category: DocumentCategory.LEGAL
  },
  [DocumentRequestType.VTL_BIRTH_CERTIFICATE]: {
    type: DocumentRequestType.VTL_BIRTH_CERTIFICATE,
    displayName: 'Birth Certificate',
    description: 'Official birth record',
    bulletPoints: [
      'Certified copy of birth certificate',
      'Must include raised seal or stamp',
      'Hospital certificates not accepted'
    ],
    uploadPath: 'kycDocuments/birthCertificate',
    category: DocumentCategory.LEGAL
  },
  [DocumentRequestType.VTL_DIVORCE]: {
    type: DocumentRequestType.VTL_DIVORCE,
    displayName: 'Divorce Decree',
    description: 'Legal divorce documentation',
    bulletPoints: [
      'Final divorce decree',
      'Must include court seal and judge signature',
      'Include all pages'
    ],
    uploadPath: 'kycDocuments/divorceDecree',
    category: DocumentCategory.LEGAL
  },
  [DocumentRequestType.VTL_MARRIAGE]: {
    type: DocumentRequestType.VTL_MARRIAGE,
    displayName: 'Marriage Certificate',
    description: 'Official marriage record',
    bulletPoints: [
      'Certified copy of marriage certificate',
      'Must include official seal or stamp',
      'Not a commemorative certificate'
    ],
    uploadPath: 'kycDocuments/marriageCertificate',
    category: DocumentCategory.LEGAL
  },

  // Proof of Residence Documents
  [DocumentRequestType.DOC_LEASE]: {
    type: DocumentRequestType.DOC_LEASE,
    displayName: 'Lease Agreement',
    description: 'Residential lease documentation',
    bulletPoints: [
      'Current signed lease agreement',
      'Must show your name and address',
      'Include signature pages'
    ],
    uploadPath: 'kycDocuments/lease',
    category: DocumentCategory.PROOF_OF_RESIDENCE
  },
  [DocumentRequestType.DOC_MORTGAGE]: {
    type: DocumentRequestType.DOC_MORTGAGE,
    displayName: 'Mortgage Agreement',
    description: 'Home loan documentation',
    bulletPoints: [
      'Current mortgage statement or agreement',
      'Must show property address and your name',
      'Recent statement preferred'
    ],
    uploadPath: 'kycDocuments/mortgage',
    category: DocumentCategory.PROOF_OF_RESIDENCE
  },
  [DocumentRequestType.DOC_UTILITY]: {
    type: DocumentRequestType.DOC_UTILITY,
    displayName: 'Utility Bill',
    description: 'Proof of residence via utility service',
    bulletPoints: [
      'Recent utility bill (within 60 days)',
      'Electric, gas, water, or internet accepted',
      'Must show service address and your name'
    ],
    uploadPath: 'kycDocuments/utilityBill',
    category: DocumentCategory.PROOF_OF_RESIDENCE
  },

  // Other Documents
  [DocumentRequestType.DOC_PAYSTUB]: {
    type: DocumentRequestType.DOC_PAYSTUB,
    displayName: 'Pay Stub Documentation',
    description: 'Employment income verification',
    bulletPoints: [
      'Recent pay stubs (last 2-3)',
      'Must show employer name and your details',
      'Should have year-to-date totals'
    ],
    uploadPath: 'kycDocuments/paystub',
    category: DocumentCategory.OTHER
  },
  [DocumentRequestType.DOC_SSA]: {
    type: DocumentRequestType.DOC_SSA,
    displayName: 'Social Security Administration Documentation',
    description: 'SSA benefits or statements',
    bulletPoints: [
      'Social Security benefit statement',
      'SSA-1099 or SSA-1042S forms',
      'Includes Form 4029 if applicable'
    ],
    uploadPath: 'kycDocuments/ssaDoc',
    category: DocumentCategory.OTHER
  },
  [DocumentRequestType.DOC_TUITION]: {
    type: DocumentRequestType.DOC_TUITION,
    displayName: 'Tuition Statement',
    description: 'Educational expense documentation',
    bulletPoints: [
      'Official tuition statement from institution',
      'Must show student name and amounts'
    ],
    uploadPath: 'kycDocuments/tuition',
    category: DocumentCategory.OTHER
  },
  [DocumentRequestType.DOC_UO_BENEFITS]: {
    type: DocumentRequestType.DOC_UO_BENEFITS,
    displayName: 'Unemployment Benefits Letter',
    description: 'Unemployment compensation documentation',
    bulletPoints: [
      'Official benefits determination letter',
      'Shows benefit amount and duration',
      'Must be from state unemployment office'
    ],
    uploadPath: 'kycDocuments/unemploymentBenefits',
    category: DocumentCategory.OTHER
  },
  // HUH? No clue when Sila uses this
  [DocumentRequestType.OTHER_DOC]: {
    type: DocumentRequestType.OTHER_DOC,
    displayName: 'Other Document',
    description: 'Additional supporting documentation',
    bulletPoints: [
      'Any other requested documentation',
      'Must be official and current',
      'Contact TACH support for specific requirements'
    ],
    uploadPath: 'kycDocuments/otherDoc',
    category: DocumentCategory.OTHER
  }
}

/**
 * Document request status enum
 */
export enum DocumentRequestStatus {
  PENDING = 'pending',
  SUBMITTED = 'submitted',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  CANCELLED = 'cancelled',
  RE_REQUESTED = 're_requested'
}

/**
 * Document rejection reasons
 */
export enum DocumentRejectionReason {
  ILLEGIBLE = 'illegible',
  INCORRECT_DOCUMENT = 'incorrect_document',
  EXPIRED = 'expired',
  INCOMPLETE = 'incomplete',
  WRONG_ENTITY = 'wrong_entity',
  ALTERED_DOCUMENT = 'altered_document',
  OTHER = 'other'
}

export const DOCUMENT_REJECTION_REASONS_DISPLAY_NAMES: Record<DocumentRejectionReason, string> = {
  [DocumentRejectionReason.ILLEGIBLE]: 'Illegible Document',
  [DocumentRejectionReason.INCORRECT_DOCUMENT]: 'Incorrect Document',
  [DocumentRejectionReason.EXPIRED]: 'Expired Document',
  [DocumentRejectionReason.INCOMPLETE]: 'Incomplete Document',
  [DocumentRejectionReason.WRONG_ENTITY]: 'Wrong Entity',
  [DocumentRejectionReason.ALTERED_DOCUMENT]: 'Altered Document',
  [DocumentRejectionReason.OTHER]: 'Other'
}

/**
 * Rejection reason details for email formatting
 */
export const REJECTION_REASON_DETAILS: Record<DocumentRejectionReason, string[]> = {
  [DocumentRejectionReason.ILLEGIBLE]: [
    'The document provided is not clearly readable',
    'Please ensure all text and numbers are visible',
    'Take a clear photo or scan in good lighting',
    'Avoid blurry or low-resolution images'
  ],
  [DocumentRejectionReason.INCORRECT_DOCUMENT]: [
    'The document type submitted does not match what was requested',
    'Please review the specific document requirements',
    'Ensure you are uploading the correct document type'
  ],
  [DocumentRejectionReason.EXPIRED]: [
    'The document provided has expired',
    'Please provide a current, valid document',
    'Check the expiration date before submitting'
  ],
  [DocumentRejectionReason.INCOMPLETE]: [
    'The document is missing required pages or information',
    'Please include all pages of the document',
    'Ensure all required fields are filled out',
    'Submit the complete document as one file if possible'
  ],
  [DocumentRejectionReason.WRONG_ENTITY]: [
    'The document is for a different person or business',
    'Please ensure the document matches the requested entity',
    'Check that names and identifying information match'
  ],
  [DocumentRejectionReason.ALTERED_DOCUMENT]: [
    'The document appears to have been modified or altered',
    'Please provide an original, unaltered document',
    'Obtain a fresh copy from the issuing source if needed'
  ],
  [DocumentRejectionReason.OTHER]: [
    'The document does not meet our requirements',
    'Please review the specific requirements for this document type',
    'Contact support if you need clarification'
  ]
}

/**
 * Event types for document requests
 */
export enum DocumentRequestEventCreatedBy {
  ADMIN_PORTAL = 'admin_portal',
  CUSTOMER_PORTAL = 'customer_portal',
  SYSTEM = 'system'
}

/**
 * Event types for document requests
 */
export enum DocumentRequestEventSubtype {
  CREATED = 'created',
  CANCELLED = 'cancelled',
  RE_REQUESTED = 're_requested',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  SUBMITTED = 'submitted',
  GET_PRESIGNED_URL = 'get_presigned_url',
  UPLOADED_TO_SILA = 'uploaded_to_sila',
  SENT_TO_BLUE_PENGUIN = 'sent_to_blue_penguin',
  SEND_TO_BLUE_PENGUIN_FAILED = 'send_to_blue_penguin_failed'
}

/**
 * Authoritative outcome of the last Blue Penguin send attempt for a
 * DocumentRequest. null (column) = never attempted. `pending` is stamped as an
 * optimistic claim before dispatch; the sendBpDocumentsEmail wrapper workflow
 * flips it to `sent` or `failed` based on the actual delivery outcome.
 */
export enum BpDocumentSendStatus {
  PENDING = 'pending',
  SENT = 'sent',
  FAILED = 'failed'
}

/**
 * For tracking who the document is for
 */
export enum DocumentRequestTarget {
  CUSTOMER = 'customer', // Business entity
  DRIVER = 'driver', // Individual person
  ANCILLARY_OWNER = 'ancillary_owner' // External KYC individual
}

export enum DocumentRequestReason {
  FAILED_UNDERWRITING_CHECK = 'failed_underwriting_check',
  SILA_REQUESTED = 'sila_requested',
  // Customer chose "Submit 6 Months of Bank Statements" instead of linking Plaid during onboarding
  // (THT-703). Auto-created so they get an in-app upload prompt; scopes the reverse cancel so only
  // onboarding-created requests are voided when they switch back to Plaid.
  ONBOARDING_REVENUE_VERIFICATION = 'onboarding_revenue_verification',
  OTHER = 'other'
}

export const DOCUMENT_REQUEST_REASONS: Record<DocumentRequestReason, string> = {
  [DocumentRequestReason.FAILED_UNDERWRITING_CHECK]: 'Failed Underwriting Check',
  [DocumentRequestReason.SILA_REQUESTED]: 'Sila Requested',
  [DocumentRequestReason.ONBOARDING_REVENUE_VERIFICATION]: 'Onboarding Revenue Verification',
  [DocumentRequestReason.OTHER]: 'Other'
}

export interface DocumentRequestWithTarget {
  type: DocumentRequestType
  targetName: string | null
}

/**
 * Extended document requirement for email with target info
 */
export interface DocumentRequirementWithTarget extends DocumentRequirement {
  targetName: string | null
}


// From common/rds-utils/src/types/eld.ts
/**
 * Self-reported ELD provider, collected during the application flow.
 * Distinct from the ELD integrations TACH actively connects to.
 * When the user picks `Other`, the free-form value is stored in `eld_provider_other`.
 */
export enum EldProvider {
  Motive = 'motive',
  Samsara = 'samsara',
  Geotab = 'geotab',
  VerizonConnect = 'verizon_connect',
  Other = 'other'
}

export const ELD_PROVIDER_VALUES = Object.values(EldProvider)


// From common/rds-utils/src/types/employee.ts


/**
 * `Employee.role` vocabulary. The column itself stays a free-text nullable STRING; this enum is
 * the only place a role value is meaningful. Lives here (not `types-and-constants`) because it
 * describes a model column — see `Employee.role` in `models/admin/employee.ts`, matching how
 * `DebitCardEventSubtype` is typed against its column.
 */
export enum EmployeeRole {
  ADMIN = 'admin',
  SUPPORT = 'support',
  VIEWER = 'viewer'
}

/**
 * The only place roles meet permissions. `permissionsForRole` is the sole reader — add a role or
 * change what it can do here, never by comparing `role` strings at a call site.
 *
 * `viewer` is NOT read-only: outside the four admin areas THT-797 gates (addresses, budget items,
 * internal bank accounts, debit cards), a viewer can still fund/approve cash advances, decide
 * applications, approve Blue Penguin documents, trigger KYC, and change feature flags — those
 * areas aren't gated yet. Don't assign `viewer` expecting it to fully lock someone out of
 * mutations until that follow-up work lands.
 */
export const ROLE_PERMISSIONS: Readonly<Record<EmployeeRole, readonly AdminPermission[]>> = {
  [EmployeeRole.ADMIN]: [
    AdminPermission.CARDS_MANAGE,
    AdminPermission.ADDRESSES_MANAGE,
    AdminPermission.BUDGET_MANAGE
  ],
  [EmployeeRole.SUPPORT]: [AdminPermission.ADDRESSES_MANAGE, AdminPermission.BUDGET_MANAGE],
  [EmployeeRole.VIEWER]: []
}

/**
 * Resolves an `Employee.role` value to its permissions. Fail-closed: a null/undefined role (the
 * column defaults to `'admin'`, but a row can still be created or altered with an explicit NULL)
 * or any value outside the `EmployeeRole` vocabulary returns no permissions rather than guessing.
 */
export function permissionsForRole(role: string | null | undefined): readonly AdminPermission[] {
  if (!role || !(Object.values(EmployeeRole) as string[]).includes(role)) return []
  return ROLE_PERMISSIONS[role as EmployeeRole]
}


// From common/rds-utils/src/types/linkedAccounts.ts
// Enums for the LinkedAccount model.

// Why an account can no longer be ACH-debited. This is TACH's runtime control state
// (distinct from Sila's link-time `web_debit_verified` fact) and is the gate the deposit
// path checks (`debit_disabled_at IS NULL`).
export enum DebitDisabledReason {
  NotWebDebitVerified = 'not_web_debit_verified', // Sila returned web_debit_verified === false at provisioning
  AchReturnAccountClosed = 'ach_return_account_closed', // R02 / R03 / R04
  AchReturnUnauthorized = 'ach_return_unauthorized', // R10 / R29
  AchReturnRevoked = 'ach_return_revoked', // R07
  AchReturnAccountFrozen = 'ach_return_account_frozen', // R16
  OpsManual = 'ops_manual',
  Fraud = 'fraud'
}

/**
 * Our classification of Sila's freeze state for a linked account — NOT a mirror of Sila's
 * `account_status`, which is only `active` / `inactive`.
 *
 * Sila freezes EVERY newly linked account and thaws it ~5–15 minutes later, but it uses the same
 * `inactive` for a permanent fuzzy-name-match freeze that only Sila can lift. `inactive` alone
 * therefore can't answer the one question that matters — does the customer wait, or act? — and the
 * field that separates them (`match_score`) is not persisted.
 *
 * So we classify at write time, where the score is already in hand from `/link_account` or
 * `/get_accounts`, and store the decision rather than the input. Deposit eligibility reads this
 * column directly, on every linked-accounts list render, with no call back to Sila.
 *
 * Deliberately NOT any of:
 * - "provisioned yet" — that's `sila_payment_instrument_id IS NULL`
 * - "terminally disabled" — that's `debit_disabled_at` (ACH returns, fraud). A freeze is
 *   recoverable; a disable is not. Conflating the two is what made `web_debit_verified` useless
 *   as a gate.
 */
export enum SilaAccountStatus {
  /** Sila reports the instrument active — usable for a pull right now. */
  Active = 'active',
  /** Frozen, but scored at or above Sila's threshold: the freeze-on-link kind, thaws on its own. */
  PendingActivation = 'pending_activation',
  /** Frozen below Sila's threshold: a name mismatch. Needs a re-link under a different entity, or Sila support. */
  NameMismatch = 'name_mismatch'
}

/**
 * Sila's documented fuzzy-name-match cutoff. At or above it a freeze is transient; below it the
 * account is frozen permanently. Lives here so the classifier and the deposit wait can't drift.
 */
export const SILA_NAME_MATCH_THRESHOLD = 0.73

/**
 * Classifies Sila's raw view of an account. `match_score` is null when Sila didn't report one —
 * treated as the recoverable case, since assuming a mismatch would permanently condemn an account
 * that might simply be mid-thaw.
 */
export function classifySilaAccountStatus({
  active,
  match_score
}: {
  active: boolean
  match_score: number | null
}): SilaAccountStatus {
  if (active) return SilaAccountStatus.Active
  if (match_score != null && match_score < SILA_NAME_MATCH_THRESHOLD) {
    return SilaAccountStatus.NameMismatch
  }
  return SilaAccountStatus.PendingActivation
}


// From common/rds-utils/src/types/liquidityPool.ts
export enum LiquidityPoolLedgerEntryType {
  /** Funds advanced from pool → customer via BP C2C transfer in response to a confirmed deposit. */
  CustomerAdvance = 'customer_advance',
  /** Funds returned to pool via ACH from Sila (or other source) to replenish after advances. */
  Replenishment = 'replenishment',
  /** Manual or system correction (e.g. reconciliation fix, initial seed, manual top-up). */
  Adjustment = 'adjustment',
  /**
   * Funds advanced from pool → customer's stored balance via BP C2C to front an unload
   * (pool-accelerated withdrawal) so the outbound ACH can fire before the card unload settles.
   */
  UnloadAdvance = 'unload_advance',
  /** Settled card-unload funds returned to the pool via BP C2C, closing an UnloadAdvance. */
  UnloadRecoup = 'unload_recoup'
}

/**
 * Polymorphic source reference for ledger entries (pairs with source_id). Lets the pool back
 * multiple use-cases with one standard polymorphic-reference pair instead of a nullable FK
 * column per domain.
 */
export enum LiquidityPoolLedgerSourceType {
  /** source_id → Deposits.deposit_id (CustomerAdvance entries). */
  Deposit = 'deposit',
  /** source_id → LiquidityPoolReplenishments.replenishment_id (Replenishment entries). */
  Replenishment = 'replenishment',
  /** source_id → Unloads.unload_id (UnloadAdvance / UnloadRecoup entries). */
  Unload = 'unload'
}

export enum LiquidityPoolReplenishmentStatus {
  /** Replenishment created but ACH not yet initiated. */
  Pending = 'pending',
  /** ACH initiated from Sila, awaiting settlement at BP. */
  InTransit = 'in_transit',
  /** Funds confirmed in pool BP account. */
  Completed = 'completed',
  /** ACH failed or was returned. */
  Failed = 'failed'
}

export enum LiquidityPoolReplenishmentSource {
  /** Same-day or standard ACH push from Sila to BP pool account. */
  SilaAch = 'sila_ach',
  /** Manual funding (e.g. wire from operating account, initial seed). */
  Manual = 'manual',
  /** Internal transfer within Sila before batched ACH (V3). */
  InternalTransfer = 'internal_transfer'
}


// From common/rds-utils/src/types/marketing.ts
export enum MarketingStatus {
  NEW = 'new',
  LEMLIST = 'lemlist',
  ACTIVECAMPAIGN = 'activecampaign',
  UNSUBSCRIBED = 'unsubscribed',
  CONVERTED = 'converted'
}

/**
 * MarketingEvent.event_type values relevant to the AC inactivity-cleanup cron.
 * The column is a free string written by several producers (lemlist webhook
 * processor → see common/lemlist-utils/src/marketing-events, customer signup →
 * services/customers/src/createCustomer.ts). These constants let the cleanup
 * code reference the values without string literals.
 */
export enum MarketingEventType {
  EMAIL_SENT = 'email_sent',
  EMAIL_OPENED = 'email_opened',
  EMAIL_CLICKED = 'email_clicked',
  EMAIL_REPLIED = 'email_replied',
  INTERESTED = 'interested',
  EMAILS_INTERESTED = 'emailsInterested',
  CUSTOMER_SIGNUP = 'customer_signup',
  APPLICATION_STARTED = 'application_started'
}

/**
 * How a Customer was matched to a CarrierLead at signup/onboarding. Recorded in the
 * customer_signup MarketingEvent's event_data.matched_on. See
 * common/leads-utils/src/customerLeadMatching.ts.
 */
export enum CustomerLeadMatchType {
  EMAIL_OR_PHONE = 'email_or_phone',
  MC_OR_DOT = 'mc_or_dot',
  // No lead existed for any identifier, so one was created from the customer's own
  // MC/DOT capture (THT-728 heads-up page). Distinguishes "we found your lead" from
  // "you are the lead" in attribution reporting. Recorded in the customer_signup
  // MarketingEvent's JSON event_data — no column, no migration.
  //
  // NOT a complete census on its own: the event below is only written when an
  // attribution ETID exists (campaign_id/variant_id are NOT NULL), and a
  // created-from-customer lead usually has none — that is what "no lead matched"
  // tends to mean. The durable signal for THAT population is the lead's own
  // `source_broker_ids` tag (HEADS_UP_LEAD_SOURCE), which is always stamped. Count
  // heads-up-sourced leads from the tag; use this value to split attributed ones.
  CREATED_FROM_CUSTOMER = 'created_from_customer'
}

/**
 * MarketingEvent.event_type values that count as positive engagement when
 * scoring a lead's inactivity. Mirrors the lemlist engagement set in
 * services/lemlist/src/webhookProcessor.ts (emailsOpened / emailsClicked /
 * emailsReplied / interested / emailsInterested) after lemlist→MarketingEvent
 * type mapping.
 */
export const POSITIVE_ENGAGEMENT_MARKETING_EVENT_TYPES: MarketingEventType[] = [
  MarketingEventType.EMAIL_OPENED,
  MarketingEventType.EMAIL_CLICKED,
  MarketingEventType.EMAIL_REPLIED,
  MarketingEventType.INTERESTED,
  MarketingEventType.EMAILS_INTERESTED
]

/**
 * Resolve what an AC sync may write to `carrier_lead.marketing_status`.
 * Returns ACTIVECAMPAIGN to nudge NEW/LEMLIST leads forward, or `undefined`
 * (leave unchanged) when the current status must be preserved:
 * - CONVERTED — the lead became a customer; marketing stays suppressed.
 * - UNSUBSCRIBED — the lead opted out; admin lead-search filters and reporting
 *   rely on it (`is_unsubscribed` only suppresses sends, not the status).
 * Single source of truth for BOTH writers of the column — the lemlist→AC path
 * (`updateCarrierLeadStatus`) and the lifecycle router
 * (`persistCarrierLeadLifecycleState`) — so their guards can never drift or
 * defeat each other.
 */
export function resolveMarketingStatusForAcSync(
  current: MarketingStatus | null | undefined
): MarketingStatus | undefined {
  if (current === MarketingStatus.CONVERTED || current === MarketingStatus.UNSUBSCRIBED) {
    return undefined
  }
  return MarketingStatus.ACTIVECAMPAIGN
}

/**
 * Whether a CarrierLead has opted out of marketing, per EITHER signal:
 * `is_unsubscribed` (written by the lemlist unsubscribe webhook — suppresses
 * SENDS) or `marketing_status = UNSUBSCRIBED` (the reporting/filtering signal,
 * see `resolveMarketingStatusForAcSync`). Different producers write them and
 * neither implies the other, so a guard that reads only one misses real opt-outs.
 *
 * Single source of truth for every AC-facing opt-out guard, so the lifecycle
 * router's pre-check (`fetchCarrierLeadDealRef`) and the contact mint's own
 * recheck (`ensureActiveCampaignContactForCarrierLead`) can never drift. That
 * matters because the mint SUBSCRIBES the contact to the master list: a guard
 * that disagrees with the other silently re-enlists someone who opted out.
 *
 * Takes the raw column names so it can be handed a CarrierLead model instance
 * directly — no DTO mapping between the row and the decision.
 */
export function isCarrierLeadUnsubscribed(lead: {
  is_unsubscribed?: boolean | null
  marketing_status?: MarketingStatus | null
}): boolean {
  return lead.is_unsubscribed === true || lead.marketing_status === MarketingStatus.UNSUBSCRIBED
}

/**
 * Outcome of an AC inactivity-cleanup action, stored on
 * CarrierLead.activecampaign_cleanup_action. null = never cleaned up.
 */
export enum ActiveCampaignCleanupAction {
  ARCHIVED = 'archived', // AC contact archived by the inactivity-cleanup cron
  ALREADY_PURGED = 'already_purged', // AC returned 404 at action time — treat as already gone, flag only
  /**
   * Permanently out of the cleanup's reach — the lead became a customer /
   * applicant (§2.4–.5 guard) or its deal progressed past the archive-eligible
   * P1 stages (forward-only router ⇒ it can never come back). Flagged so the
   * weekly scan stops re-reading these leads (and re-burning AC calls) at the
   * front of the candidate set every run. The AC contact is ALIVE — revival
   * must NOT treat this as archived.
   */
  PROTECTED = 'protected'
}

/** Tag applied to AC contacts archived by the inactivity-cleanup cron. */
export const ACTIVE_CAMPAIGN_ARCHIVED_INACTIVE_TAG = 'tach-archived-inactive'

/**
 * Decide how to revive a (possibly) cleaned-up CarrierLead's AC presence.
 * Shared by the lemlist→AC sync activities and the admin push handler so both
 * route flagged leads identically.
 *
 * - `none`     — lead was never cleaned up (or is merely PROTECTED — its AC
 *                contact is alive and untouched); proceed with the normal sync path.
 * - `recreate` — the lead was cleaned up (archived or already purged); drop the
 *                stale AC ids so the normal sync path makes a fresh contact +
 *                deal. AC purges archived contacts past its retention window and
 *                offers no reliable single-contact restore, so revival always
 *                recreates rather than restoring.
 */
export function decideActiveCampaignRevival(input: {
  cleanupAction: ActiveCampaignCleanupAction | null
}): 'none' | 'recreate' {
  if (
    input.cleanupAction === ActiveCampaignCleanupAction.ARCHIVED ||
    input.cleanupAction === ActiveCampaignCleanupAction.ALREADY_PURGED
  ) {
    return 'recreate'
  }
  return 'none'
}

/** Lost reason recorded on AC deals marked lost by the inactivity-cleanup cron. */
export const ACTIVE_CAMPAIGN_INACTIVITY_LOST_REASON = 'Inactivity'


// From common/rds-utils/src/types/monitoring.ts
export enum FinancialHealthStatus {
  HEALTHY = 'healthy',
  WARNING = 'warning',
  CRITICAL = 'critical'
}

// From common/rds-utils/src/types/netTakeHomePay.ts
// NTHP category identifier. Authoritative config (display name, emoji, etc.) lives in
// `types-and-constants/src/constants/budgeting.ts` under
// `defaultSystemManagedBudgetItemsConfig.net_take_home_pay`. Keep this string in sync.
export const NET_TAKE_HOME_PAY_CATEGORY = 'net_take_home_pay'


// From common/rds-utils/src/types/pendingTransactions.ts
// Enum for the PendingTransaction model — a reconciliation-neutral record of an in-flight
// money movement surfaced to the customer before it settles into a real Transaction.
// Deposits (ACH debit pulls) are the first consumer.

export enum PendingTransactionStatus {
  Pending = 'pending',
  Cleared = 'cleared',
  Failed = 'failed',
  Canceled = 'canceled'
}

/**
 * Outcome discriminant for guarded model writes (e.g. `PendingTransaction.markFailed`):
 * `Success` = the write was performed; `Skipped` = the status guard prevented it (no-op —
 * the result carries context like the row's current status so the caller can route).
 */
export enum GuardedUpdateOutcome {
  Success = 'success',
  Skipped = 'skipped'
}


// From common/rds-utils/src/types/scheduledWithdrawals.ts
// Model-lifecycle enums for ScheduledWithdrawal rows. The domain-level enums the pure
// recurrence/memo logic needs (frequency, amount_type) live in types-and-constants —
// workflow-side Temporal code consumes them there; these three are Sequelize-row state.
// Design doc: docs/scheduled-withdrawals-feature-spec.md (D1, D11).

export enum ScheduledWithdrawalStatus {
  Active = 'active',
  Paused = 'paused',
  /** Terminal. Rows are permanent audit records — canceling frees the customer's cap slot. */
  Canceled = 'canceled'
}

export enum ScheduledWithdrawalPausedReason {
  Customer = 'customer',
  Admin = 'admin',
  /** Destination linked account was unlinked/deleted — recovery = edit destination, then resume. */
  DestinationUnlinked = 'destination_unlinked',
  /** The source custom bucket was deleted. */
  BucketDeleted = 'bucket_deleted'
}

export enum ScheduledWithdrawalCreatedBy {
  Customer = 'customer',
  Admin = 'admin'
}


// From common/rds-utils/src/types/thirdPartyLogistics.ts
/**
 * Where a 3PL's logo shows. `DASHBOARD` replaces the TACH logo in the customer dashboard (and
 * also shows in the application header); `APPLICATION_ONLY` shows it in the application header
 * only, leaving the dashboard pure TACH.
 */
export enum ThirdPartyLogisticsBrandingScope {
  DASHBOARD = 'dashboard',
  APPLICATION_ONLY = 'application_only'
}

/** Every valid ThirdPartyLogisticsBrandingScope value — the source of truth for joi `.valid(...)`. */
export const THIRD_PARTY_LOGISTICS_BRANDING_SCOPE_VALUES = Object.values(
  ThirdPartyLogisticsBrandingScope
)


// From common/rds-utils/src/types/tiers.ts
// Customer tier enums and constants

export enum TierType {
  STARTER = 'starter',
  CORE = 'core',
  PRO = 'pro'
}

// The tier a customer falls back to whenever we can't honor or find a requested/selected tier
// (invalid tier on signup, failed tier write, missing CustomerTiers row). Keep every such
// fallback on this constant so the two endpoints that report it (createCustomer, findUser)
// can't drift.
export const DEFAULT_CUSTOMER_TIER = TierType.PRO

export enum TierChangeReason {
  SIGNUP = 'signup',
  UPGRADE = 'upgrade',
  DOWNGRADE = 'downgrade',
  ADMIN_OVERRIDE = 'admin_override',
  MIGRATION = 'migration'
}

// Fee configuration per tier
export interface TierFeeConfig {
  app_fee_cents: number | null
  monthly_fee_per_truck_cents: number | null // DEPRECATED
  deposit_fee_basis_points: number | null
}

// Default fee configuration by tier
export const TIER_FEE_DEFAULTS: Record<TierType, TierFeeConfig> = {
  [TierType.STARTER]: {
    app_fee_cents: 9900, // $99 one-time
    monthly_fee_per_truck_cents: null,
    deposit_fee_basis_points: null
  },
  [TierType.CORE]: {
    app_fee_cents: null,
    monthly_fee_per_truck_cents: null,
    deposit_fee_basis_points: 119 // 1.19%
  },
  [TierType.PRO]: {
    app_fee_cents: null,
    monthly_fee_per_truck_cents: null,
    deposit_fee_basis_points: 149 // 1.49%
  }
}

// Cash advance rates by tier (basis points)
export interface CashAdvanceRates {
  first_month_basis_points: number
  subsequent_months_basis_points: number
}

export const CASH_ADVANCE_RATES: Record<TierType, CashAdvanceRates> = {
  [TierType.STARTER]: {
    first_month_basis_points: 300, // 3%
    subsequent_months_basis_points: 300 // 3%
  },
  [TierType.CORE]: {
    first_month_basis_points: 300, // 3%
    subsequent_months_basis_points: 200 // 2%
  },
  [TierType.PRO]: {
    first_month_basis_points: 200, // 2%
    subsequent_months_basis_points: 150 // 1.5%
  }
}

// Cashback rates by tier (basis points)
export interface CashbackRates {
  fuel_basis_points: number
  other_basis_points: number
}

export const CASHBACK_RATES: Record<TierType, CashbackRates> = {
  [TierType.STARTER]: {
    fuel_basis_points: 0,
    other_basis_points: 0
  },
  [TierType.CORE]: {
    fuel_basis_points: 200, // 2%
    other_basis_points: 100 // 1%
  },
  [TierType.PRO]: {
    fuel_basis_points: 300, // 3%
    other_basis_points: 200 // 2%
  }
}

// Service fees by tier (cents)
export interface ServiceFees {
  roadside: number
  rental: number
}

export const SERVICE_FEES: Record<TierType, ServiceFees> = {
  [TierType.STARTER]: {
    roadside: 14900, // $149
    rental: 19900 // $199
  },
  [TierType.CORE]: {
    roadside: 9900, // $99
    rental: 12900 // $129
  },
  [TierType.PRO]: {
    roadside: 0,
    rental: 0
  }
}

// Fuel advance fee rates by tier (basis points)
export const FUEL_ADVANCE_FEE_RATES: Record<TierType, { fee_basis_points: number }> = {
  [TierType.STARTER]: { fee_basis_points: 300 }, // 3%
  [TierType.CORE]: { fee_basis_points: 200 }, // 2%
  [TierType.PRO]: { fee_basis_points: 150 } // 1.5%
}

export const FUEL_ADVANCE_MAX_AMOUNT_CENTS = 100_000 // $1,000
export const FUEL_ADVANCE_LOAD_VALUE_PERCENTAGE = 0.5
export const FUEL_ADVANCE_DUE_DAYS_AFTER_DELIVERY = 7
export const FUEL_ADVANCE_HIGH_RISK_DAYS_AFTER_DELIVERY = 3
export const FUEL_ADVANCE_INFO_REQUEST_EXPIRY_HOURS = 72

// Helper to get all tier values as array (for validation)
export const TIER_TYPE_VALUES = Object.values(TierType)
export const TIER_CHANGE_REASON_VALUES = Object.values(TierChangeReason)


// From common/rds-utils/src/types/transactions.ts
export enum ReversalStatus {
  Reversed = 'reversed',
  Expired = 'expired'
}


// From common/rds-utils/src/types/users.ts


export interface VendorWithType extends Vendor {
  userType: 'vendor'
}

export interface CustomerWithType extends Customer {
  userType: 'customer'
  drivers: Driver[]
  trucks: Truck[]
  trailers: Trailer[]
  bp_customer_id: string // Defaults to descriptive string if not found
}

export interface PartnerWithType extends Partner {
  userType: 'partner'
}

export type UserWithType = VendorWithType | CustomerWithType | PartnerWithType


// From common/rds-utils/src/functions/types.ts


export interface GetAllTrucksAndTrailersByCustomerIdResponse {
  trucks: Truck[]
  trailers: Trailer[]
}

export interface GetAllTrucksAndTrailersByCustomerIdParams {
  customer_id: string
  truck_attributes?: string[]
  trailer_attributes?: string[]
}

export interface CreateTruckOutOfServiceLogParams {
  truck_id: string
  out_of_service_reason: string
}

export interface TrucksAndMostRecentOutOfServiceLog extends Truck, TruckOutOfServiceLog {
  truck_id: string
  is_currently_out_of_service: boolean
}

export class ProfanityDetectedError extends Error {
  constructor(entityName?: string) {
    const suffix = !!entityName ? ` in ${entityName}.` : '.'
    const message = `Profanity detected` + suffix
    super(message)
    this.name = 'ProfanityDetectedError'

    // Ensure `instanceof` works correctly
    Object.setPrototypeOf(this, ProfanityDetectedError.prototype)
  }
}

export interface GetLockParams {
  lock_id: string
  ttl_ms?: number
  session_id?: string | null
}

export interface GetLockResponse {
  lock: Lock
  gotLock: boolean
}

export interface ReleaseLockParams {
  lock_id: string
}

export interface WithLockOptions extends GetLockParams {
  onFail?: () => Error // optional custom error on lock failure
}

export class LockTimeoutError extends Error {
  constructor(ms: number) {
    super(`Locked function exceeded time limit of ${ms}ms`)
    this.name = 'LockTimeoutError'

    // Ensure `instanceof` works correctly
    Object.setPrototypeOf(this, LockTimeoutError.prototype)
  }
}

export interface CustomerRevenueConsistencyMetrics {
  customer_id: string
  recent_revenue: number
  historical_revenue: number
  percentage_difference: number
}

export interface CheckIfDirectDepositVerifiedFor30DaysResponse {
  verified_for_30_days: boolean
  customer_id: string
}

// Update to this interface should be reflected in ownershipInfoSchema in admin-applications
export interface OwnershipInfo {
  first_name: string
  last_name: string
  ssn: string
  dob: string
  address_st_number: string
  address_st_name: string
  address_unit?: string
  address_city: string
  address_state: string
  address_zip: string
  email: string
  phone_number: string
  id_value: string
  id_state: string
  percentage: number
  sila_kyc_metadata: SilaKycMetadata
}

// Standard TypeScript Omit + partial override pattern
// We omit sila_kyc_metadata from the request body because we create defaults if not provided
export interface OwnershipInfoForRequest extends Omit<OwnershipInfo, 'sila_kyc_metadata'> {
  sila_kyc_metadata?: OwnershipInfo['sila_kyc_metadata']
}

// Update to this interface should be reflected in silaKycMetadataSchema in admin-applications
export interface SilaKycMetadata {
  system_uuid: string
  sila_customer_id: string | null
  sila_been_linked: boolean
  sila_kyc_status: string | null
}

export enum DebtType {
  BUSINESS_LOAN = 'business_loan',
  LINE_OF_CREDIT = 'line_of_credit',
  CREDIT_CARD = 'credit_card',
  TRUCK_LEASE = 'truck_lease',
  TRUCK_LOAN = 'truck_loan',
  TRAILER_LEASE = 'trailer_lease',
  TRAILER_LOAN = 'trailer_loan',
  OTHER = 'other'
}

export const debtTypeLabels: Record<DebtType, string> = {
  [DebtType.BUSINESS_LOAN]: 'Business Loan',
  [DebtType.LINE_OF_CREDIT]: 'Line of Credit',
  [DebtType.CREDIT_CARD]: 'Credit Card',
  [DebtType.TRUCK_LEASE]: 'Truck Lease',
  [DebtType.TRUCK_LOAN]: 'Truck Loan',
  [DebtType.TRAILER_LEASE]: 'Trailer Lease',
  [DebtType.TRAILER_LOAN]: 'Trailer Loan',
  [DebtType.OTHER]: 'Other'
}

// Keep the original array format for backward compatibility if needed
export const debtTypeOptions = Object.entries(debtTypeLabels).map(([value, label]) => ({
  value,
  label
}))

export interface DebtFormData {
  debtType: DebtType
  outstandingBalance: number
  monthlyPayment: number
}

export enum ApplicationEventCreatedBy {
  ADMIN_PORTAL = 'admin_portal',
  SIGNUP_FLOW = 'signup_flow',
  UNDERWRITING_WORKFLOW = 'underwriting_workflow',
  ID_VERIFICATION_WORKFLOW = 'id_verification_workflow',
  PLAID_PROCESS_ASSET_REPORT_WORKFLOW = 'plaid_process_asset_report_workflow',
  NEW_CUSTOMER_WORKFLOW = 'new_customer_workflow',
  DROPBOX_SIGN_WEBHOOK = 'dropbox_sign_webhook',
  // One-off: moved off the deprecated Plaid Link step by backfillDeprecatedPlaidLinkStepWorkflow.
  PLAID_LINK_STEP_BACKFILL = 'plaid_link_step_backfill'
}

export enum EventObjectType {
  APPLICATION = 'application',
  LOAN_REQUEST = 'loan_request',
  LOAN_TERMS_OPTION = 'loan_terms_option',
  DOCUMENT_REQUEST = 'document_request',
  APPLICATION_NOTE = 'application_note',
  ADDRESS = 'address',
  DEPOSIT_INVOICE = 'deposit_invoice',
  FEATURE_FLAG = 'feature_flag',
  SYSTEM_ALERT = 'system_alert',
  CUSTOMER = 'customer',
  BUDGET_ITEM = 'budget_item',
  SCHEDULED_WITHDRAWAL = 'scheduled_withdrawal',
  DEBIT_CARD = 'debit_card'
}

export enum EventEventType {
  UPDATE = 'update',
  CREATE = 'create',
  FETCH = 'fetch',
  DELETE = 'delete',
  TOGGLED = 'toggled',
  SCHEDULE_CREATED = 'schedule_created',
  WORKFLOW_STARTED = 'workflow_started',
  WORKFLOW_PAUSED = 'workflow_paused',
  WORKFLOW_RESUMED = 'workflow_resumed',
  PHASE_APPROVED = 'phase_approved',
  ROLLBACK_TRIGGERED = 'rollback_triggered',
  NOTIFICATION_SENT = 'notification_sent',
  PHASE_TRANSITION = 'phase_transition',
  ROLLBACK = 'rollback',
  STATUS_CHANGE = 'status_change'
}


// From common/rds-utils/src/functions/notificationTypes.ts


export type NotificationMetadata =
  | MaintenanceReminderMetadata
  | MonthlyStatementMetadata
  | CardDeclineMetadata
  | ManualMileageRequestMetadata
  | PreventativeMaintenanceReminderCreatedMetadata
  | CashAdvanceConsentMetadata
  | ScheduledWithdrawalSkippedMetadata
  | ScheduledWithdrawalPartialMetadata
  | ScheduledWithdrawalPausedMetadata

export enum NotificationDisplayType {
  Notification = 'notification',
  Insight = 'insight',
  Both = 'both'
}

// [TruckName] is due for [maintenance_type] by [end_date/end_mileage].
export interface MaintenanceReminderMetadata {
  asset_display_name: string
  asset_type: string
  maintenance_type: string
  end_date?: Date // Optional if end_mileage is provided
  end_mileage?: number // Optional if end_date is provided
  reminder_type: string
  asset_id: string
  reminder_id: string
}

export interface PreventativeMaintenanceReminderCreatedMetadata {
  truck_display_name: string
  end_mileage: number
  truck_id: string
}

// Your monthly statement for February, 2025 is available.
export interface MonthlyStatementMetadata {
  account_id: string
  year: number
  month: number
}

export interface CardDeclineMetadata {
  dollar_amount: string
  decline_reason: string
  last_four_digits: string | null
  // Merchant the swipe was attempted at, when the processor provided one. Shown in the app's
  // notification lead-in ("Your $50 purchase at PILOT TRAVEL CTR…"); omitted when blank.
  merchant_name?: string
}

export interface ManualMileageRequestMetadata {
  truck_display_name?: string
  week_start_date: string
  week_end_date: string
}

// Set when a cash advance requires customer consent before continuing.
// Notification deep-links to /dashboard/banking/cash-advance/consent/{loan_request_id}.
// Origin: temporal/src/activities/creditActivities/creditActivities.ts (~line 994).
export interface CashAdvanceConsentMetadata {
  loan_request_id: string
  consent_link: string
}

/**
 * Scheduled withdrawals (scheduled-withdrawals spec D5) — one shape per notification type,
 * discriminated on `outcome`. Each carries every value the app needs to render the same
 * sentence the push said. The values are a snapshot of when we looked: the label can be
 * edited later, and nothing else keeps the amount that was available at that moment.
 * Amounts are pre-formatted like CardDeclineMetadata.dollar_amount; dates are DATEONLY
 * (YYYY-MM-DD) for the app to format.
 * Origin: temporal/src/activities/scheduledWithdrawalActivities (buildNotificationContent).
 */
export interface ScheduledWithdrawalNotificationMetadataBase {
  scheduled_withdrawal_id: string
  occurrence_date: string
  // The customer's own name for the schedule, e.g. "Fuel card". Optional — null renders as
  // "Your scheduled withdrawal …", never as a quoted placeholder.
  label: string | null
}

// Your "Fuel card" scheduled withdrawal didn't run — only $12.40 was available. Nothing was withdrawn.
// Links to the schedule — it is still active, and next_run_date is its next attempt.
export interface ScheduledWithdrawalSkippedMetadata
  extends ScheduledWithdrawalNotificationMetadataBase {
  outcome: 'skipped'
  // "$12.40" — a negative (over-reserved) balance is shown as $0.00, same as the push
  available_amount: string
  next_run_date: string
}

// Your "Fuel card" scheduled withdrawal sent $300.00 — less than scheduled, because that was what was available.
export interface ScheduledWithdrawalPartialMetadata
  extends ScheduledWithdrawalNotificationMetadataBase {
  outcome: 'partial'
  // "$300.00" — what actually went out
  withdrawn_amount: string
}

// Your "Fuel card" scheduled withdrawal was paused because the budget category it withdrew from was deleted.
// The two strings come from the backend's per-reason copy, so the app never has to keep its
// own copy of what each reason means or what the customer should do about it. The push ends
// with a shorter version of the recovery step; in-app has room for the full one.
export interface ScheduledWithdrawalPausedMetadata
  extends ScheduledWithdrawalNotificationMetadataBase {
  outcome: 'paused'
  paused_reason: ScheduledWithdrawalPausedReason
  reason_description: string
  recovery_instruction: string
}

export enum NotificationOwnerType {
  Customer = 'customer',
  Driver = 'driver',
  Vendor = 'vendor',
  Partner = 'partner',
  PartnerAgent = 'partnerAgent'
}


// From common/sila-utils/src/types/registration.ts


/**
 * Enum of acceptable document types used for identity verification.
 */
export enum DocType {
  /** U.S. Passport */
  Passport = 'id_passport',

  /** U.S. Passport Card */
  // TACH doesn't support this
  // PassportCard = 'id_passport_card',

  /** Driver's License */
  DriversLicense = 'id_drivers_license',

  /** Driver's Permit */
  // TACH doesn't support this
  // DriversPermit = 'id_drivers_permit',

  /** State-issued ID card */
  StateID = 'id_state'

  /** U.S. Permanent Resident Card (Green Card) */
  // TACH doesn't support this
  // GreenCard = 'doc_green_card'
}

/**
 * Represents an identity document object used for user verification.
 * Note: Supply either `doc_country` OR `doc_state`, NOT both.
 */
export type IdentityDocument = IdentityNationalDocument | IdentityStateDocument

export interface IdentityNationalDocument {
  /**
   * The type of document being submitted.
   * Must be one of the supported types from DocType.
   */
  doc_type: DocType

  /**
   * The unique identification number on the document (e.g., passport number or license number).
   */
  doc_id: string

  /**
   * Required if submitting a passport or green card.
   * Should be a 2-character ISO country code (e.g., 'US').
   */
  doc_country: 'US'
}

export interface IdentityStateDocument {
  /**
   * The type of document being submitted.
   * Must be one of the supported types from DocType.
   */
  doc_type: DocType

  /**
   * The unique identification number on the document (e.g., passport number or license number).
   */
  doc_id: string

  /**
   * Required if submitting a passport or green card.
   * Should be a 2-character ISO country code (e.g., 'US').
   * Do NOT include this if using a state-issued document.
   */
  doc_state: string
}

export interface RegisterOwnerParams {
  driver_id: string
  first_name: string
  last_name: string
  ssn: string
  birthdate: string | Date
  address_st_number: string
  address_st_name: string
  address_city: string
  address_state: string
  address_zip: string
  email: string
  phone_number: string
  identity_document: IdentityDocument
}

export interface RegisterBusinessParams {
  customer_id: string
  business_name: string
  dba_name?: string
  employer_id_number: string
  date_of_incorporation: string | Date
  address_st_number: string
  address_st_name: string
  address_city: string
  address_state: string
  address_zip: string
  registration_state: string
  naics_code?: number
  email: string
  phone_number: string
  business_type: SilaBusinessType
}

export enum SilaBusinessType {
  // ✅ Certification required for owners > 25%
  Corporation = 'corporation',
  LLC = 'llc',
  LLP = 'llp',
  LP = 'lp',
  NonProfit = 'non_profit',
  Partnership = 'partnership',
  // 🚫 Certification exempt
  PublicCorporation = 'public_corporation',
  SoleProprietorship = 'sole_proprietorship'
  // DEPRECATED for Priority Bank
  // Trust = 'trust',
  // UnincorporatedAssociation = 'unincorporated_association'
}

/**
 * Enum representing required or optional user roles associated with a business.
 */
export enum SilaBusinessRole {
  /**
   * Required.
   * The user responsible for setting up the business.
   * Must certify business information and verify beneficial owners and the controlling officer.
   */
  Administrator = 'administrator',

  /**
   * Required.
   * A person in a leadership position with authority to sign contracts on behalf of the business.
   */
  ControllingOfficer = 'controlling_officer',

  /**
   * Conditional.
   * Required for individuals with >25% ownership in businesses that are not exempt (e.g., LLC, Corp).
   */
  BeneficialOwner = 'beneficial_owner'
}

export interface UnlinkBusinessMemberParams {
  user_handle: string
  business_handle: string
  role: SilaBusinessRole
}

export interface UnlinkBusinessMemberResponse {
  message: string
  role: SilaBusinessRole
}

export type LinkBusinessMemberParams =
  | LinkAdminParams
  | LinkControllingOfficerParams
  | LinkBeneficialOwnerParams

type LinkAdminParams = {
  customer_id: string
  owner_id: string
  role: SilaBusinessRole.Administrator
}

type LinkControllingOfficerParams = {
  customer_id: string
  driver_id: string
  owner_id: string
  role: SilaBusinessRole.ControllingOfficer
}

type LinkBeneficialOwnerParams = {
  customer_id: string
  driver_id: string
  owner_id: string
  role: SilaBusinessRole.BeneficialOwner
  ownership_stake: number
}

export interface SilaRegistrationResponse {
  message: string
  user_handle: string
}

export interface SilaBusinessRegistrationResponse extends SilaRegistrationResponse {
  business_uuid: string
}

export interface ResumeVerificationResponse {
  verification_uuid: string
  message: string
}

export interface EntityInfo {
  /** Epoch timestamp when entity was created */
  created_epoch: number

  /** Full name or registered business name */
  entity_name: string

  /** Birthdate in YYYY-MM-DD format (for individuals) */
  birthdate: string

  /** First name (individual only) */
  first_name: string

  /** Last name (individual only) */
  last_name: string
}

export interface SilaAddress {
  added_epoch: number
  modified_epoch: number
  uuid: string
  nickname: string
  street_address_1: string
  street_address_2: string
  city: string
  state: string
  country: string
  postal_code: string
}

export interface Email {
  added_epoch: number
  modified_epoch: number
  uuid: string
  email: string
}

export interface Phone {
  added_epoch: number
  modified_epoch: number
  uuid: string
  phone: string

  /** Indicates whether SMS confirmation was requested */
  sms_confirmation_requested: boolean

  /** Whether SMS was confirmed */
  sms_confirmed: boolean

  /** Whether this is the primary phone */
  primary: boolean
}

export interface Membership {
  /** The business this person is affiliated with */
  business_handle: string

  /** Name of the business */
  entity_name: string

  /** Role of the individual (e.g., administrator, controlling_officer, beneficial_owner) */
  role: SilaBusinessRole

  /** Optional details about the role (e.g., CEO) */
  details: string | null

  /** Ownership stake percentage (for beneficial owners only) */
  ownership_stake: number | null

  /** Certification token if beneficial ownership was certified */
  certification_token: string | null
}

export interface Identity {
  added_epoch: number
  modified_epoch: number
  uuid: string

  /** Identity type (e.g., SSN, EIN, etc.) */
  identity_type: string

  /** Masked identity value */
  identity: string
}

export interface GetEntityResponse {
  /** The user handle associated with this entity */
  user_handle: string

  /** 'individual' or 'business' */
  entity_type: SilaEntityType

  /** Core entity data such as name, DOB */
  entity: EntityInfo

  /** Array of associated addresses */
  addresses: SilaAddress[]

  /** Array of associated identities (e.g., SSN) */
  identities: Identity[]

  /** Array of associated email addresses */
  emails: Email[]

  /** Array of associated phone numbers */
  phones: Phone[]

  /** Memberships to businesses with roles like admin or owner */
  memberships: Membership[]
}

/**
 * Identity alias values accepted by Sila's identity endpoints.
 * SSN for individuals, EIN for businesses.
 */
export enum SilaIdentityAlias {
  SSN = 'SSN',
  EIN = 'EIN'
}

/** Params for updating an existing identity value on a registered entity (POST /update/identity). */
export interface UpdateIdentityParams {
  /** The entity's user handle (individual or business). */
  user_handle: string

  /** UUID of the existing identity record to update (from the entity's `identities` array). */
  uuid: string

  /** Which identity is being updated — SSN (individual) or EIN (business). */
  identity_alias: SilaIdentityAlias

  /** The new identity value (e.g. a 9-digit SSN/EIN, dashes optional). */
  identity_value: string

  /** Optional caller-supplied idempotency/tracking id echoed back as `customer_reference_id`. */
  reference?: string
}

/** The identity object returned by /update/identity — the base identity plus document linkage. */
export interface UpdatedIdentity extends Identity {
  document_id: string | null
  document_name: string | null
}

/** Response from POST /update/identity. */
export interface UpdateIdentityResponse {
  message: string
  identity: UpdatedIdentity
  customer_reference_id: string
  sila_reference_id: string
}


// From common/sila-utils/src/types/general.ts
export interface SilaResponseBase {
  success: boolean
  //   message: string
  reference: string
  sila_reference_id: string
  response_time_ms: string
  status: SilaResponseStatus
}

export enum SilaResponseStatus {
  Success = 'SUCCESS',
  Error = 'FAILURE'
}

export enum SilaEntityType {
  Individual = 'individual',
  Business = 'business'
}


// From common/loanpro-utils/src/constants.ts
export const lineOfCreditProductId = {
  default: 1
}

export const lineOfCreditBucketId = {
  default: 2
}

export const lineOfCreditAlreadyActiveExpectedErrorMessages = ['Line of Credit is already active.']

export enum CreditLimitUpdateMessage {
  JustInTimeCheck = 'Updated when reassessing credit for new loan request.'
}

export enum LoanOwner {
  CorporateBilling = 'CorporateBilling',
  ScottFunding = 'ScottFunding'
}

// Should NEVER exceed $50k
export const absoluteMaxLineOfCreditLimitDollars = 50000


// From common/lemlist-utils/src/types/types.ts
export interface LemlistConfig {
  apiKey: string
  stage: string
}

export interface Campaign {
  _id: string
  name: string
  status: 'draft' | 'running' | 'paused' | 'ended' | 'archived'
  createdAt: string
  stats?: CampaignStats
}

export interface CampaignListParams {
  limit?: number
  offset?: number
  status?: string
}

export interface LemlistLead {
  _id?: string
  email: string
  firstName?: string
  lastName?: string
  companyName?: string
  phone?: string
  campaignId?: string
  // Allow any additional fields to be added at the root level
  [key: string]: any
}

export interface LemlistActivity {
  _id: string
  type: string
  createdAt: string
  campaignId: string
  campaignName: string
  leadId: string
  leadEmail: string
  leadFirstName?: string
  leadLastName?: string
  teamId: string
  url?: string // For click events
  messageId?: string
  subject?: string
}

export interface CampaignStats {
  sent: number
  opened: number
  clicked: number
  replied: number
  bounced: number
  unsubscribed: number
  interested: number
  notInterested: number
  clickedLinks: Array<{
    url: string
    count: number
  }>
}

export interface CampaignStatsV2Step {
  index: number
  sequenceId: string
  sequenceStep: number
  abTest?: string
  taskType:
    | 'email'
    | 'linkedinVisit'
    | 'linkedinInvite'
    | 'linkedinSend'
    | 'phone'
    | 'manual'
    | 'conditional'
  conditionLabel?: string
  invited?: number
  sent: number
  delivered: number
  opened: number
  clicked: number
  replied: number
  notDelivered: number
  bounced: number
  unsubscribed: number
}

export interface CampaignStatsV2Response {
  nbLeads: number
  nbLeadsLaunched: number
  nbLeadsReached: number
  nbLeadsOpened: number
  nbLeadsInteracted: number
  nbLeadsAnswered: number
  nbLeadsInterested: number
  nbLeadsNotInterested: number
  nbLeadsUnsubscribed: number
  nbLeadsInterrupted: number
  messagesSent: number
  messagesNotSent: number
  messagesBounced: number
  delivered: number
  opened: number
  clicked: number
  replied: number
  invitationAccepted: number
  meetingBooked: number
  steps: CampaignStatsV2Step[]
}

export interface CampaignStatsV2Params {
  startDate: string
  endDate: string
  sendUser?: string
  ABSelected?: 'A' | 'B'
  channels?: ('email' | 'linkedin' | 'others')[]
}

export interface MarketingTrackingData {
  carrierId?: string
  brokerId: string
  campaignId: string
  emailVariant?: string
  source: 'lemlist'
  medium: 'email'
  content?: string
}

export interface ConversionFunnelMetrics {
  emailsSent: number
  emailsOpened: number
  emailsClicked: number
  micrositeVisits: number
  applicationStarts: number
  completedSignups: number
  openRate: number
  clickRate: number
  micrositeConversionRate: number
  signupConversionRate: number
}

export interface RetargetingSegment {
  segmentType: 'no_open' | 'opened_no_click' | 'clicked_no_signup' | 'abandoned_signup'
  leads: Array<{
    leadId: string
    email: string
    lastEventType: string
    lastEventDate: Date
    daysSinceLastEvent: number
  }>
}

export interface ABTestResult {
  campaignId: string
  variants: Array<{
    variantId: string
    sent: number
    opened: number
    clicked: number
    converted: number
    openRate: number
    clickRate: number
    conversionRate: number
  }>
  winner?: string
  confidence?: number
}

export interface SyncLeadsBulkToLemlistResult {
  successful: number
  failed: number
  results: Array<{
    leadId: string
    email: string
    success: boolean
    lemlistContactId?: string
    error?: string
  }>
}

// Lemlist webhook event types for email campaigns
export const LEMLIST_WEBHOOK_EVENT_TYPES = {
  // Email Events
  EMAILS_SENT: 'emailsSent',
  EMAILS_OPENED: 'emailsOpened',
  EMAILS_CLICKED: 'emailsClicked',
  EMAILS_REPLIED: 'emailsReplied',
  EMAILS_BOUNCED: 'emailsBounced',
  EMAILS_SEND_FAILED: 'emailsSendFailed',
  EMAILS_FAILED: 'emailsFailed',
  // Lemlist has NEVER sent this one — see LEMLIST_UNSUBSCRIBE_TYPES in constants.ts. Kept
  // declared in case that changes.
  EMAILS_UNSUBSCRIBED: 'emailsUnsubscribed',
  // The types lemlist actually sends when someone opts out.
  ENTITY_UNSUBSCRIBED: 'entityUnsubscribed',
  VARIABLE_UNSUBSCRIBED: 'variableUnsubscribed',
  EMAILS_INTERESTED: 'emailsInterested',
  EMAILS_NOT_INTERESTED: 'emailsNotInterested',

  // Lead Status Events
  CONTACTED: 'contacted',
  HOOKED: 'hooked',
  ATTRACTED: 'attracted',
  WARMED: 'warmed',
  INTERESTED: 'interested',
  SKIPPED: 'skipped',
  NOT_INTERESTED: 'notInterested',

  // Lead Management Events
  PAUSED: 'paused',
  RESUMED: 'resumed',

  // System Events
  CUSTOM_DOMAIN_ERRORS: 'customDomainErrors',
  CONNECTION_ISSUE: 'connectionIssue',
  SEND_LIMIT_REACHED: 'sendLimitReached',
  LEMWARM_PAUSED: 'lemwarmPaused',
  CAMPAIGN_COMPLETE: 'campaignComplete',

  // Other Events
  ANNOTATED: 'annotated',
  ENRICHMENT_DONE: 'enrichmentDone',
  ENRICHMENT_ERROR: 'enrichmentError'
} as const

export type LemlistWebhookEventType =
  (typeof LEMLIST_WEBHOOK_EVENT_TYPES)[keyof typeof LEMLIST_WEBHOOK_EVENT_TYPES]

// Webhook payload structure based on Lemlist docs
export interface LemlistWebhookPayload {
  _id: string
  type: LemlistWebhookEventType
  teamId: string
  createdAt?: string

  // Lead/Campaign info (when applicable)
  leadId?: string
  campaignId: string
  campaignName: string

  // Lead details
  email?: string
  firstName?: string
  lastName?: string
  companyName?: string
  phone?: string
  linkedinUrl?: string

  // Email event details
  messageId?: string
  subject?: string

  // Click event details
  url?: string

  // Opt-out events (entityUnsubscribed / variableUnsubscribed). `mutationAction` is the
  // durable signal — it says what happened regardless of which type name carried it.
  mutationAction?: 'unsubscribe' | 'subscribe'
  mutationType?: 'entity' | 'variables'
  /** Who triggered it: 'lead' when the recipient clicked unsubscribe, 'api' when we or a
   *  suppression import did. Both are real opt-outs. */
  unsubscribedSource?: string

  // Error details (for error events)
  error?: string
  errorMessage?: string

  // Additional metadata
  metadata?: Record<string, any>

  // Allow any additional custom fields at the root level
  [key: string]: any
}

// Webhook configuration
export interface LemlistWebhookConfig {
  targetUrl: string
  type?: LemlistWebhookEventType
  campaignId?: string
  isFirst?: boolean
  secret?: string
}

// Webhook response from API
export interface LemlistWebhook {
  _id: string
  targetUrl: string
  createdAt: string
  type?: LemlistWebhookEventType
  campaignId?: string
  zapId?: number
}


// From common/card-utils/src/types.ts



// Raw model values — limits in cents, exactly as stored. The one place these
// leave cents is `presentDebitCardInDollars` (listDebitCards.ts), applied only
// at the customer list edge (D1).
export interface DebitCardWithTruckCents
  extends Omit<DebitCard, 'banned_spend_category_mcc_ranges'> {
  banned_spend_categories: MccCategory[]
  // Null for business cards (no truck) — the schema has always been nullable
  truck: Truck | null
  address: Address
}

// Same shape, limits in dollars — the legacy client name. Structurally
// identical to DebitCardWithTruckCents (TS can't distinguish a "cents number"
// from a "dollars number"), which is exactly why some existing response
// shapes below still say `DebitCardWithTruck` while holding cents — a
// documented, deliberately untouched inconsistency (see the spec).
export type DebitCardWithTruck = DebitCardWithTruckCents

export enum CardControlsApiFlags {
  SpendAmount = 'spend_amount',
  SpendCategories = 'spend_categories'
}

export type SetCardSpendAmountControlsBody = {
  daily_spend_limit: number // Note, these should be in cents
  thirty_day_spend_limit: number // Note, these should be in cents
}

export type SetCardSpendCategoryControlsBody = {
  banned_spend_category_mcc_ranges: MccCategory[]
}

export type SetDebitCardControlsRequest =
  | {
      api_flag: CardControlsApiFlags.SpendAmount
      body: SetCardSpendAmountControlsBody
      // Set by async-aware clients (web). When absent/false the caller gets the legacy
      // synchronous 200 response; when true it gets the 202/409 async contract.
      is_web_client?: boolean
    }
  | {
      api_flag: CardControlsApiFlags.SpendCategories
      body: SetCardSpendCategoryControlsBody
      is_web_client?: boolean
    }

export interface SetDebitCardControlsNoChangeResponse {
  status: 'no_change'
  debit_card: DebitCardWithTruck
}

export interface SetDebitCardControlsStartedResponse {
  status: 'started' | 'already_running'
  workflow_id: string
  started_at: string
  // Included for backward compatibility with older mobile clients that read `debit_card`
  // from the set-controls response. Reflects the card's current (pre-reconcile) state.
  debit_card: DebitCardWithTruck
}

export type SetDebitCardControlsResponse =
  | SetDebitCardControlsNoChangeResponse
  | SetDebitCardControlsStartedResponse

export type CardControlsWorkflowStatus = 'idle' | 'running' | 'failed'

export type CardControlsErrorCode = 'PARTIAL_RECONCILE_FAILURE' | 'BP_API_TIMEOUT' | 'INTERNAL'

export interface GetDebitCardControlsStatusResponse {
  status: CardControlsWorkflowStatus
  workflow_id?: string
  started_at?: string
  failed_at?: string
  error?: {
    code: CardControlsErrorCode
    message: string
  }
}


// From common/temporal-utils/src/temporalTypes/debitCards.ts
// Discriminated on card_type; legacy clients omit it, which means a truck card.
// Each variant pins the other's field to `?: undefined` so callers can still read
// params.card_line_2 / params.truck_id without narrowing (both are `string | undefined`),
// while a caller building a business card need not spell out `truck_id: undefined`.
// Optional rather than required-undefined because the two are indistinguishable once the
// request is serialized — requiring the key only broke callers that send honest JSON.
export type CreateChildDebitCardForTruckWorkflowParams =
  | {
      card_type?: 'truck'
      account_id: string
      truck_id: string
      customer_id: string
      address_id: string
      card_line_2?: undefined
    }
  | {
      card_type: 'business'
      account_id: string
      truck_id?: undefined
      customer_id: string
      address_id: string
      // Optional second emboss line, printed under the business name.
      // Uppercase alphanumeric + space, max 20 chars (BP emboss limit).
      card_line_2?: string
    }

export interface FreezeUnfreezeChildDebitCardWorkflowParams {
  debit_card_id: string
  card_frozen: boolean
}

export interface CancelChildDebitCardWorkflowParams {
  debit_card_id: string
}

export interface GetChildDebitCardDetailsWorkflowParams {
  debit_card_id: string
}

export interface ReconcileDebitCardControlsWorkflowParams {
  debit_card_id: string
  bp_customer_id: string
  bp_card_id: string
  // String values from the MccCategory enum (e.g., 'Adult Entertainment').
  // Kept as string[] here because temporal-utils cannot import from
  // types-and-constants (cross-common imports break yarn install).
  goal_categories: string[]
  // Always populated by the calling Lambda. If the user did not change a
  // limit, the Lambda passes the current value.
  goal_daily_spend_limit_in_cents: number
  goal_thirty_day_spend_limit_in_cents: number
  // Used by the workflow to skip BP calls when a limit didn't change.
  current_daily_spend_limit_in_cents: number
  current_thirty_day_spend_limit_in_cents: number
}


// From common/card-utils/src/errors.ts
export type CardErrorKind =
  | 'not_found'
  | 'cancelled'
  | 'bad_reference'
  | 'capacity'
  | 'rate_limited'
  | 'already_running'
  | 'unknown'

export interface CardErrorClassification {
  kind: CardErrorKind
  message: string
  field?: string
}


// From common/payment-utils/src/initiateWithdrawal.ts
export interface InitiateWithdrawalParams {
  amount: number // integer cents
  linked_account_id: string
  internal_bank_account_id: string
  customer_id: string
}

export interface InitiateScheduledWithdrawalParams {
  customer_id: string
  internal_bank_account_id: string
  linked_account_id: string
  scheduled_withdrawal_id: string
  occurrence_date: string // DATEONLY; with the schedule id, forms the D4 workflowId
  amount_type: ScheduledWithdrawalAmountType
  configured_amount_in_cents: number | null // fixed mode only; null for bucket_balance
  source_bucket_category: string | null
  category_display_name: string | null // custom-bucket display name, for the ACH memo
  label: string | null // customer free text — in-app description only, never on the wire
}

export type InitiateWithdrawalResult =
  | {
      status: 'success'
      pending_transaction_id: string
      withdrawn_in_cents: number
      remaining_balance_in_cents: number
    }
  | {
      status: 'partial'
      pending_transaction_id: string
      requested_in_cents: number
      withdrawn_in_cents: number
      remaining_balance_in_cents: number
    }
  /**
   * Nothing moved. `available_in_cents` is the amount we actually resolved before deciding
   * it was under the floor — the card's available balance for `below_partial_floor`, the
   * capped bucket draw for `below_bucket_floor`. It exists so the skip notification can
   * answer the customer's first question ("how much did I have?") instead of just telling
   * them it failed. It can be negative (an over-reserved card); clamp at the display layer,
   * not here, so the logged value stays honest.
   */
  | {
      status: 'skipped'
      reason: 'below_partial_floor' | 'below_bucket_floor'
      available_in_cents: number
    }
  /**
   * A bucket_balance schedule whose source bucket no longer exists. Nothing moved, and nothing
   * ever can: the bucket IS this schedule's amount. The occurrence child pauses the schedule
   * on this (spec D11 — the runner owns that rule, not the code paths that delete buckets).
   *
   * Its own status rather than a `skipped` reason on purpose. `skipped` means "the customer's
   * balance was short" and drives the insufficient-funds notification, which here would say
   * "only $0.00 was available" — false, and repeated every occurrence forever. A distinct
   * status also makes every exhaustive consumer handle it instead of inheriting skip
   * behavior by default.
   */
  | { status: 'source_bucket_missing' }
  /**
   * This occurrence's triggerPayment already exists (running or completed) — a prior
   * attempt moved the money. Deliberately carries NO amounts: this attempt resolved
   * nothing, and inventing numbers here is how the pre-fix code lied
   * (`withdrawn_in_cents` describing an attempt that moved nothing). Callers treat it as
   * silent success — attempt #1's pending row already tells the customer the true story.
   * Produced by the pre-resolution probe (retries) or the D4 gate catch (races).
   */
  | { status: 'already_initiated' }


// Constants
// From common/types-and-constants/src/constants/ach.ts
// NACHA ACH return codes we surface from Sila (on debit pulls and credit pushes). Not exhaustive —
// the consumer-relevant subset we act on or report. Values are the raw codes Sila puts in
// `return_code`, so `someCode === AchReturnCode.R02` and switch(return_code) both work directly.
// General (used by deposits + withdrawals), so it lives here rather than in the deposits constants.
export enum AchReturnCode {
  R01 = 'R01', // Insufficient funds
  R02 = 'R02', // Account closed
  R03 = 'R03', // No account / unable to locate account
  R04 = 'R04', // Invalid account number
  R05 = 'R05', // Unauthorized debit to consumer account (corporate SEC code)
  R06 = 'R06', // Returned at ODFI's request
  R07 = 'R07', // Authorization revoked by customer
  R08 = 'R08', // Payment stopped
  R09 = 'R09', // Uncollected funds
  R10 = 'R10', // Customer advises originator not authorized
  R11 = 'R11', // Customer advises entry not in accordance with the terms of the authorization
  R16 = 'R16', // Account frozen
  R20 = 'R20', // Non-transaction account
  R29 = 'R29' // Corporate customer advises not authorized
}

// Human-readable description per code — for ops alerts, audit, and customer-facing copy.
export const ACH_RETURN_CODE_DESCRIPTIONS: Record<AchReturnCode, string> = {
  [AchReturnCode.R01]: 'Insufficient funds',
  [AchReturnCode.R02]: 'Account closed',
  [AchReturnCode.R03]: 'No account / unable to locate account',
  [AchReturnCode.R04]: 'Invalid account number',
  [AchReturnCode.R05]: 'Unauthorized debit to consumer account',
  [AchReturnCode.R06]: "Returned at ODFI's request",
  [AchReturnCode.R07]: 'Authorization revoked by customer',
  [AchReturnCode.R08]: 'Payment stopped',
  [AchReturnCode.R09]: 'Uncollected funds',
  [AchReturnCode.R10]: 'Customer advises not authorized',
  [AchReturnCode.R11]: 'Customer advises entry not in accordance with authorization terms',
  [AchReturnCode.R16]: 'Account frozen',
  [AchReturnCode.R20]: 'Non-transaction account',
  [AchReturnCode.R29]: 'Corporate customer advises not authorized'
}

// Safe lookup for a raw code string (Sila may send a code outside the subset above).
export function getAchReturnCodeDescription(code: string | null | undefined): string {
  if (!code) return 'Unknown return'
  return ACH_RETURN_CODE_DESCRIPTIONS[code as AchReturnCode] ?? code
}

// Customer-facing copy for a failed deposit, by return code — friendlier + actionable than the
// ops-facing descriptions above. (Draft — review tone with marketing/compliance before enabling.)
// Consistency rule: any code below that tells the customer to "add a different account" must also be
// in ACH_RETURN_CODE_TO_DEBIT_DISABLE_REASON (temporal processSilaTransactionStatusUpdate.ts) so the
// account is disabled and they can't retry straight back into it. (The map can't live here because it
// targets rds-utils' DebitDisabledReason and types-and-constants can't depend on rds-utils.)
export const ACH_RETURN_CODE_CUSTOMER_COPY: Partial<Record<AchReturnCode, string>> = {
  [AchReturnCode.R01]:
    'Your bank reported insufficient funds. Please check your balance and try again.',
  [AchReturnCode.R09]:
    'Your bank reported insufficient available funds. Please try again in a little while.',
  [AchReturnCode.R02]: 'That bank account appears to be closed. Please add a different account.',
  [AchReturnCode.R03]:
    "We couldn't locate that bank account. Please re-link it or add a different account.",
  [AchReturnCode.R04]: 'That account number appears to be invalid. Please re-link your account.',
  [AchReturnCode.R07]:
    'Authorization for that account was revoked. Please add a different account.',
  [AchReturnCode.R08]: 'A stop payment was placed on this transfer. Please contact your bank.',
  [AchReturnCode.R10]:
    'Your bank flagged this transfer as unauthorized. Please add a different account.',
  [AchReturnCode.R29]:
    'Your bank flagged this transfer as unauthorized. Please add a different account.',
  [AchReturnCode.R16]: 'That bank account is frozen. Please add a different account.',
  [AchReturnCode.R20]: "That account type can't accept this transfer. Please use a checking account."
}

// Customer-facing failure message for a raw return code, with a safe generic fallback.
export function getDepositFailureCustomerMessage(code: string | null | undefined): string {
  const fallback =
    "We couldn't complete your deposit. Please try again or use a different account."
  if (!code) return fallback
  return ACH_RETURN_CODE_CUSTOMER_COPY[code as AchReturnCode] ?? fallback
}


// From common/types-and-constants/src/constants/addresses.ts
// Maximum number of addresses per customer
export const MAX_ADDRESSES_PER_CUSTOMER = 20

/**
 * Splits a one-line street address into the house number and the street name, which
 * we store in separate columns (`address_st_number` / `address_st_name`).
 *
 * Group 1 is the number ("123", "123A", "123-1"), group 2 the rest. Deliberately
 * strict: the number must be followed by whitespace AND a non-empty remainder, so
 * "1st Avenue" does NOT parse as number "1" + street "st Avenue". Anything that does
 * not match is left whole in the street name (THT-711).
 */
export const STREET_NUMBER_PATTERN = /^(\d+(?:[-/]\d+)?[A-Za-z]?)\s+(.+)$/


// From common/types-and-constants/src/constants/adminPortal.ts
/**
 * Deep links into the tach-admin portal.
 *
 * Backend alerts (Slack, email) routinely need to hand a human the exact admin page
 * for a record. Only the ROUTE lives here — the origin comes from `getAdminPortalUrl`
 * (`src/functions/urls.ts`), which is the single source of truth for admin hosts, so a
 * domain change stays a one-line edit in one file.
 */

/**
 * Admin portal customer-detail route, keyed on `customer_id`
 * (tach-admin `/dashboard/users/:userType/:userId`).
 */
export const ADMIN_PORTAL_CUSTOMER_PATH = '/dashboard/users/customer'

/**
 * Query string that lands the admin on the customer-detail page's Banking tab
 * (tach-admin `UserDetails` reads `?tab=`). Alerts that ask a human to check a
 * carrier's deposit history link straight to it rather than to the default
 * Details tab.
 */
export const ADMIN_PORTAL_BANKING_TAB_QUERY = '?tab=banking'


// From common/types-and-constants/src/constants/budgeting.ts


// source - https://www.ttnews.com/articles/nacfe-study-shows-flat-fuel-economy-class-8-vehicles-surveyed
export const heavyDutyMilesPerGallon = 6.24

// Source - NPTC 2024 Benchmarking Survery Report
export const mediumDutyMilesPerGallon = 8.23

// Source - https://www.fjvans.com/sprinter-van-mpg-ratings and https://www.fuelly.com/car/mercedes-benz/sprinter
export const lightDutyMilesPerGallon = 18.0

// source - https://www.eia.gov/petroleum/gasdiesel/
// Should really build a service that gets this value updated often
export const averageCostOfDieselPerGallon = 3.85

// source - Scott!
export const averageCostOfPMForHeavyDutyTruck = 700

// source - Scott!
export const averageCostOfPMForMediumDutyTruck = 500

// source - https://www.mbprinceton.com/service/service-parts-tips/mercedes-benz-sprinter-maintenance-schedule
// Average of Service A and B
export const averageCostOfPMForLightDutyTruck = 450

// source - Scott!
export const averageCostOfPMForTrailer = 150

// Source - Scott!
export const numberOfTrailerPMsPerYear = 2

// Source - CHATGPT 5
export const highCostPerMileForTrucksThreshold = 1.5

// Source - Scott!
export const numberOfMilesPerPM = 25000

// Source - https://mytourig.com/what-you-need-to-know-about-service-a-and-service-b-maintenance-for-sprinter-vans
export const numberOfMilesPerPMForLightDuty = 10000

// Source - ATRI 2023 Operational Cost of Trucking Report
export const dollarsPerMileForTolls = 0.028

// Source - ATRI 2023 Operational Cost of Trucking Report
export const dollarsPerMileForLicensing = 0.015

// Source - NPTC 2024 Benchmarking Survery Report
// Averages the numbers from 2020 thru 2024 bc 2024 had an outlier-like upswing
export const averageNumberOfBreakdownsPer100ThousandMilesHeavyDuty = 4.06

// Source - NPTC 2024 Benchmarking Survery Report
// Scott said to up it to 2500 from 1262
export const averageCostPerRepair = 2500 // 1262

// Source - NPTC 2024 Benchmarking Survery Report
// Averages 2021 thru 2024 bc 2024 number also seemed off
export const averageNumberOfBreakdownsPer100ThousandMilesMediumDuty = 1.78

// Source - https://caredge.com/mercedes-benz/sprinter-2500/maintenance
// Driving 25k miles per year + cost per repair aligns with expected costs by year 4/5
export const averageNumberOfBreakdownsPer100ThousandMilesLightDuty = 1.1

export interface BudgetItemConfig {
  category: string
  category_description: string
  category_display_name: string
  time_window_in_months: number
  emoji_unicode: string
}

export const defaultBudgetItemsConfig = {
  fuel: {
    category: 'fuel',
    category_description:
      'Expenses related to refueling trucks during transportation or delivery routes',
    category_display_name: 'Fuel',
    time_window_in_months: 1,
    emoji_unicode: 'U+26FD' // Fuel pump
  },
  preventative_maintenance: {
    category: 'preventative_maintenance',
    category_description:
      'Routine maintenance costs aimed at preventing breakdowns, such as oil changes, filter replacements, and inspections to keep trucks in good working condition',
    category_display_name: 'PMs',
    time_window_in_months: 3,
    emoji_unicode: 'U+1F527' // Wrench
  },
  tires: {
    category: 'tires',
    category_description:
      'Costs associated with purchasing, maintaining, or replacing tires for trucks, including tire rotations or alignment services',
    category_display_name: 'Tires',
    time_window_in_months: 12,
    emoji_unicode: 'U+1F6DE' // Tires
  },
  repairs: {
    category: 'repairs',
    category_description:
      'Expenses related to fixing or repairing any broken or malfunctioning parts of the truck, including engine, brakes, or transmission issues',
    category_display_name: 'Repairs & Parts',
    time_window_in_months: 12,
    emoji_unicode: 'U+1F6E0' // Wrench and hammer
  },
  insurance: {
    category: 'insurance',
    category_description:
      'Regular payments for insurance coverage related to trucks, cargo, or liability protection required for operating the trucking business',
    category_display_name: 'Insurance',
    time_window_in_months: 1,
    emoji_unicode: 'U+1F6E1' // Shield
  },
  truck_payments: {
    category: 'truck_payments',
    category_description:
      'Installment payments or leasing costs for purchasing or leasing trucks used in the business',
    category_display_name: 'Truck Payments',
    time_window_in_months: 1,
    emoji_unicode: 'U+1F69A' // Truck
  },
  licensing: {
    category: 'licensing',
    category_description:
      'Fees related to obtaining or renewing permits, registrations, or licenses required for legal operation of trucks, including vehicle registration or driver certifications',
    category_display_name: 'Licensing & Fees',
    time_window_in_months: 12,
    emoji_unicode: 'U+1F4C4' // Document
  },
  tolls: {
    category: 'tolls',
    category_description:
      'Expenses incurred from toll roads or highways used during trucking operations for transportation or delivery route',
    category_display_name: 'Tolls',
    time_window_in_months: 12,
    emoji_unicode: 'U+1F6E3' // Highway
  }
} as const satisfies Record<string, BudgetItemConfig>

// Type-safe static budget category type derived from the config
export type StaticBudgetCategory = keyof typeof defaultBudgetItemsConfig

// Array of static budget category keys for iteration
export const STATIC_BUDGET_CATEGORIES = Object.keys(
  defaultBudgetItemsConfig
) as StaticBudgetCategory[]

// Helper to check if a category is a static budget category.
// Own-property check, not `in`: `in` walks the prototype chain, so 'toString'/'constructor'
// would pass and callers indexing the config would get Object.prototype members instead of
// bucket config. Same bug class as PR #1657 (Sequelize instances) — check ownership/value,
// not key reachability. (hasOwnProperty.call rather than Object.hasOwn: sibling common
// packages type-check these sources laterally under tsconfig libs older than ES2022.)
export const isStaticBudgetCategory = (category: string): category is StaticBudgetCategory => {
  return Object.prototype.hasOwnProperty.call(defaultBudgetItemsConfig, category)
}

// Helper to check if a category is a custom budget category
export const isCustomBudgetCategory = (category: string): boolean => {
  return category.startsWith('custom_')
}

// Maximum number of custom budget categories a customer may create.
// Introduced as 5 in PR #186; the THT-750 spec attributes the decision to THT-123.
// Deliberate either way — change the value only with product sign-off.
export const MAX_CUSTOM_BUDGET_ITEMS = 5

// Upper bound for BudgetItems.admin_scale_bps: 50,000 bps = a 5x scale on the system
// recommendation (decided 2026-09-04). Zero is a valid value — the admin "None" dial is a
// designed zero-target state — and null means no scaling; it is negative, fractional, NaN,
// and absurd values that must never reach the resolver, where Math.max(0, ...) would turn a
// negative into a stealth disable and NaN would poison the proportional-share arithmetic.
export const MAX_ADMIN_SCALE_BPS = 50_000

// Wire format for BudgetItems.emoji_unicode: one or more `U+XXXX` codepoints joined by
// single spaces, exactly what the web and mobile clients send and what existing rows store.
// A single codepoint covers most emoji (💰 = `U+1F4B0`), but variation selectors
// (❤️ = `U+2764 U+FE0F`), skin-tone modifiers and ZWJ sequences
// (👷‍♂️ = `U+1F477 U+200D U+2642 U+FE0F`) are multi-codepoint — THT-750.
//
// Anchored and space-strict on purpose: leading, trailing or repeated spaces are rejected so
// the stored value round-trips back to the same emoji.
//
// Case-insensitive, but NOT because a client sends lowercase — both build the value with
// `.toString(16).toUpperCase()`, so every value we receive from the pickers is uppercase. It is
// permissive for values that don't come from a picker (manual rows, backfills, future writers).
// Accepting either case is safe only because writers normalize before persisting — see
// normalizeEmojiUnicode below. Read this pattern as "what we'll take", not "what we store".
//
// 1-6 hex digits, NOT 4-6: both clients build this with `codePointAt(0).toString(16)` and do
// NOT zero-pad, so low codepoints arrive short. Keycap emoji (1️⃣ = `U+31 U+FE0F U+20E3`) and
// ©️ / ®️ (`U+A9 U+FE0F`) are all selectable in the emoji picker and were 400ing under a
// 4-digit minimum.
//
// Note the upper bound is loose: 6 hex digits admits values above U+10FFFF, which is not a
// codepoint at all. This is a FORMAT check, not a codepoint-range check — callers must not read
// a match as "renderable". `String.fromCodePoint(0xFFFFFF)` throws a RangeError rather than
// degrading, so an out-of-range value is only safe in front of a decoder that range-filters
// before rendering (the THT-750 client decoders do; older ones throw and take the screen down).
//
// The range IS expressible without hurting readability, and tightening it here would remove that
// caveat entirely:
//   /^U\+(?:10[0-9A-F]{4}|[0-9A-F]{1,5})(?: U\+(?:10[0-9A-F]{4}|[0-9A-F]{1,5}))*$/i
// Deliberately not adopted in THT-750: it narrows what the endpoint accepts, which is a contract
// change this ticket didn't scope. Left as a follow-up.
//
// Exported as a SOURCE STRING as well as a RegExp because the OpenAPI/Swagger definition in
// `type-utils/src/swagger-generator.ts` publishes this same rule as a JSON Schema `pattern`,
// which is flagless ECMA-262 — there is nowhere to put an `i`. So the case variants are spelled
// out in the character classes rather than carried by a flag, letting both consumers share one
// string. Hardcoding the pattern in the generator is what let it drift to the old
// single-codepoint form (THT-750 review); import it instead.
const EMOJI_CODEPOINT_SOURCE = '[Uu]\\+[0-9A-Fa-f]{1,6}'

export const EMOJI_UNICODE_PATTERN_SOURCE = `^${EMOJI_CODEPOINT_SOURCE}(?: ${EMOJI_CODEPOINT_SOURCE})*$`

export const EMOJI_UNICODE_PATTERN = new RegExp(EMOJI_UNICODE_PATTERN_SOURCE)

// Max accepted length of an `emoji_unicode` value. `BudgetItems.emoji_unicode` is a
// VARCHAR(255) (Sequelize DataTypes.STRING), and EMOJI_UNICODE_PATTERN allows unbounded
// repetition — without this cap an over-long but well-formed value passes validation and then
// blows up at INSERT time as a 500 instead of a 400. The longest real emoji we ship is a 7-
// codepoint ZWJ family sequence (~58 chars), so 100 leaves plenty of headroom.
export const MAX_EMOJI_UNICODE_LENGTH = 100

// Canonical stored form of an `emoji_unicode` value. EMOJI_UNICODE_PATTERN accepts either case so
// a non-picker writer (manual row, backfill) isn't rejected, but everything we PERSIST is
// uppercase — a lowercase row is only renderable in front of a decoder that strips the prefix
// case-insensitively (`/^U\+/i`), and the older `.replace('U+', '')` form parses `u+1f4b0` to NaN
// and throws a RangeError on render. Normalizing on write means no consumer ever has to care.
//
// Deliberately not joi's `.uppercase()`: both budget-item schemas are `.strict(true)`, which turns
// conversion off and makes `.uppercase()` an assertion that REJECTS lowercase rather than fixing
// it. The handlers also discard joi's converted value and re-parse the raw body, so a conversion
// there would be dropped on the floor. The write sites are the honest place for this.
export const normalizeEmojiUnicode = (emojiUnicode: string): string => emojiUnicode.toUpperCase()

// System-managed budget items are created and maintained by the system, not the customer.
// They cannot be deleted, renamed, or have their amounts edited by the customer.
// Currently the only system-managed bucket is Net Take Home Pay (NTHP), which holds
// take-home pay that has not yet been swept to the customer's linked external account.
//
// The NTHP category string itself ('net_take_home_pay') is exported as
// NET_TAKE_HOME_PAY_CATEGORY from rds-utils/src/types/netTakeHomePay.ts so it can be
// used by migrations and activities in that package. Importing it from there avoids
// duplicate-declaration errors during type-utils generation. Use the rds-utils export
// from any non-common package; from inside types-and-constants we inline the literal.
export const defaultSystemManagedBudgetItemsConfig = {
  net_take_home_pay: {
    category: 'net_take_home_pay',
    category_description:
      'System-managed bucket holding take-home pay that has not been swept to your linked external account.',
    category_display_name: 'Net Take Home Pay',
    time_window_in_months: 1,
    emoji_unicode: 'U+1F4B5' // Dollar bill
  }
} as const satisfies Record<string, BudgetItemConfig>

// Type-safe system-managed budget category type derived from the config
export type SystemManagedBudgetCategory = keyof typeof defaultSystemManagedBudgetItemsConfig

// Array of system-managed budget category keys for iteration
export const SYSTEM_MANAGED_BUDGET_CATEGORIES = Object.keys(
  defaultSystemManagedBudgetItemsConfig
) as SystemManagedBudgetCategory[]

// Helper to check if a category is a system-managed budget category.
// Use this in any handler that mutates BudgetItems to reject system-managed categories.
// Own-property check, not `in` — same prototype-chain reasoning as isStaticBudgetCategory above.
export const isSystemManagedBudgetCategory = (
  category: string
): category is SystemManagedBudgetCategory => {
  return Object.prototype.hasOwnProperty.call(defaultSystemManagedBudgetItemsConfig, category)
}

export const dollarsPerMileForTires = {
  trucks: {
    heavyDuty: {
      premium: 0.0155,
      budget: 0.0222
    },
    mediumDuty: 0.0125,
    lightDuty: 0.0105
  },
  trailers: {
    premium: 0.0195,
    budget: 0.0278
  }
}

/**
 * The fleet we assume when a customer has no trucks on file.
 *
 * Budgeting reads exactly seven fields off a truck and four off a trailer; everything else on the
 * models (VIN, make, model, odometer) is invisible to it. These are those fields and nothing more,
 * so an assumed asset is a throwaway object built at the top of the budget run and never saved.
 *
 * Shared by two callers, deliberately: the prequal estimate and the no-assets-on-file budget. Two
 * sets of "what an average truck costs" would drift apart, and the prequal numbers were already
 * stale (100k miles and a $2,000/mo payment on a truck it also called owned).
 *
 * `pay_for_repairs` is the load-bearing one — `false` silently zeroes preventative maintenance,
 * repairs AND tires, which would look like a working budget that happens to be small.
 */
export const assumedOwnedTruckProfile = {
  truck_class: TruckClassCategories.HeavyDuty,
  truck_class_number: 8, // Class 8; HeavyDuty covers 7 and 8, and this picks the one we mean.
  typical_annual_mileage: 85000,
  tire_brand_quality: TireBrandQuality.Premium,
  pay_for_repairs: true,
  ownership_status: OwnershipStatus.Owned,
  engine_condition: EngineCondition.Unmodified,
  /**
   * MONTHLY, in dollars — `calculateAnnualInsuranceBudget` multiplies by 12. This is a whole-rig
   * policy (auto liability, cargo, physical damage), which is how an owner-operator actually buys
   * insurance, and it is why the trailer profile below carries none: the trailer is covered here.
   */
  insurance_payment_amount: 2000,
  // Assumed owned outright. A financed truck is a real truck someone entered.
  truck_payment_amount: 0
} as const

/**
 * A term-leased assumed truck. Only reachable from prequal, which knows the owned/leased split;
 * `asset_summary` does not carry one, so the no-assets path builds owned trucks exclusively.
 *
 * Leasing inverts two of the assumptions above: the lessor carries the maintenance, and there is
 * a payment by definition.
 */
export const assumedLeasedTruckProfile = {
  ...assumedOwnedTruckProfile,
  ownership_status: OwnershipStatus.Leased,
  pay_for_repairs: false,
  truck_payment_amount: 2000
} as const

/**
 * The assumed trailer. No insurance line — see `assumedOwnedTruckProfile.insurance_payment_amount`.
 *
 * A trailer contributes $300/yr of PM plus a share of the tire budget. Note that share does not
 * scale with count: `calculateAnnualTiresBudget` divides the trucks' total mileage across however
 * many trailers there are, so one trailer and four cost the same in tires.
 */
export const assumedOwnedTrailerProfile = {
  tire_brand_quality: TireBrandQuality.Premium,
  pay_for_repairs: true,
  ownership_status: OwnershipStatus.Owned,
  insurance_payment_amount: 0,
  trailer_payment_amount: 0
} as const

export const assumedLeasedTrailerProfile = {
  ...assumedOwnedTrailerProfile,
  ownership_status: OwnershipStatus.Leased,
  pay_for_repairs: false,
  trailer_payment_amount: 1500
} as const

/**
 * A carrier with no power unit is not operating, so a declared zero is read as an owner-operator
 * rather than as an empty fleet. One truck is also the median prod fleet size.
 *
 * This floor is unconditional — a declared zero, a null `asset_summary`, and a customer with no
 * application row all land here. There is no path through budget initialization that produces a
 * zero-truck budget.
 */
export const assumedMinimumTruckCount = 1

/**
 * Ceiling on the assumed fleet. Nothing validates the signup input — it is a bare number field —
 * and the count multiplies straight into every mileage-driven bucket, so a typo'd 500 would
 * produce a ~$46M budget and start sweeping deposits against it. The largest real fleet in prod
 * is 23 trucks; anything above this is a data-entry accident, and we warn and clamp rather than
 * refusing to budget at all.
 */
export const assumedMaximumTruckCount = 25

/**
 * Ceiling on assumed trailers, for the same reason as the truck ceiling — but higher, because a
 * trailer count legitimately exceeds a truck count. Drop-and-hook carriers run two or three
 * trailers per power unit, so clamping trailers at the truck ceiling would cut real fleets.
 *
 * Each assumed trailer adds $300/yr of preventative maintenance to a bucket the deposit waterfall
 * sweeps against, and one Sequelize model retained in workflow memory and history, so this is
 * bounded rather than trusted.
 */
export const assumedMaximumTrailerCount = 50


// From common/types-and-constants/src/constants/businessIdentity.ts
/**
 * Shared EIN validation. Single source of truth for the format our request schemas
 * accept, so a malformed EIN is rejected at the edge instead of surfacing days later
 * as a failed Sila registration (`prepareRegistrationParams` in common/sila-utils
 * strips the dash and requires exactly 9 digits — NODE-AWSLAMBDA-184).
 *
 * Both shapes our clients send are valid:
 *   - `12-3456789` — carrier signup (tach-ui, tach-mobile) and the admin portal
 *   - `123456789`  — vendor signup (tach-ui VendorBusinessDetails)
 */
export const EIN_PATTERN = /^\d{2}-?\d{7}$/

/**
 * joi's default `string.pattern.base` message interpolates the whole regex, and the
 * handlers return `error.message` verbatim in the 400 body — so a mistyped EIN would
 * read `... fails to match the required pattern: /^\d{2}-?\d{7}$/`. Shared by every
 * schema that validates an EIN so the wording can't drift (see budget-items for the
 * same treatment, THT-750).
 */
export const EIN_VALIDATION_MESSAGES = {
  'string.pattern.base': '"employer_id_number" must be a 9-digit EIN, e.g. "12-3456789"'
}


// From common/types-and-constants/src/constants/cardControls.ts
export enum MccCategory {
  AdultEntertainment = 'Adult Entertainment',
  AdvertisingServices = 'Advertising Services',
  AgriculturalServices = 'Agricultural Services',
  AirlinesAndAirCarriers = 'Airlines & Air Carriers',
  Airports = 'Airports',
  AmbulanceServices = 'Ambulance Services',
  AmusementParks = 'Amusement Parks & Circuses',
  AntiquesAndUsedMerchandise = 'Antiques & Used Merchandise',
  ArtDealersAndGalleries = 'Art Dealers & Galleries',
  AutoDealers = 'Auto, Boat & RV Dealers',
  AutomotiveFuel = 'Automotive Fuel',
  AutomotivePartsAndAccessories = 'Auto Parts & Accessories',
  AutomotiveRepair = 'Automotive Repair',
  BarsAndDrinkingPlaces = 'Bars & Drinking Places',
  BeautyAndBarberShops = 'Beauty & Barber Shops',
  BicycleShops = 'Bicycle Shops',
  BoatRentalsAndMarinas = 'Boat Rentals & Marinas',
  Bookstores = 'Bookstores',
  BowlingAlleys = 'Bowling Alleys',
  BuildingMaterialsAndHardware = 'Building Materials & Hardware',
  BusLines = 'Bus Lines',
  BusinessServices = 'Business Services',
  CableSatelliteAndStreaming = 'Cable, Satellite & Streaming',
  CameraAndPhoto = 'Camera & Photo',
  CarRentals = 'Car Rentals',
  CharitableOrganizations = 'Charitable Organizations',
  ChildcareServices = 'Childcare Services',
  CigarAndTobaccoStores = 'Cigar & Tobacco Stores',
  ClothingAndApparel = 'Clothing & Apparel',
  ComputerProgrammingAndIT = 'Computer Programming & IT',
  ConstructionContractors = 'Construction Contractors',
  CosmeticStores = 'Cosmetic Stores',
  CounselingServices = 'Counseling Services',
  CruiseLines = 'Cruise Lines',
  DanceStudiosAndHalls = 'Dance Studios & Halls',
  DepartmentAndDiscountStores = 'Department & Discount Stores',
  DigitalGoods = 'Digital Goods',
  DirectMarketing = 'Direct Marketing',
  DryCleaningAndLaundry = 'Dry Cleaning & Laundry',
  Education = 'Schools & Education',
  ElderCare = 'Nursing & Elder Care',
  ElectronicsStores = 'Electronics Stores',
  EntertainmentVenues = 'Entertainment & Recreation',
  EquipmentRentalAndLeasing = 'Equipment, Tool & Appliance Rental',
  FastFood = 'Fast Food',
  FinancialInstitutions = 'Financial Institutions',
  Florists = 'Florists',
  FuneralServices = 'Funeral Services',
  FurnitureAndHomeFurnishings = 'Furniture & Home Furnishings',
  Gambling = 'Gambling & Betting',
  GiftAndNoveltyShops = 'Gift & Novelty Shops',
  GolfAndCountryClubs = 'Athletic Clubs & Country Clubs',
  GovernmentServices = 'Government Services',
  GroceryAndSupermarkets = 'Grocery & Supermarkets',
  GunsAndAmmunition = 'Guns & Ammunition',
  HealthAndBeautySpas = 'Health & Beauty Spas',
  HealthServices = 'Health Services',
  HobbyToysAndGames = 'Hobby, Toys & Games',
  HotelsAndLodging = 'Hotels & Lodging',
  Insurance = 'Insurance',
  JewelryAndWatches = 'Jewelry & Watches',
  Landscaping = 'Landscaping & Horticultural',
  LegalAndAccounting = 'Legal & Accounting',
  LiquorStores = 'Liquor Stores',
  LuggageAndLeather = 'Luggage & Leather Goods',
  Marketplaces = 'Online Marketplaces',
  MedicalEquipment = 'Medical Equipment & Supplies',
  MembershipOrganizations = 'Membership Organizations',
  MiscellaneousRetail = 'Miscellaneous & Specialty Retail',
  MoneyTransfer = 'Money Transfer',
  MusicStores = 'Music Stores',
  NewsDealers = 'News Dealers & Newsstands',
  ParkingAndTolls = 'Parking & Tolls',
  PassengerRailAndTransit = 'Passenger Rail & Commuter Transit',
  PawnShops = 'Pawn Shops',
  PetShopsAndSupplies = 'Pet Shops & Supplies',
  PharmaciesAndDrugs = 'Pharmacies & Drug Stores',
  ProfessionalServices = 'Professional Services',
  PublishingAndPrinting = 'Publishing & Printing',
  ReligiousGoods = 'Religious Goods Stores',
  RepairServices = 'Repair Services',
  RestaurantsAndDining = 'Restaurants & Dining',
  SecurityServices = 'Security & Detective Services',
  ShippingAndCourier = 'Shipping, Freight & Courier',
  SpecialtyFoodStores = 'Specialty Food Stores',
  SportingGoods = 'Sporting Goods',
  StampAndCoin = 'Stamp & Coin Stores',
  StationeryAndOffice = 'Stationery & Office Supplies',
  StorageFacilities = 'Storage Facilities',
  TattooAndPiercing = 'Personal Services (Tattoo, Grooming, Misc)',
  TaxisAndRideshare = 'Taxis & Rideshare',
  Telecommunications = 'Telecommunications',
  TouristAttractions = 'Tourist Attractions',
  TransportationServices = 'Transportation Services',
  TravelAgencies = 'Travel Agencies',
  Utilities = 'Utilities',
  VeterinaryServices = 'Veterinary Services',
  WholesaleDistributors = 'Wholesale Distributors (B2B)'
}

// Older mobile clients (deployed before the MCC taxonomy was expanded) send category string
// values that no longer exist in MccCategory. Map each legacy value to its closest current
// equivalent(s) so their card-control requests keep working until the client catches up.
// Keys are the legacy string values; only values still missing from MccCategory are listed
// (values that survived unchanged validate on their own and don't need an alias).
export const LEGACY_MCC_CATEGORY_ALIASES: Readonly<Record<string, readonly MccCategory[]>> = {
  'Advertising & Marketing': [MccCategory.AdvertisingServices, MccCategory.DirectMarketing],
  Agriculture: [MccCategory.AgriculturalServices],
  'Airlines & Travel': [MccCategory.AirlinesAndAirCarriers, MccCategory.Airports],
  'Amusement Parks': [MccCategory.AmusementParks],
  'Auto Dealers': [MccCategory.AutoDealers],
  'Automotive Repairs': [MccCategory.AutomotiveRepair],
  'Beverage Stores': [MccCategory.LiquorStores],
  'Building Materials': [MccCategory.BuildingMaterialsAndHardware],
  'Charity & Donations': [MccCategory.CharitableOrganizations],
  'Childcare & Daycare': [MccCategory.ChildcareServices],
  Construction: [MccCategory.ConstructionContractors],
  'Consulting Services': [MccCategory.BusinessServices],
  'Contractors & Repairs': [MccCategory.ConstructionContractors, MccCategory.RepairServices],
  'Cruises & Resorts': [MccCategory.CruiseLines],
  Education: [MccCategory.Education],
  'Elder Care': [MccCategory.ElderCare],
  'Electronics & Appliances': [MccCategory.ElectronicsStores],
  Entertainment: [MccCategory.EntertainmentVenues],
  'Event Ticketing': [MccCategory.EntertainmentVenues],
  'Fitness & Gyms': [MccCategory.GolfAndCountryClubs],
  'Florists & Gifts': [MccCategory.Florists, MccCategory.GiftAndNoveltyShops],
  'Furniture & Decor': [MccCategory.FurnitureAndHomeFurnishings],
  'Gaming & Casinos': [MccCategory.Gambling],
  Gambling: [MccCategory.Gambling],
  'IT & Software': [MccCategory.ComputerProgrammingAndIT],
  Landscaping: [MccCategory.Landscaping],
  'Legal Services': [MccCategory.LegalAndAccounting],
  'Medical Equipment': [MccCategory.MedicalEquipment],
  'Office Supplies': [MccCategory.StationeryAndOffice],
  'Pet Supplies': [MccCategory.PetShopsAndSupplies],
  'Pharmacies & Drugs': [MccCategory.PharmaciesAndDrugs],
  'Security Services': [MccCategory.SecurityServices],
  'Shipping & Freight': [MccCategory.ShippingAndCourier],
  'Social Services': [MccCategory.CounselingServices],
  'Tattoo & Piercing': [MccCategory.TattooAndPiercing],
  Transportation: [
    MccCategory.BusLines,
    MccCategory.PassengerRailAndTransit,
    MccCategory.TaxisAndRideshare,
    MccCategory.TransportationServices
  ],
  'Wholesale Distributors': [MccCategory.WholesaleDistributors]
}

// Legacy category values that should still pass request validation, in addition to the
// current MccCategory values.
export const LEGACY_MCC_CATEGORY_VALUES: readonly string[] = Object.keys(LEGACY_MCC_CATEGORY_ALIASES)

const CURRENT_MCC_CATEGORY_VALUES = new Set<string>(Object.values(MccCategory))

// Translate a mix of current and legacy category values into the current MccCategory set,
// expanding legacy aliases and de-duplicating. Unknown values are dropped.
export function normalizeLegacyMccCategories(categories: readonly string[]): MccCategory[] {
  const normalized = new Set<MccCategory>()
  for (const category of categories) {
    if (CURRENT_MCC_CATEGORY_VALUES.has(category)) {
      normalized.add(category as MccCategory)
    } else {
      const aliases = LEGACY_MCC_CATEGORY_ALIASES[category]
      if (aliases) aliases.forEach((aliased) => normalized.add(aliased))
    }
  }
  return Array.from(normalized)
}

export interface MccRange {
  start: string
  end: string
}

interface MccCategoryInfo {
  description: string
  ranges: ReadonlyArray<MccRange>
}

// Each category maps to one or more Visa Merchant Category Code ranges.
// A single MCC is represented as a range where start === end. Sources:
// Visa Merchant Data Standards Manual, April 2026.
export const mccMappings: { [key in MccCategory]: MccCategoryInfo } = {
  [MccCategory.AdultEntertainment]: {
    description: 'Adult content, video streaming, and dating/escort services.',
    ranges: [
      { start: '5967', end: '5967' },
      { start: '7273', end: '7273' }
    ]
  },
  [MccCategory.AdvertisingServices]: {
    description: 'Advertising agencies and classified ad placement.',
    ranges: [{ start: '7311', end: '7311' }]
  },
  [MccCategory.AgriculturalServices]: {
    description: 'Farming co-operatives and farm management services.',
    ranges: [{ start: '0763', end: '0763' }]
  },
  [MccCategory.AirlinesAndAirCarriers]: {
    description: 'Airline tickets, baggage fees, and in-flight purchases.',
    ranges: [
      { start: '3000', end: '3308' },
      { start: '4511', end: '4511' }
    ]
  },
  [MccCategory.Airports]: {
    description: 'Airport operations, hangar rental, and aircraft servicing.',
    ranges: [{ start: '4582', end: '4582' }]
  },
  [MccCategory.AmbulanceServices]: {
    description: 'Ambulance and emergency vehicle transportation.',
    ranges: [{ start: '4119', end: '4119' }]
  },
  [MccCategory.AmusementParks]: {
    description: 'Amusement and theme parks, circuses, carnivals, and fortune tellers.',
    ranges: [{ start: '7996', end: '7996' }]
  },
  [MccCategory.AntiquesAndUsedMerchandise]: {
    description: 'Used merchandise, consignment, antique shops, and reproductions.',
    ranges: [
      { start: '5931', end: '5932' },
      { start: '5937', end: '5937' }
    ]
  },
  [MccCategory.ArtDealersAndGalleries]: {
    description: 'Art and craft supplies, art dealers, and galleries.',
    ranges: [{ start: '5970', end: '5971' }]
  },
  [MccCategory.AutoDealers]: {
    description: 'New and used car, truck, boat, motorcycle, RV, and mobile home dealers.',
    ranges: [
      { start: '5271', end: '5271' },
      { start: '5511', end: '5511' },
      { start: '5521', end: '5521' },
      { start: '5551', end: '5551' },
      { start: '5561', end: '5561' },
      { start: '5571', end: '5571' },
      { start: '5592', end: '5592' },
      { start: '5598', end: '5599' }
    ]
  },
  [MccCategory.AutomotiveFuel]: {
    description: 'Gas stations, automated fuel dispensers, and EV charging.',
    ranges: [
      { start: '5172', end: '5172' },
      { start: '5541', end: '5542' },
      { start: '5552', end: '5552' },
      { start: '5983', end: '5983' }
    ]
  },
  [MccCategory.AutomotivePartsAndAccessories]: {
    description: 'Tire stores and auto parts/accessories retailers.',
    ranges: [
      { start: '5013', end: '5013' },
      { start: '5532', end: '5533' }
    ]
  },
  [MccCategory.AutomotiveRepair]: {
    description: 'Body shops, paint, tire repair, service shops, car washes, towing, and salvage.',
    ranges: [
      { start: '5935', end: '5935' },
      { start: '7531', end: '7549' }
    ]
  },
  [MccCategory.BarsAndDrinkingPlaces]: {
    description: 'Bars, taverns, nightclubs, breweries, and cocktail lounges.',
    ranges: [{ start: '5813', end: '5813' }]
  },
  [MccCategory.BeautyAndBarberShops]: {
    description: 'Hair salons, barber shops, nail salons, and makeup studios.',
    ranges: [{ start: '7230', end: '7230' }]
  },
  [MccCategory.BicycleShops]: {
    description: 'Bicycle sales, parts, and service.',
    ranges: [{ start: '5940', end: '5940' }]
  },
  [MccCategory.BoatRentalsAndMarinas]: {
    description: 'Boat rentals, marinas, and marine service.',
    ranges: [
      { start: '4457', end: '4457' },
      { start: '4468', end: '4468' }
    ]
  },
  [MccCategory.Bookstores]: {
    description: 'New and used book stores, magazines, and periodicals.',
    ranges: [
      { start: '5192', end: '5192' },
      { start: '5942', end: '5942' }
    ]
  },
  [MccCategory.BowlingAlleys]: {
    description: 'Bowling alleys.',
    ranges: [{ start: '7933', end: '7933' }]
  },
  [MccCategory.BuildingMaterialsAndHardware]: {
    description: 'Home supply warehouses, lumber, hardware, paint, and garden centers.',
    ranges: [
      { start: '5039', end: '5039' },
      { start: '5072', end: '5072' },
      { start: '5074', end: '5074' },
      { start: '5198', end: '5198' },
      { start: '5200', end: '5211' },
      { start: '5231', end: '5231' },
      { start: '5251', end: '5251' },
      { start: '5261', end: '5261' }
    ]
  },
  [MccCategory.BusLines]: {
    description: 'Scheduled passenger bus services.',
    ranges: [{ start: '4131', end: '4131' }]
  },
  [MccCategory.BusinessServices]: {
    description: 'Credit reporting, collections, copy services, employment agencies, testing labs, and other business services.',
    ranges: [
      { start: '7278', end: '7278' },
      { start: '7321', end: '7322' },
      { start: '7338', end: '7339' },
      { start: '7342', end: '7342' },
      { start: '7349', end: '7349' },
      { start: '7361', end: '7361' },
      { start: '7399', end: '7399' },
      { start: '8734', end: '8734' }
    ]
  },
  [MccCategory.CableSatelliteAndStreaming]: {
    description: 'Cable, satellite, and streaming TV/radio services.',
    ranges: [{ start: '4899', end: '4899' }]
  },
  [MccCategory.CameraAndPhoto]: {
    description: 'Camera stores, photo studios, photo developing, and commercial photography.',
    ranges: [
      { start: '5044', end: '5044' },
      { start: '5946', end: '5946' },
      { start: '7221', end: '7221' },
      { start: '7333', end: '7333' },
      { start: '7395', end: '7395' }
    ]
  },
  [MccCategory.CarRentals]: {
    description: 'Car, truck, utility trailer, motor home, and RV rentals.',
    ranges: [
      { start: '3351', end: '3441' },
      { start: '7512', end: '7513' },
      { start: '7519', end: '7519' }
    ]
  },
  [MccCategory.CharitableOrganizations]: {
    description: 'Non-political charities, crowd-funding, and social welfare organizations.',
    ranges: [{ start: '8398', end: '8398' }]
  },
  [MccCategory.ChildcareServices]: {
    description: 'Daycare, babysitting, nurseries, and preschools.',
    ranges: [{ start: '8351', end: '8351' }]
  },
  [MccCategory.CigarAndTobaccoStores]: {
    description: 'Tobacco shops, cigar stores, and electronic cigarettes.',
    ranges: [{ start: '5993', end: '5993' }]
  },
  [MccCategory.ClothingAndApparel]: {
    description: 'Men’s, women’s, and children’s clothing, footwear, accessories, and tailoring.',
    ranges: [
      { start: '5137', end: '5137' },
      { start: '5139', end: '5139' },
      { start: '5611', end: '5699' },
      { start: '5949', end: '5949' },
      { start: '7296', end: '7296' }
    ]
  },
  [MccCategory.ComputerProgrammingAndIT]: {
    description: 'Software design, IT consulting, internet service providers, and computer repair.',
    ranges: [
      { start: '4816', end: '4816' },
      { start: '7372', end: '7372' },
      { start: '7375', end: '7375' },
      { start: '7379', end: '7379' }
    ]
  },
  [MccCategory.ConstructionContractors]: {
    description: 'General contractors, HVAC, electrical, masonry, carpentry, roofing, and concrete.',
    ranges: [
      { start: '1520', end: '1520' },
      { start: '1711', end: '1711' },
      { start: '1731', end: '1731' },
      { start: '1740', end: '1740' },
      { start: '1750', end: '1750' },
      { start: '1761', end: '1761' },
      { start: '1771', end: '1771' },
      { start: '1799', end: '1799' }
    ]
  },
  [MccCategory.CosmeticStores]: {
    description: 'Cosmetics and makeup retailers.',
    ranges: [{ start: '5977', end: '5977' }]
  },
  [MccCategory.CounselingServices]: {
    description: 'Debt, marriage, family, and addiction counseling.',
    ranges: [{ start: '7277', end: '7277' }]
  },
  [MccCategory.CruiseLines]: {
    description: 'Steamship and cruise line passenger transportation.',
    ranges: [{ start: '4411', end: '4411' }]
  },
  [MccCategory.DanceStudiosAndHalls]: {
    description: 'Dance studios, schools, and public dance halls.',
    ranges: [{ start: '7911', end: '7911' }]
  },
  [MccCategory.DepartmentAndDiscountStores]: {
    description: 'Wholesale clubs, duty-free shops, discount, department, and variety stores.',
    ranges: [
      { start: '5300', end: '5311' },
      { start: '5331', end: '5331' },
      { start: '5399', end: '5399' }
    ]
  },
  [MccCategory.DigitalGoods]: {
    description: 'Digital media, games, applications, and large digital goods merchants.',
    ranges: [{ start: '5815', end: '5818' }]
  },
  [MccCategory.DirectMarketing]: {
    description: 'Catalog, door-to-door, outbound telemarketing, and subscription merchants.',
    ranges: [
      { start: '5963', end: '5966' },
      { start: '5968', end: '5969' }
    ]
  },
  [MccCategory.DryCleaningAndLaundry]: {
    description: 'Laundromats, dry cleaners, carpet/upholstery cleaning, and garment services.',
    ranges: [{ start: '7210', end: '7217' }]
  },
  [MccCategory.Education]: {
    description: 'Schools, colleges, universities, vocational schools, and educational services.',
    ranges: [{ start: '8211', end: '8299' }]
  },
  [MccCategory.ElderCare]: {
    description: 'Nursing homes, hospice, assisted living, and home healthcare.',
    ranges: [{ start: '8050', end: '8050' }]
  },
  [MccCategory.ElectronicsStores]: {
    description: 'Consumer electronics, telecom equipment, and computer software stores.',
    // 5733 (musical instruments) and 5735 (record stores) are split out into
    // MusicStores; 5734 (computer software) stays here with electronics.
    ranges: [
      { start: '4812', end: '4812' },
      { start: '5045', end: '5045' },
      { start: '5065', end: '5065' },
      { start: '5732', end: '5732' },
      { start: '5734', end: '5734' }
    ]
  },
  [MccCategory.EntertainmentVenues]: {
    description:
      'Movie theaters, video rentals, theatrical producers, live entertainment, billiards, arcades, and zoos. MCC 7999 also makes this cover recreation: public swimming pools, ski resorts, mini golf, driving ranges, skating rinks, horseback riding, and bike/aircraft rentals.',
    ranges: [
      { start: '7829', end: '7841' },
      { start: '7922', end: '7929' },
      { start: '7932', end: '7932' },
      { start: '7941', end: '7941' },
      { start: '7993', end: '7994' },
      { start: '7998', end: '7999' }
    ]
  },
  [MccCategory.EquipmentRentalAndLeasing]: {
    description: 'Equipment, tool, furniture, and appliance rental and leasing.',
    ranges: [{ start: '7394', end: '7394' }]
  },
  [MccCategory.FastFood]: {
    description: 'Quick-service restaurants, sandwich shops, coffee shops, and ice cream shops.',
    ranges: [{ start: '5814', end: '5814' }]
  },
  [MccCategory.FinancialInstitutions]: {
    description: 'Banks, ATMs, brokers, stored value cards, and non-financial currency/crypto services.',
    ranges: [
      { start: '6010', end: '6012' },
      { start: '6051', end: '6051' },
      { start: '6211', end: '6211' },
      { start: '6540', end: '6540' }
    ]
  },
  [MccCategory.Florists]: {
    description: 'Florists, flower shops, and floral wholesalers.',
    ranges: [
      { start: '5193', end: '5193' },
      { start: '5992', end: '5992' }
    ]
  },
  [MccCategory.FuneralServices]: {
    description: 'Funeral homes, crematories, and mortuaries.',
    ranges: [{ start: '7261', end: '7261' }]
  },
  [MccCategory.FurnitureAndHomeFurnishings]: {
    description: 'Furniture, floor coverings, drapery, fireplaces, household appliances, and glassware.',
    ranges: [
      { start: '5021', end: '5021' },
      { start: '5712', end: '5719' },
      { start: '5722', end: '5722' },
      { start: '5950', end: '5950' },
      { start: '7641', end: '7641' }
    ]
  },
  [MccCategory.Gambling]: {
    description: 'Lotteries, casinos, horse/dog racing, sports betting, and bingo.',
    ranges: [
      { start: '7800', end: '7802' },
      { start: '7995', end: '7995' },
      { start: '9406', end: '9406' }
    ]
  },
  [MccCategory.GiftAndNoveltyShops]: {
    description: 'Gift, card, novelty, and souvenir shops.',
    ranges: [{ start: '5947', end: '5947' }]
  },
  [MccCategory.GolfAndCountryClubs]: {
    description:
      'Public/private golf courses, country clubs, and membership sports & recreation clubs. MCC 7997 is broad: it also covers gyms, health/fitness clubs, tennis, yacht, boating, swimming, and bowling clubs.',
    ranges: [
      { start: '7992', end: '7992' },
      { start: '7997', end: '7997' }
    ]
  },
  [MccCategory.GovernmentServices]: {
    description: 'Court costs, fines, tax payments, postal services, and other government services.',
    ranges: [
      { start: '9211', end: '9223' },
      { start: '9311', end: '9311' },
      { start: '9399', end: '9405' }
    ]
  },
  [MccCategory.GroceryAndSupermarkets]: {
    description: 'Full-line grocery stores and supermarkets.',
    ranges: [{ start: '5411', end: '5411' }]
  },
  [MccCategory.GunsAndAmmunition]: {
    description: 'Firearms and ammunition retailers.',
    ranges: [{ start: '5723', end: '5723' }]
  },
  [MccCategory.HealthAndBeautySpas]: {
    description: 'Massage parlors, health and beauty spas, and tanning salons.',
    ranges: [{ start: '7297', end: '7298' }]
  },
  [MccCategory.HealthServices]: {
    description: 'Doctors, dentists, optometrists, chiropractors, hospitals, and other medical practitioners.',
    ranges: [
      { start: '8011', end: '8049' },
      { start: '8062', end: '8062' },
      { start: '8099', end: '8099' }
    ]
  },
  [MccCategory.HobbyToysAndGames]: {
    description: 'Hobby shops, toy stores, and game stores.',
    ranges: [{ start: '5945', end: '5945' }]
  },
  [MccCategory.HotelsAndLodging]: {
    description: 'Hotels, motels, resorts, B&Bs, timeshares, camps, and campgrounds.',
    ranges: [
      { start: '3501', end: '3883' },
      { start: '7011', end: '7012' },
      { start: '7032', end: '7033' }
    ]
  },
  [MccCategory.Insurance]: {
    description: 'Insurance sales, premiums, and warranties.',
    ranges: [
      { start: '5960', end: '5960' },
      { start: '6300', end: '6300' }
    ]
  },
  [MccCategory.JewelryAndWatches]: {
    description: 'Fine jewelry, watches, silverware, and jewelry/watch repair.',
    ranges: [
      { start: '5094', end: '5094' },
      { start: '5944', end: '5944' },
      { start: '7631', end: '7631' }
    ]
  },
  [MccCategory.Landscaping]: {
    description: 'Landscaping, horticultural, lawn care, and gardening services.',
    ranges: [{ start: '0780', end: '0780' }]
  },
  [MccCategory.LegalAndAccounting]: {
    description: 'Legal services, attorneys, accounting, bookkeeping, and tax preparation.',
    ranges: [
      { start: '7276', end: '7276' },
      { start: '8111', end: '8111' },
      { start: '8931', end: '8931' }
    ]
  },
  [MccCategory.LiquorStores]: {
    description: 'Package stores selling beer, wine, and liquor for off-premises consumption.',
    ranges: [{ start: '5921', end: '5921' }]
  },
  [MccCategory.LuggageAndLeather]: {
    description: 'Luggage, briefcases, wallets, and leather goods stores.',
    ranges: [{ start: '5948', end: '5948' }]
  },
  [MccCategory.Marketplaces]: {
    description: 'Visa-registered online marketplaces.',
    ranges: [{ start: '5262', end: '5262' }]
  },
  [MccCategory.MedicalEquipment]: {
    description: 'Medical, dental, ophthalmic equipment, hearing aids, prosthetics, and labs.',
    ranges: [
      { start: '5047', end: '5047' },
      { start: '5122', end: '5122' },
      { start: '5975', end: '5976' },
      { start: '8071', end: '8071' }
    ]
  },
  [MccCategory.MembershipOrganizations]: {
    description: 'Civic, social, fraternal, political, religious, and automobile associations.',
    ranges: [
      { start: '8641', end: '8641' },
      { start: '8651', end: '8651' },
      { start: '8661', end: '8661' },
      { start: '8675', end: '8675' },
      { start: '8699', end: '8699' }
    ]
  },
  [MccCategory.MiscellaneousRetail]: {
    description: 'Swimming pool, electric razor, tent/awning, and other specialty retail.',
    ranges: [{ start: '5996', end: '5999' }]
  },
  [MccCategory.MoneyTransfer]: {
    description: 'Wire transfers, remittances, and money transfer services.',
    ranges: [
      { start: '4821', end: '4821' },
      { start: '4829', end: '4829' }
    ]
  },
  [MccCategory.MusicStores]: {
    description: 'Musical instrument and piano stores, sheet music, and record stores.',
    ranges: [
      { start: '5733', end: '5733' },
      { start: '5735', end: '5735' }
    ]
  },
  [MccCategory.NewsDealers]: {
    description: 'News dealers, newsstands, and periodicals.',
    ranges: [{ start: '5994', end: '5994' }]
  },
  [MccCategory.ParkingAndTolls]: {
    description: 'Parking lots, garages, meters, toll roads, and bridge fees.',
    ranges: [
      { start: '4784', end: '4784' },
      { start: '7523', end: '7523' }
    ]
  },
  [MccCategory.PassengerRailAndTransit]: {
    description: 'Passenger railways, ferries, and local/suburban commuter transportation.',
    ranges: [
      { start: '4111', end: '4112' }
    ]
  },
  [MccCategory.PawnShops]: {
    description: 'Pawn shops.',
    ranges: [{ start: '5933', end: '5933' }]
  },
  [MccCategory.PetShopsAndSupplies]: {
    description: 'Pet stores, pet food, and pet supplies.',
    ranges: [{ start: '5995', end: '5995' }]
  },
  [MccCategory.PharmaciesAndDrugs]: {
    description: 'Drug stores, pharmacies, and prescription medication.',
    ranges: [{ start: '5912', end: '5912' }]
  },
  [MccCategory.ProfessionalServices]: {
    description: 'Management consulting, architectural, engineering, and other professional services.',
    ranges: [
      { start: '7392', end: '7392' },
      { start: '8911', end: '8911' },
      { start: '8999', end: '8999' }
    ]
  },
  [MccCategory.PublishingAndPrinting]: {
    description: 'Publishing, printing, typesetting, and bookbinding services.',
    ranges: [
      { start: '2741', end: '2741' },
      { start: '2791', end: '2791' }
    ]
  },
  [MccCategory.ReligiousGoods]: {
    description: 'Religious goods stores selling devotional items, figurines, and books.',
    ranges: [{ start: '5973', end: '5973' }]
  },
  [MccCategory.RepairServices]: {
    description: 'Shoe, electronics, appliance, AC/refrigeration, welding, and miscellaneous repair shops.',
    ranges: [
      { start: '7251', end: '7251' },
      { start: '7622', end: '7629' },
      { start: '7692', end: '7699' }
    ]
  },
  [MccCategory.RestaurantsAndDining]: {
    description: 'Full-service restaurants, cafes, caterers, and diners.',
    ranges: [{ start: '5811', end: '5812' }]
  },
  [MccCategory.SecurityServices]: {
    description: 'Detective agencies, security guards, alarm systems, and armored car services.',
    ranges: [{ start: '7393', end: '7393' }]
  },
  [MccCategory.ShippingAndCourier]: {
    description: 'Railroad freight, motor freight, trucking, moving companies, and couriers.',
    ranges: [
      { start: '4011', end: '4011' },
      { start: '4214', end: '4215' }
    ]
  },
  [MccCategory.SpecialtyFoodStores]: {
    description: 'Bakeries, butchers, candy, dairy, convenience stores, and specialty food markets.',
    ranges: [
      { start: '5422', end: '5422' },
      { start: '5441', end: '5441' },
      { start: '5451', end: '5451' },
      { start: '5462', end: '5462' },
      { start: '5499', end: '5499' }
    ]
  },
  [MccCategory.SportingGoods]: {
    description: 'Sporting goods, sports apparel, camping, fishing, and outdoor equipment.',
    ranges: [{ start: '5941', end: '5941' }]
  },
  [MccCategory.StampAndCoin]: {
    description: 'Stamp and coin stores for collecting or investment.',
    ranges: [{ start: '5972', end: '5972' }]
  },
  [MccCategory.StationeryAndOffice]: {
    description: 'Stationery, office supplies, paper, and typewriter stores.',
    ranges: [
      { start: '5111', end: '5111' },
      { start: '5943', end: '5943' },
      { start: '5978', end: '5978' }
    ]
  },
  [MccCategory.StorageFacilities]: {
    description: 'Public warehousing, refrigerated storage, and household goods storage.',
    ranges: [{ start: '4225', end: '4225' }]
  },
  [MccCategory.TattooAndPiercing]: {
    description:
      'Tattoo and piercing parlors. Warning: MCC 7299 is a broad "miscellaneous personal services" code, so blocking this also blocks animal grooming, dog training, animal boarding/breeding, wedding chapels, taxidermists, water filtration services, apartment rental services, and standalone tipping.',
    ranges: [{ start: '7299', end: '7299' }]
  },
  [MccCategory.TaxisAndRideshare]: {
    description: 'Taxicabs, limousines, and rideshare services.',
    ranges: [{ start: '4121', end: '4121' }]
  },
  [MccCategory.Telecommunications]: {
    description: 'Phone, fax, prepaid calling cards, and other telecom services.',
    ranges: [{ start: '4814', end: '4814' }]
  },
  [MccCategory.TouristAttractions]: {
    description: 'Museums, botanical gardens, wineries, and tourist exhibits.',
    ranges: [{ start: '7991', end: '7991' }]
  },
  [MccCategory.TransportationServices]: {
    description: 'Airport shuttles, aerial tramways, and other transportation services.',
    ranges: [{ start: '4789', end: '4789' }]
  },
  [MccCategory.TravelAgencies]: {
    description: 'Travel agencies, tour operators, and travel-related direct marketing.',
    ranges: [
      { start: '4722', end: '4723' },
      { start: '5962', end: '5962' }
    ]
  },
  [MccCategory.Utilities]: {
    description: 'Electric, gas, water, sanitary, and waste management utilities.',
    ranges: [{ start: '4900', end: '4900' }]
  },
  [MccCategory.VeterinaryServices]: {
    description: 'Veterinary medicine, pet hospitals, and pet clinics.',
    ranges: [{ start: '0742', end: '0742' }]
  },
  [MccCategory.WholesaleDistributors]: {
    description:
      'B2B/wholesale distributors of construction, industrial, chemical, petroleum, and durable/nondurable goods.',
    ranges: [
      { start: '2842', end: '2842' },
      { start: '5046', end: '5046' },
      { start: '5051', end: '5051' },
      { start: '5085', end: '5085' },
      { start: '5099', end: '5099' },
      { start: '5131', end: '5131' },
      { start: '5169', end: '5169' },
      { start: '5199', end: '5199' }
    ]
  }
}

// Returns an empty array for unknown values (e.g., renamed/removed enum
// entries still persisted in older JSON payloads), so callers can iterate
// safely without crashing on stale data.
export function getMccRangesForCategory(category: MccCategory): readonly MccRange[] {
  return (mccMappings as Record<string, MccCategoryInfo | undefined>)[category]?.ranges ?? []
}

// Reverse of mccMappings: given a raw merchant category code, return the category whose
// ranges contain it, or null if it falls outside every mapped range. Comparison is numeric
// so zero-padding differences (e.g. '0763') never break ordering. Returns the first match;
// ranges are authored to be non-overlapping, so at most one category applies.
export function getMccCategoryForMcc(mcc: string | null | undefined): MccCategory | null {
  if (!mcc) return null
  const code = Number(mcc)
  if (!Number.isFinite(code)) return null
  for (const category of Object.keys(mccMappings) as MccCategory[]) {
    for (const { start, end } of mccMappings[category].ranges) {
      if (code >= Number(start) && code <= Number(end)) return category
    }
  }
  return null
}

// List should have unique entries
export const DefaultSpendCategoriesToBan: MccCategory[] = [
  MccCategory.AdultEntertainment,
  MccCategory.Gambling,
  MccCategory.JewelryAndWatches,
  MccCategory.TattooAndPiercing,
  MccCategory.AmusementParks,
  MccCategory.PawnShops
]


// From common/types-and-constants/src/constants/carrierIdentity.ts
/**
 * Carrier identity (MC/DOT) capture — THT-728.
 *
 * MC/DOT collection moved post-login onto the app's heads-up page. These constants are
 * shared by the two backend entry points of that flow:
 *   - services/customers  → creates a CarrierLead when an MC/DOT patch matches nothing
 *   - services/highway    → looks a carrier's legal name up for on-screen confirmation
 */

/**
 * Stamped on `carrier_lead.source_broker_ids` for leads created from the in-app
 * heads-up MC/DOT capture, so they are distinguishable from landing-page prequal
 * leads (`tach-landing-page`) and demo-site captures (`demo-site`) in reporting.
 */
export const HEADS_UP_LEAD_SOURCE = 'tach-app-heads-up'

/**
 * Highway's `by_identifier` lookup keys. A user-entered number is tried as both,
 * because carriers routinely type their DOT number into an MC field and vice versa.
 */
export const HighwayIdentifierType = {
  MC: 'MC',
  DOT: 'DOT'
} as const

export type HighwayIdentifierTypeValue =
  (typeof HighwayIdentifierType)[keyof typeof HighwayIdentifierType]

/** Highway External API v1 host per environment, and the shared path prefix. */
export const HIGHWAY_PROD_DOMAIN = 'highway.com'
export const HIGHWAY_NON_PROD_DOMAIN = 'staging.highway.com'
export const HIGHWAY_EXTERNAL_API_BASE_PATH = '/core/connect/external_api/v1'

/**
 * Ceiling for a single carrier lookup call. The heads-up page blocks on this
 * request, so it must fail fast rather than ride the Lambda's 30s timeout.
 */
export const HIGHWAY_CARRIER_LOOKUP_TIMEOUT_MS = 8000

/**
 * Highway statuses that mean "that identifier is not a carrier" rather than "Highway is
 * having a problem" — surfacing a permanent miss as an outage would tell a user to
 * retry a number that will never work, instead of letting them correct it.
 *
 * 404 is confirmed against staging Highway: an out-of-range identifier (9999999999)
 * answers 404, not 422 (see tests/carrierNameLookupLive.test.ts). 410 is included as
 * the only other status that can only ever mean "this record is gone". 422 is
 * deliberately NOT here — Highway was never observed using it, and it more likely
 * signals a malformed request on our side, which must surface as an error.
 */
export const HIGHWAY_CARRIER_NOT_FOUND_STATUSES: number[] = [404, 410]

/** Only digits are ever valid for an MC or DOT number; length caps a hostile input. */
export const CARRIER_IDENTIFIER_PATTERN = /^[0-9]{1,10}$/

/**
 * Highway tags each carrier address with an `is_type`. The physical one is the
 * carrier's actual place of business — the mailing address is often a PO box or the
 * accountant's office, which is the wrong thing to prefill into a business address.
 */
export const HIGHWAY_PHYSICAL_ADDRESS_TYPE = 'physical'

/**
 * Highway tags each contact with an `is_type`. Only the owner is the person filling
 * in the application — a dispatcher, bookkeeper or safety contact is someone else at
 * (or outside) the company, and prefilling their name and email onto a credit
 * application puts a third party on the record. Preferred, never required: carriers
 * routinely have no owner contact on file, and the caller then falls back positionally.
 */
export const HIGHWAY_OWNER_CONTACT_TYPE = 'owner'

/**
 * Consecutive failed MC/DOT lookups after which the heads-up page reports the trucker
 * as stuck (THT-738). The UI owns the counting in v1; this is the shared number so a
 * later move to server-side counting does not have to rediscover it.
 */
export const VERIFICATION_STUCK_FAILURE_THRESHOLD = 3

/**
 * Ceiling on how many identifiers one stuck report may carry. The UI sends what the
 * user actually tried (normally 3); the cap keeps a hostile caller from turning the
 * endpoint into an unbounded Slack-message generator.
 */
export const VERIFICATION_STUCK_MAX_ATTEMPTED_NUMBERS = 5

/**
 * Lock key serializing CarrierLead creation for one carrier identifier. `mc_number` /
 * `dot_number` carry no unique constraint (and no migration may add one), so without
 * this two customers at the same carrier patching concurrently can both miss the
 * dedupe read and both insert — duplicate leads, double-counted conversion.
 *
 * Keyed on the identifier TYPE as well as the number: the two ranges overlap, so
 * `MC 149513` and `DOT 149513` are different carriers (confirmed against live Highway).
 * A bare-number key would serialize them against each other, and since contention skips
 * rather than queues, that false collision would cost a real customer their attribution.
 */
export const carrierLeadCreateLockId = (
  identifierType: HighwayIdentifierTypeValue,
  number: string
): string => `carrier-lead-create#${identifierType}-${number}`


// From common/types-and-constants/src/constants/cashAdvance.ts
// Revenue-consistency band for cash advance activation, expressed in percentage points of
// difference between a customer's actual deposits and their expected revenue over the
// configured history window (see `determineRevenueConsistency`).
//
// Deliberately asymmetric. Depositing MORE than projected is a sign of a healthy, growing
// carrier, not a risk, so the ceiling exists only to catch genuine data outliers — duplicate
// credits, a one-off asset sale, a misclassified transfer. The floor is what actually gates:
// it is the point below which we no longer believe we can see enough of the customer's cash
// flow to underwrite against it.
export const cashAdvanceRevenueToleranceFloorPercentage = -50
export const cashAdvanceRevenueToleranceCeilingPercentage = 200

// Window during which a customer can accept the presented cash-advance options.
// Set in product review.
export const CASH_ADVANCE_OPTIONS_TTL = 48 * 60 * 60 * 1000

// How long before expiry to send a single reminder push + SMS.
export const CASH_ADVANCE_OPTIONS_REMINDER_BEFORE = 24 * 60 * 60 * 1000

// Single source of truth for the per-request mutex key. Used by the admin
// "present" endpoint, the customer select-option/decline-options endpoints,
// and the workflow's expireOptionsActivity. Changing the format here propagates
// everywhere — do not inline this literal anywhere else.
export const cashAdvanceOptionsLockId = (request_id: string): string =>
  `cash-advance-options#${request_id}`

// Attempt-scoped workflow id for presentCashAdvanceOptionsWorkflow. Used by
// services to derive the signal target. temporal-utils cannot import this
// (it must stay self-contained for the worker bundle), so it inlines the SAME
// format in `presentCashAdvanceOptionsHandler` — both sites must agree; change
// them together.
export const cashAdvanceOptionsWorkflowId = (args: {
  request_id: string
  presentation_attempt: number
}): string =>
  `present-cash-advance-options-${args.request_id}-${args.presentation_attempt}`

// Signal name string the workflow listens for. Mirrored in
// `temporal/src/workflows/workflowsShared/signals.ts` SignalNames enum — both
// sites read this constant so they cannot drift.
export const CASH_ADVANCE_OPTION_RESOLVED_SIGNAL_NAME = 'CashAdvanceOptionResolved' as const


// From common/types-and-constants/src/constants/credit.ts
export const maximumLoanTermInMonths = 4

export const defaultAPR = 0.03

export const additionalMonthlyAPR = 0.015

export const corporateBillingFeePercentage = 0.03

export const globalMaximumTotalLoanBalancesCents = 1000000


// From common/types-and-constants/src/constants/debitCardFailures.ts
// Typed failure reasons for card-utils business rules, carried on
// ApplicationFailure.type so callers can classify a workflow refusal without
// string-matching the message (see card-utils/src/errors.ts classifyCardError).
export const CARD_FAILURE_TYPE = {
  CAPACITY_REACHED: 'CARD_CAPACITY_REACHED',
  TRUCK_NOT_FOUND: 'CARD_TRUCK_NOT_FOUND',
  ACCOUNT_NOT_FOUND: 'CARD_ACCOUNT_NOT_FOUND'
} as const


// From common/types-and-constants/src/constants/debitCards.ts
// The second line embossed on a physical card (Blue Penguin `card_name2`),
// printed under the business name. Truck cards use the VIN; business cards use
// an optional customer-entered label. Blue Penguin embosses uppercase
// alphanumerics and spaces only, and cuts the line off past 20 characters.
export const CARD_LINE_2_MAX_LENGTH = 20
export const CARD_LINE_2_PATTERN = /^[A-Z0-9 ]*$/

// Line 2 on the company card ordered at signup for multi-truck fleets, so the
// truckless card is identifiable next to the per-truck cards it ships with.
export const COMPANY_CARD_LINE_2 = 'COMPANY CARD'


// From common/types-and-constants/src/constants/deposits.ts
export enum DepositStatus {
  Pending = 'pending',
  Completed = 'completed',
  Failed = 'failed'
}

export enum DepositOrigin {
  Sila = 'sila',
  BluePenguinWire = 'blue_penguin_wire'
}

// Right now we just use ach pushes
export enum DepositMovementType {
  //   StandardAchPull = 'standard_ach_pull',
  StandardAchPush = 'standard_ach_push',
  SameDayAchPull = 'same_day_ach_pull',
  SameDayAchPush = 'same_day_ach_push',
  //   WirePull = 'wire_pull',
  //   WirePush = 'wire_push',
  //   FedNowPull = 'fednow_pull',
  //   FedNowPush = 'fednow_push',
  //   RtpPull = 'rtp_pull',
  //   RtpPush = 'rtp_push'
  /**
   * This is for when there is no movement associated with the deposit,
   * meaning it hit the customer's account directly instead of from an upstream
   * sub account (i.e. went straight to BP, not Sila).
   */
  None = 'none',
  /**
   * Funds moved from the liquidity pool to the customer's BP account via a
   * synchronous C2C (MoveStoredBalances) transfer. The deposit is immediately
   * 'completed' — no ACH settlement wait.
   */
  LiquidityPoolC2C = 'liquidity_pool_c2c'
}

export enum DepositErrorType {
  AchReturn = 'ach_return',
  SilaError = 'sila_error'
}

/**
 * Customer-initiated deposit (ACH debit pull) limits, in cents. Plain constants (not SSM) —
 * changing them needs a deploy, which is acceptable for limit tuning and avoids an SSM read
 * per deposit. Moderate start; tune as we learn return rates.
 */
export const DEPOSIT_LIMITS_IN_CENTS = {
  minPerTransaction: 2000, // $20
  maxPerTransaction: 1000000, // $10,000
  dailyCap: 2000000, // $20,000
  monthlyCap: 5000000 // $50,000
} as const


// From common/types-and-constants/src/constants/dispatchPricing.ts
/**
 * Dispatch fee tiers (percent of load) by equipment class and carrier
 * authority age — John's pricing, revised +0.5% per Scott 2026-07-16
 * (THT-691). SINGLE SOURCE OF TRUTH: every quote (pricing API, dispatcher
 * email, Slack post) must read these values from here — never restate them as
 * literals at a call site.
 */
export const DISPATCH_FEE_PCT = {
  standard: { over1yr: 6.0, under1yr: 7.0 },
  boxHotshot: { over1yr: 7.0, under1yr: 8.0 }
} as const

/**
 * Equipment values priced at the boxHotshot tier. Everything else — including
 * unknown values from newer app versions (`equipment_types` is an open string
 * array by contract) — prices as standard equipment.
 */
export const BOX_HOTSHOT_EQUIPMENT_TYPES: ReadonlySet<string> = new Set(['box_truck', 'hotshot'])


// From common/types-and-constants/src/constants/documentRequests.ts
/**
 * Upload rules for document-request files. Shared by every path that writes a
 * requested document to S3 (the customer upload in services/applications and the
 * admin on-behalf upload in services/admin-document-requests) so the two can
 * never drift on what they accept.
 */

// Allowed file extensions (lower-case) and the MIME type stored with the S3 object
export const DOCUMENT_REQUEST_ALLOWED_FILE_TYPES: Readonly<Record<string, string>> = {
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png'
}

// 10MB limit minus a 500KB buffer -> 9.5MB, in bytes
export const DOCUMENT_REQUEST_MAX_FILE_BYTES = 9.5 * 1024 * 1024

// The cap as shown in error messages, e.g. "9.5MB"
export const formatDocumentRequestMaxFileSize = (
  max_bytes: number = DOCUMENT_REQUEST_MAX_FILE_BYTES
): string => `${(max_bytes / (1024 * 1024)).toFixed(1)}MB`


// From common/types-and-constants/src/constants/eld.ts
/**
 * ELD odometer plausibility bounds (THT-785).
 *
 * `Trucks.current_mileage` is fed by ELD odometer readings via
 * `updateDailyMileageSnapshot`, and that write is monotonic once the value is
 * ELD-sourced: a reading lower than what is stored is rejected so a bad gateway
 * value can't ratchet mileage backwards. The consequence is that a single
 * implausibly HIGH reading would latch the truck at that value forever, since
 * every real reading afterwards is smaller. These bounds keep such a value from
 * ever being written.
 */

/**
 * Upper bound (exclusive) for an odometer reading in miles. A Class 8 truck's
 * lifetime is roughly 1–2M miles, so anything at or above this is bad data —
 * a sentinel value (e.g. 9999999) or a reading in the wrong unit (meters).
 *
 * A physical-plausibility bound, deliberately not an SSM parameter: it does not
 * vary by stage and is not something ops should tune.
 */
export const MAX_PLAUSIBLE_ODOMETER_MILES = 2_000_000


// From common/types-and-constants/src/constants/general.ts
export const stages = {
  dev: 'dev',
  staging: 'staging',
  production: 'prod'
}

export const plaidStages = {
  sandbox: 'sandbox',
  production: 'production'
}

export const thirtyDaysInMs = 1000 * 3600 * 24 * 30

export const oneYearInMs = 1000 * 3600 * 24 * 365

export const twoWeeksInMs = 1000 * 3600 * 24 * 14

export const oneDayInMs = 1000 * 3600 * 24

export const oneHourInMs = 1000 * 3600

export const monthsInYear = 12

export const fiveSecondsInMs = 5 * 1000

export const twentyFiveSecondsInMs = 25 * 1000

export const thirtySecondsInMs = 30 * 1000

export const NULL_UUID = '00000000-0000-0000-0000-000000000000'

export const BUSINESS_CATEGORY_NAME = 'Business'

/**
 * US Federal Bank Holidays in UTC format (YYYY-MM-DD)
 * These are the major holidays when banks are closed and ACH transactions don't settle.
 */
export const BANK_HOLIDAYS_UTC = [
  // 2025
  '2025-01-01', // New Year's Day (Wed)
  '2025-01-20', // Martin Luther King Jr. Day (Mon)
  '2025-02-17', // Presidents' Day (Mon)
  '2025-05-26', // Memorial Day (Mon)
  '2025-06-19', // Juneteenth (Thu)
  '2025-07-04', // Independence Day (Fri)
  '2025-09-01', // Labor Day (Mon)
  '2025-10-13', // Columbus Day (Mon)
  '2025-11-11', // Veterans Day (Tue)
  '2025-11-27', // Thanksgiving Day (Thu)
  '2025-12-25', // Christmas Day (Thu)

  // 2026
  '2026-01-01', // New Year's Day (Thu)
  '2026-01-19', // Martin Luther King Jr. Day (Mon)
  '2026-02-16', // Presidents' Day (Mon)
  '2026-05-25', // Memorial Day (Mon)
  '2026-06-19', // Juneteenth (Fri)
  '2026-07-03', // Independence Day (observed) (Fri)
  '2026-09-07', // Labor Day (Mon)
  '2026-10-12', // Columbus Day (Mon)
  '2026-11-11', // Veterans Day (Wed)
  '2026-11-26', // Thanksgiving Day (Thu)
  '2026-12-25', // Christmas Day (Fri)

  // 2027
  '2027-01-01', // New Year's Day (Fri)
  '2027-01-18', // Martin Luther King Jr. Day (Mon)
  '2027-02-15', // Presidents' Day (Mon)
  '2027-05-31', // Memorial Day (Mon)
  '2027-06-18', // Juneteenth (observed) (Fri)
  '2027-07-05', // Independence Day (observed) (Mon)
  '2027-09-06', // Labor Day (Mon)
  '2027-10-11', // Columbus Day (Mon)
  '2027-11-11', // Veterans Day (Thu)
  '2027-11-25', // Thanksgiving Day (Thu)
  '2027-12-24' // Christmas Day (observed) (Fri)
]

// US state codes including DC
export const US_STATE_CODES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY'
]


// From common/types-and-constants/src/constants/loans.ts
export enum LoanStatuses {
  Active = 'active',
  Closed = 'closed',
  Requested = 'requested'
}


// From common/types-and-constants/src/constants/notifications.ts
export enum NotificationTypes {
  cardDecline = 'card_decline',
  maintenanceReminder = 'maintenance_reminder',
  preventativeMaintenanceReminderCreated = 'preventative_maintenance_reminder_created',
  monthlyStatement = 'monthly_statement',
  depositFailed = 'deposit_failed',
  manualMileageRequest = 'manual_mileage_request',
  extendedIdle = 'extended_idle',
  poorFuelEfficiency = 'poor_fuel_efficiency',
  maintenanceDue = 'maintenance_due',
  criticalFaultCode = 'critical_fault_code',
  highTripCost = 'high_trip_cost',
  weeklyCostAnalysis = 'weekly_cost_analysis',
  unsafeDrivingPattern = 'unsafe_driving_pattern',
  criticalSafetyEvent = 'critical_safety_event',
  speedingViolation = 'speeding_violation',
  highMonthlySpeedingCost = 'high_monthly_speeding_cost',
  failedInspection = 'failed_inspection',
  inspectionComplianceRisk = 'inspection_compliance_risk',
  hosViolation = 'hos_violation',
  complianceRisk = 'compliance_risk',
  cashAdvanceConsentRequired = 'cash_advance_consent_required',
  cashAdvanceOptions = 'cash_advance_options',
  // Scheduled withdrawals (spec D5). Deliberately NO "missed" type: a missed occurrence only
  // happens when our sweep didn't run, the customer's funds simply stayed in TACH, and their
  // remedy is a manual withdrawal they could make anyway — so it stays loud to us (Event +
  // ops Slack + tripwire) and silent to them.
  scheduledWithdrawalSkipped = 'scheduled_withdrawal_skipped',
  scheduledWithdrawalPartial = 'scheduled_withdrawal_partial',
  scheduledWithdrawalPaused = 'scheduled_withdrawal_paused',
  // Financial correlation notification types
  detentionCostAlert = 'detention_cost_alert',
  highMonthlyDetentionCost = 'high_monthly_detention_cost',
  routeDeliveryPenalty = 'route_delivery_penalty',
  predictiveMaintenanceCostAlert = 'predictive_maintenance_cost_alert',
  gatewayDataLossRisk = 'gateway_data_loss_risk',
  pendingTruckApproval = 'pending_truck_approval',
  vinlessEldVehicle = 'vinless_eld_vehicle'
}

// Notification.object_type value used to scope notifications created for
// the pending-truck-approval flow. Shared between the temporal activity that
// creates them and the trucks service handlers that mark them viewed.
export const PENDING_TRUCK_OBJECT_TYPE = 'pending_truck'


// From common/types-and-constants/src/constants/payments.ts
export enum Currencies {
  usd = 'usd'
}


// From common/types-and-constants/src/constants/phone.ts
// Shared phone-number validation. Single source of truth for the E.164 US
// format (`+1` followed by 10 digits, e.g. +15551234567) used across the
// drivers and driver-invites services. Replaces the inline `^\+1\d{10}$`
// regex that was duplicated in services/drivers/src/apiTypes.ts.
export const PHONE_E164_US = /^\+1\d{10}$/


// From common/types-and-constants/src/constants/referrals.ts
export const VENDOR_REFERRAL_PERCENTAGE = 0.0035
export const PARTNER_REFERRAL_PERCENTAGE = 0.0035


// From common/types-and-constants/src/constants/scheduledWithdrawals.ts


// Constants for scheduled withdrawals. Design doc: docs/scheduled-withdrawals-feature-spec.md

/** Creation-time floor for a fixed-amount schedule. */
export const SCHEDULED_WITHDRAWAL_MIN_FIXED_AMOUNT_IN_CENTS = 50_00

/**
 * Creation-time ceiling for a fixed-amount schedule — $250k, which will almost certainly
 * never be hit; it exists so the column can safely be INTEGER (max ~$21.4M in cents) and so
 * a fat-fingered amount fails loudly at validation instead of downstream.
 */
export const SCHEDULED_WITHDRAWAL_MAX_FIXED_AMOUNT_IN_CENTS = 250_000_00

/** Execution-time floor for bucket_balance mode — below this the occurrence skips + notifies. */
export const SCHEDULED_WITHDRAWAL_BUCKET_MODE_FLOOR_IN_CENTS = 10_00

/**
 * Execution-time floor for a fixed-mode partial: when available < configured, withdraw the
 * available amount if it clears this floor (a $5 shortfall shouldn't kill the run), else
 * skip + notify.
 */
export const SCHEDULED_WITHDRAWAL_PARTIAL_FLOOR_IN_CENTS = 1_00

/**
 * Cap counts NON-CANCELED rows (active + paused): pausing keeps the slot, only canceling
 * frees it — otherwise pause could be used to hoard unbounded schedules.
 */
export const MAX_NON_CANCELED_SCHEDULED_WITHDRAWALS_PER_CUSTOMER = 10

/**
 * BP's `pay_dba_name` (the ACH statement descriptor) is hard-capped at 16 chars in
 * makeAchPayment. Every memo this feature builds must fit.
 */
export const BP_ACH_MEMO_MAX_LENGTH = 16

export const SCHEDULED_WITHDRAWAL_MEMO_PREFIX = 'TACH: '
/** Chars left for the category short name after the 6-char 'TACH: ' prefix. */
export const SHORT_MEMO_NAME_MAX_LENGTH =
  BP_ACH_MEMO_MAX_LENGTH - SCHEDULED_WITHDRAWAL_MEMO_PREFIX.length

/**
 * Statement descriptor for a scheduled withdrawal with no source bucket. Exactly 16 chars —
 * it fits the BP cap with ZERO slack, so any format change must re-check the length
 * (there's a test pinning this). Manual withdrawals keep 'Net Funds - TACH' unchanged.
 */
export const SCHEDULED_WITHDRAWAL_FALLBACK_MEMO = 'TACH: WITHDRAWAL'

/**
 * Statement short names for the static budget categories ('TACH: FUEL' etc.), each within
 * SHORT_MEMO_NAME_MAX_LENGTH. Exhaustive over StaticBudgetCategory by construction — adding
 * a static bucket without a short name is a compile error. Custom buckets derive theirs by
 * sanitizing the display name (see buildScheduledWithdrawalAchMemo).
 */
export const staticBudgetCategoryShortMemoNames: Record<StaticBudgetCategory, string> = {
  fuel: 'FUEL',
  preventative_maintenance: 'PMS',
  tires: 'TIRES',
  repairs: 'REPAIRS',
  insurance: 'INSURANCE',
  truck_payments: 'TRUCK PAY',
  licensing: 'LICENSING',
  tolls: 'TOLLS'
}


// From common/types-and-constants/src/constants/thirdPartyLogistics.ts
export const THIRD_PARTY_LOGISTICS_SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/
export const THIRD_PARTY_LOGISTICS_SLUG_MAX_LENGTH = 64

export const BRANDING_LOGO_PRESIGN_TTL_SECONDS = 3600 // 1 hour


// From common/types-and-constants/src/constants/transactions.ts
export const transactionExpenseCategories = {
  transferOut: {
    categoryName: 'transfer_out',
    categoryDescription:
      'Transactions where funds are moved out of the account to another destination, oftentimes a bank transfer, not an expense for goods and services',
    emoji_unicode: 'U+1F4E4', // outbox tray
    displayName: 'Withdrawal'
  }
}

export const transactionDepositCategories = {
  transferIn: {
    categoryName: 'transfer_in',
    categoryDescription:
      'Transactions where funds are transferred into the account from another source, oftentimes a bank transfer',
    emoji_unicode: 'U+1F4B8', // money with wings
    displayName: 'Deposit'
  },
  income: {
    categoryName: 'income',
    categoryDescription:
      'Transactions that reflect incoming funds, such as payments, earnings, or revenue, oftentimes direct deposit payments',
    emoji_unicode: 'U+1F4B5', // Banknote
    displayName: 'Income'
  },
  refund: {
    categoryName: 'refund',
    categoryDescription:
      'Transactions that are funds refunded to the customer by TACH, such as loan overpayments',
    emoji_unicode: 'U+1F504', // Counterclockwise Arrows
    displayName: 'Refund'
  }
}

export const transactionPausedCategories = {
  underReview: {
    categoryName: 'under_review',
    categoryDescription:
      'Transactions currently under review for further investigation or classification',
    emoji_unicode: 'U+23F8', // pause button
    displayName: 'Under Review'
  },
  onHold: {
    categoryName: 'on_hold',
    categoryDescription: 'Transactions temporarily paused or pending further action or approval',
    emoji_unicode: 'U+23F8', // pause button
    displayName: 'On Hold'
  }
}

export const transactionCategoriesEmpty = {
  null: {
    categoryName: null,
    categoryDescription: 'Category is not applicable or no category assigned',
    displayName: 'Null',
    emoji_unicode: 'U+1F6AB' // prohibited
  },
  zeroAmount: {
    categoryName: 'zero_amount',
    categoryDescription:
      'Transactions that have zero dollar amounts and do not require categorization',
    displayName: 'Zero Amount',
    emoji_unicode: 'U+0030' // zero
  },
  unknown: {
    categoryName: 'unknown',
    categoryDescription:
      'Transactions that could not be confidently classified into any known category',
    displayName: 'Unknown',
    emoji_unicode: 'U+2753' // question mark
  }
}

export const transactionReversalCategories = {
  reversal: {
    categoryName: 'reversal',
    categoryDescription: 'Transactions that reverse a previous authorization hold',
    emoji_unicode: 'U+21A9', // leftwards arrow with hook
    displayName: 'Reversal'
  }
}

export const transactionCategoriesBaseMap = {
  ...transactionCategoriesEmpty,
  ...transactionPausedCategories,
  ...transactionExpenseCategories,
  ...transactionDepositCategories,
  ...transactionReversalCategories
}

export const openAIModel = 'gpt-4o'

// Basis points (3600 = 36%). Per-customer overrides live on
// InternalBankAccounts.minimum_take_home_pay_bps — resolve via effectiveMinimumTakeHomePayBps.
export const defaultMinimumTakeHomePayBps = 3600

// Admin-settable override bounds. Above 70% the reserve starves budgeting and
// loan repayment (credit estimation zeroes out well before that).
export const minimumTakeHomePayBpsMin = 0
export const minimumTakeHomePayBpsMax = 7000

export enum TransactionTypes {
  Deposit = 'deposit',
  Debit = 'debit',
  Transfer = 'transfer',
  Payment = 'payment',
  Refund = 'refund',
  Reversal = 'reversal'
}

export enum TransactionLoadStatuses {
  NotApplicable = 'not_applicable',
  NotLoaded = 'not_loaded',
  LoadStaged = 'load_staged',
  Loaded = 'loaded'
}

// Web Connect (.qbo) SONRS identity: FI ORG and the Intuit bank id (INTU.BID) QuickBooks
// requires to accept the file. `ofxFiOrg` also names TACH as the FID on the `.ofx` (OFX 2.0 XML)
// flavor, which is not validated against Intuit's FI directory.
export const ofxFiOrg = 'TACH'

// Default/fallback INTU.BID + qbo FID when the `/{stage}/data-exports/qbo-intu-bid` SSM
// parameter is not set — see convertTransactionsToOfxAndUploadToS3.ts. '3000' is the id
// ProperSoft documents as an accepted Web Connect default; TACH has no Intuit-registered id of
// its own yet. Intuit can invalidate accepted ids over time, which is why this is overridable
// via SSM rather than requiring a redeploy to change. See
// docs/spec-tht790-qbo-web-connect-export-backend.md "Open decisions".
export const qboIntuBid = '3000'

// BALAMT for the `.qbo` flavor's LEDGERBAL aggregate. Placeholder until a real closing-balance
// source exists for this export path: QuickBooks Web Connect rejects a statement without
// LEDGERBAL (verified 2026-09-24), and the value only feeds the bank balance QuickBooks shows
// for the account, not reconciliation. See docs/spec-tht790-qbo-web-connect-export-backend.md.
export const qboLedgerBalAmount = '0.00'


// From common/types-and-constants/src/constants/vendorPrograms.ts
/**
 * Bridgestone Contractor Program (THT-716).
 *
 * SINGLE SOURCE OF TRUTH for the program's customer-facing redemption
 * content and for the identifiers that tie the Bridgestone vendor records
 * together. Consumed by:
 *  - services/charts resourcesConfig — the My Resources → Tires modal
 *  - services/vendor-business-locations — the synthetic "How to redeem"
 *    deal injected on Bridgestone marketplace location cards
 *  - temporal createBridgestoneLocations — creates/updates the vendor row
 *
 * Copy edits here reach every surface on the next backend deploy; the
 * frontends only render strings the API sends, so no web or mobile release
 * is needed.
 */

/**
 * The exact business_name of the national Bridgestone vendor. This string is
 * the join key between the Temporal importer (createOrUpdateNationalVendor
 * looks the vendor up by name), the marketplace deal injection, and the
 * cosmetic logo/marker special-cases in tach-ui and tach-mobile. Renaming
 * the vendor (e.g. via the admin portal) silently breaks that chain — and
 * the next importer run would create a duplicate vendor — so treat this as
 * immutable and migrate matching to BRIDGESTONE_VENDOR_SOURCE before ever
 * changing it.
 */
export const BRIDGESTONE_VENDOR_BUSINESS_NAME = 'Bridgestone Tires'

/**
 * Stamped on Vendors.source by the importer as a rename-proof marker for the
 * Bridgestone national vendor. New code should prefer matching on this once
 * the importer has re-run in an environment; name matching above is the
 * legacy convention it will replace.
 */
export const BRIDGESTONE_VENDOR_SOURCE = 'bridgestone_national'

const PRICE_BOOKS_LABEL = '#5054 / #5063'

/**
 * Redemption content per Bridgestone's guidance (Chris Holstein, BFUSA,
 * 2026-07-28): counter staff at most dealers — Love's especially — have never
 * transacted a Contractor Program sale (<4% of their fleet sales), so the
 * driver must lead with this script BEFORE the sale is rung up.
 */
export const BRIDGESTONE_CONTRACTOR_PROGRAM = {
  priceBooks: ['5054', '5063'],
  dealTitle: 'How to Redeem Your TACH Tire Discount',
  intro: `TACH members get fleet pricing on Bridgestone tires through our Bridgestone Contractor Program — Price Book ${PRICE_BOOKS_LABEL}.`,
  // Firestone is a Bridgestone brand covered by the SAME program and price
  // books; redemption still happens at Bridgestone dealer locations, so the
  // Firestone-facing intro leads with that pointer. The map name is composed
  // from BRIDGESTONE_VENDOR_BUSINESS_NAME so a vendor rename can't split the
  // copy from the deal-injection join key.
  firestoneIntro: `TACH members get fleet pricing on Firestone commercial tires through the same Bridgestone Contractor Program — Price Book ${PRICE_BOOKS_LABEL}. Redeem at Bridgestone dealer locations: find them under ${BRIDGESTONE_VENDOR_BUSINESS_NAME} on the vendor map.`,
  stepsHeading: "How to redeem at any Bridgestone dealer (including Love's):",
  steps: [
    `Before the sale, tell the counter rep: "I'm on a Bridgestone Contractor Program."`,
    `Give them Price Book ${PRICE_BOOKS_LABEL}.`,
    `If they don't know how to ring it up, ask: "Do you know how to transact a government or set retail sale?" A contractor program sale is transacted the same way.`,
    `Make sure they can apply the program before the sale or service is completed.`
  ]
} as const

const composeRedemptionScript = (intro: string): string => {
  const { stepsHeading, steps } = BRIDGESTONE_CONTRACTOR_PROGRAM
  const numberedSteps = steps.map((step, idx) => `${idx + 1}. ${step}`)
  return [intro, stepsHeading, ...numberedSteps].join('\n\n')
}

/**
 * The full plain-text redemption script. Every render surface (Resources
 * modals, marketplace deal description) must use these builders so the copy
 * is byte-identical everywhere.
 *
 * NOTE: the price books are an active-member benefit — every surface serving
 * these scripts must be gated to active customers (the Resources endpoint
 * 403s non-active customers; the marketplace injection checks the requester
 * explicitly).
 */
export const buildBridgestoneRedemptionScript = (): string =>
  composeRedemptionScript(BRIDGESTONE_CONTRACTOR_PROGRAM.intro)

/** Same program, Firestone-branded entry point — see firestoneIntro above. */
export const buildFirestoneRedemptionScript = (): string =>
  composeRedemptionScript(BRIDGESTONE_CONTRACTOR_PROGRAM.firestoneIntro)


// Types from account-deletion-requests service
export type CreateDeletionRequestRequest = {
  reason?: string
}


// Types from active-campaign service
export interface ProcessWebhookRequest {
  /** Raw webhook payload from ActiveCampaign */
  [key: string]: any
}

export interface ProcessWebhookResponse {
  /** Processing status */
  status: 'success' | 'error'
  /** Human-readable message about the processing result */
  message: string
  /** The type of event that was processed */
  processed_event_type?: string
}


// Types from addresses service
export interface CreateAddressRequest {
  customer_id: string
  address_st_number: string
  address_st_name: string
  address_unit?: string
  address_city: string
  address_state: string
  address_zip: string
}

export interface SetPrimaryAddressParams {
  address_id: string
}

export interface DeleteAddressParams {
  address_id: string
}

export interface GetAddressesParams {
  customer_id: string
}

export interface AddressResponse {
  address_id: string
  customer_id: string
  address_st_number: string
  address_st_name: string
  address_unit: string | null
  address_city: string
  address_state: string
  address_zip: string
  is_primary: boolean
  is_deleted: boolean
  created_at: Date
  updated_at: Date
}

export interface CreateAddressResponse {
  address: AddressResponse
}

export interface SetPrimaryAddressResponse {
  address: AddressResponse
}

export interface DeleteAddressResponse {
  success: boolean
}

export interface GetAddressesResponse {
  addresses: AddressResponse[]
}


// Types from admin-3pls service
export interface CreateThirdPartyLogisticsRequest {
  name: string
  slug?: string | null
  branding_scope?: ThirdPartyLogisticsBrandingScope
}

export interface PatchThirdPartyLogisticsRequest {
  name?: string
  is_active?: boolean
  slug?: string | null
  branding_scope?: ThirdPartyLogisticsBrandingScope
}

export enum LogoContentType {
  PNG = 'image/png',
  SVG = 'image/svg+xml',
  JPEG = 'image/jpeg',
  WEBP = 'image/webp'
}

export interface GenerateLogoUploadUrlRequest {
  content_type: LogoContentType
  file_size: number
}

export interface PatchLogoRequest {
  s3_bucket: string
  s3_key: string
}


// Types from admin-addresses service
export interface GetAddressesAdminRequest {
  customer_id: string
}

export interface CreateAddressAdminRequest {
  customer_id: string
  address_st_number: string
  address_st_name: string
  address_unit?: string
  address_city: string
  address_state: string // 2-letter state code
  address_zip: string // 5-digit ZIP
}

export interface UpdateAddressAdminRequest {
  address_st_number?: string
  address_st_name?: string
  address_unit?: string
  address_city?: string
  address_state?: string
  address_zip?: string
}

export interface DeleteAddressAdminRequest {
  address_id: string
}

export interface SetPrimaryAddressAdminRequest {
  address_id: string
}

export interface AddressResponse {
  address_id: string
  customer_id: string
  address_st_number: string
  address_st_name: string
  address_unit: string | null
  address_city: string
  address_state: string
  address_zip: string
  is_primary: boolean
  is_deleted: boolean
  created_at: Date
  updated_at: Date
}

export interface GetAddressesAdminResponse {
  addresses: AddressResponse[]
}

export interface CreateAddressAdminResponse {
  address: AddressResponse
}

export interface UpdateAddressAdminResponse {
  address: AddressResponse
}

export interface DeleteAddressAdminResponse {
  success: boolean
}

export interface SetPrimaryAddressAdminResponse {
  address: AddressResponse
}


// Types from admin-application-notes service
export interface CreateApplicationNoteRequest {
  application_id: string
  content: string
}

export interface UpdateApplicationNoteRequest {
  content: string
}

export interface ApplicationNoteResponse extends ApplicationNote {
  employee: {
    employee_id: string
    first_name: string
    last_name: string
  }
}

export enum ApplicationNoteEventType {
  CREATED = 'application_note_created',
  UPDATED = 'application_note_updated',
  DELETED = 'application_note_deleted'
}


// Types from admin-applications service
export interface VendorWithDealLocation extends Vendor {
  locations: VendorBusinessLocation[]
  deals: Deal[]
  contacts: VendorContactInfo[]
}

export interface PartnerWithContacts extends Partner {
  contacts: PartnerContactInfo[]
}

export interface FetchApplicationsByStatusResponse {
  applications?: Application[]
  partners?: PartnerWithContacts[]
  vendors?: VendorWithDealLocation[]
  total?: number
  limit?: number
  offset?: number
}

export interface DecideApplicationRequest {
  decision: 'approved' | 'denied'
  decided_at?: Date
  decided_by?: string
  status?: 'reviewed' | 'pending'
  unique_broker_id?: string
}

export interface DownloadDocResponse {
  docLink: string
}

export interface DownloadDocRequest {
  docPath: string
}

export interface VerifyCarrierIdentityStepResponse {
  decision: string
  decided_at: Date
  rejected_fields: string[]
  has_verified_manually_entered_identifier: boolean
  has_dot_or_mc_number: boolean
  authority_age_requirement_passed: boolean
  claimed_years_in_business: number
  has_no_published_identity_alerts: boolean
  interstate_carrier_authority_is_active: boolean
}

export interface VerifyClaimedRevenueStepResponse {
  decision: string
  decided_at: Date
  rejected_fields: string[]
  claimed_annual_revenue: number
}

export interface VerifyAnnualExpensesStepResponse {
  decision: string
  decided_at: Date
  rejected_fields: string[]
  claimed_annual_revenue: number
  annualExpenses: number
  annualDebtRepayment: number
}

export interface VerifyTractorsStepResponse {
  decision: string
  decided_at: Date
  rejected_fields: string[]
  owned_tractors: number
  term_leased_tractors: number
}

export interface VerifyDrivingRecordAndSafetyStepResponse {
  decision: string
  decided_at: Date
  rejected_fields: string[]
  is_satisfactory_safety_rating: boolean
  carrier_interstate_authority_check: string
  is_inspection_number_satisfactory: boolean
  is_vehicle_maintenance_acute_critical: boolean
  unsafe_driving_over_threshold: boolean
  substance_alcohol_over_threshold: boolean
  is_hos_compliance_acute_critical: boolean
  is_driver_fitness_acute_critical: boolean
  no_out_of_service_order: boolean
  fatal_crashes_total: number
  total_crashes: number
  claimed_years_in_business: number
}

export interface VerifyInsuranceStepResponse {
  decision: string
  decided_at: Date
  rejected_fields: string[]
  is_active_insurance: boolean
  automobile_liability: number
  cargo_liability: number
}

export interface VerifyMileageHistoryStepResponse {
  decision: string
  decided_at: Date
  rejected_fields: string[]
  mcs150_mileage: number
}

export interface VerifyKYCStepResponse {
  decision: string
  decided_at: Date
  rejected_fields: string[]
  id_verification_status: string
}

export interface PrequalLogResponse {
  carrierIdentity: VerifyCarrierIdentityStepResponse
  claimedRevenue: VerifyClaimedRevenueStepResponse
  annualExpenses: VerifyAnnualExpensesStepResponse
  tractors: VerifyTractorsStepResponse
  drivingRecordAndSafety: VerifyDrivingRecordAndSafetyStepResponse
  insurance: VerifyInsuranceStepResponse
  mileageHistory: VerifyMileageHistoryStepResponse
}

export type ApplicationSortField = (typeof ApplicationSortField)[keyof typeof ApplicationSortField]

export type ApplicationSortDirection =
  (typeof ApplicationSortDirection)[keyof typeof ApplicationSortDirection]

export interface FetchApplicationsByStatusRequest {
  applicationStatuses: ApplicationStatus[]
  applicationType: Entity
  limit?: number
  offset?: number
  /** Customer paths only; Vendor/Partner ignore these (THT-722 scope). */
  sortBy?: ApplicationSortField
  sortDirection?: ApplicationSortDirection
  /** THT-787: narrows every entity type/status segment (including `all`). Trimmed in the service, not here. */
  searchKeyword?: string
}

export interface UnderwritingLogResponse {
  carrierIdentity: VerifyCarrierIdentityStepResponse
  claimedRevenue: VerifyClaimedRevenueStepResponse
  annualExpenses: VerifyAnnualExpensesStepResponse
  tractors: VerifyTractorsStepResponse
  drivingRecordAndSafety: VerifyDrivingRecordAndSafetyStepResponse
  insurance: VerifyInsuranceStepResponse
  mileageHistory: VerifyMileageHistoryStepResponse
  kyc: VerifyKYCStepResponse
}

export interface RequestDocumentsRequest {
  document_request_types: DocumentRequestType[]
}

export interface PatchApplicationAdminRequest {
  dot_number?: string
  mc_number?: string
  application_step?: ApplicationStep
  total_business_debt?: number
  monthly_debt_payment?: number
  status?: ApplicationStatus
  verified_active_insurance?: boolean
  verified_cargo_liability?: number
  verified_automobile_liability?: number
  manually_verified_annual_revenue?: number
}

export interface PatchCustomerRecordAdminRequest {
  business_start_date?: string
  business_type?: SilaBusinessType
  ancillary_ownership?: OwnershipInfoForRequest[]
  business_name?: string
  motor_carrier_number?: string
  employer_id_number?: string
  phone_number?: string
  email?: string
  address_st_number?: string
  address_st_name?: string
  address_unit?: string
  address_city?: string
  address_state?: string
  address_zip?: string
  is_cash_advance_active?: boolean
  cash_advance_min_history_days?: CashAdvanceMinHistoryDays
  third_party_logistics_id?: string | null
  /** THT-675: `fleet` replaces the per-asset insurance sum with the amount below. */
  insurance_premium_mode?: InsurancePremiumMode
  /** THT-675: monthly fleet-wide premium in integer CENTS (not dollars). */
  fleet_insurance_premium_amount_cents?: number
}

export interface ApplicationWithEvents extends Application {
  events: Event[]
  assetReportAnalysis: AssetReportAnalysis | null
  currentTier: CustomerTier | null
}

export const ApplicationSortField = {
  StartedAt: 'started_at',
  UpdatedAt: 'updated_at'
} as const

export const ApplicationSortDirection = {
  Ascending: 'ASC',
  Descending: 'DESC'
} as const

export const DEFAULT_APPLICATION_SORT_FIELD: ApplicationSortField = ApplicationSortField.UpdatedAt

export const DEFAULT_APPLICATION_SORT_DIRECTION: ApplicationSortDirection =
  ApplicationSortDirection.Descending


// Types from admin-budget-items service
export interface FetchCustomerBudgetRequest {
  customer_id: string
}

export interface AdminBudgetOverrideState {
  admin_bucket_enabled: boolean
  admin_scale_bps: number | null
  /**
   * What `monthly_goal` would be with no admin adjustment applied — the customer's own target,
   * in dollars, before the enabled flag and the scale.
   *
   * On the wire because the client cannot derive it. A scaled bucket could be divided back out,
   * but a DISABLED one resolves to a goal of zero, and no amount of arithmetic recovers the
   * original from that — which is precisely the case where an operator wants to see what the
   * bucket would be saving if they turned it back on.
   *
   * Equal to `monthly_goal` whenever there is no adjustment, so the portal can compare the two
   * directly and show the original only when they differ.
   */
  unadjusted_monthly_goal: number
  /** ISO-8601, or null on a bucket no admin has ever touched. */
  admin_override_updated_at: string | null
  /**
   * The employee's id — our own key, and the join key for the name below. Not the auth sub: that
   * is an external identifier that changes if the IdP entry is recreated, and it cannot join to
   * Employee by primary key.
   */
  admin_override_updated_by: string | null
  /**
   * Resolved for display, and null whenever it cannot be: no override yet, or an employee record
   * that no longer exists. The sub id above is the durable record; this is a convenience, so the
   * portal never has to hold an employee directory of its own to render "set by".
   */
  admin_override_updated_by_name: string | null
}

export interface AdminBudgetItem extends BudgetItemComputed, AdminBudgetOverrideState {
  is_net_take_home_pay: boolean
}

export interface FetchCustomerBudgetResponse {
  budgetItems: AdminBudgetItem[]
}

export interface SetBudgetBucketOverrideRequest {
  customer_id: string
  category: string
  admin_bucket_enabled: boolean
  admin_scale_bps: number | null
}

export interface SetBudgetBucketOverrideResponse {
  /** What the bucket was holding when it was disabled; 0 when nothing was swept. */
  swept_amount: number
  redistribution_deltas: { category: string; amount: number }[]
  /** Nonzero only when the account was overdrawn — see the workflow response docs. */
  deficit_spread_amount: number
}


// Types from admin-cash-advances service
export interface FetchLoanRequestsRequest {
  decision?: string | null
  amount_order?: string
  asset_id?: string
  asset_type?: string
  customer_id?: string
  created_at_order?: string
  offset?: number
  limit?: number
  type?: LoanType
}

export interface RejectLoanRequestRequest {
  rejection_reason: CashAdvanceRejectionReason | FuelAdvanceRejectionReason
  employee_id: string
}

export interface ApproveFuelAdvanceRequest {
  employee_id: string
  adjusted_amount_cents?: number
}

export interface FundFuelAdvanceRequest {
  mercury_transaction_id: string
}

export interface PresentLoanTermsOptionsRequest {
  terms_ids: string[]
}

export interface PresentLoanTermsOptionsResponse {
  request_id: string
  presentation_attempt: number
  presented_terms_ids: string[]
  workflow_id: string
}

export interface RequestInfoFuelAdvanceRequest {
  note: string
}

export interface LoanRequestWithCustomer extends LoanRequest {
  customer: {
    business_name: string
  }
}

export interface LoanRequestDetails extends LoanRequest {
  loanItem?: Loan
  events: Event[]
  customer: {
    business_name: string
    email: string
    phone_number: string
  }
  credit_estimation: CustomerCreditEstimation
  minimum_loan_term_in_months: number
  loanOptions: LoanTermsOption[]
  budgeted_cash_reserves: number
  revenue_consistency: CustomerRevenueConsistencyMetrics
  canFund: boolean
  vendor?: Vendor
}


// Types from admin-debit-cards service
export interface AdminFreezeDebitCardRequest {
  debit_card_id: string
  is_frozen: boolean
}

export interface AdminCancelDebitCardRequest {
  debit_card_id: string
  reason?: string
}

export interface AdminCreateDebitCardRequest {
  customer_id: string
  card_type?: 'truck' | 'business'
  truck_id?: string
  address_id: string
  card_line_2?: string
}

export interface AdminDebitCardRow {
  debit_card_id: string
  customer_id: string
  card_type: 'business' | 'truck'
  truck: {
    truck_id: string
    truck_display_name: string
    truck_year: number
    truck_make: string
  } | null
  address: {
    address_id: string
    address_st_number: string
    address_st_name: string
    address_unit: string | null
    address_city: string
    address_state: string
    address_zip: string
    is_primary: boolean
  }
  last_four_digits: string | null
  frozen: boolean
  is_cancelled: boolean
  cancelled_at: Date | null
  physical_card_activated_timestamp: Date | null
  created_at: Date
  daily_spend_limit_cents: number
  thirty_day_spend_limit_cents: number
  banned_spend_categories: MccCategory[]
}

export interface AdminCardErrorBody {
  kind: CardErrorKind | 'bad_request'
  field?: string
  workflow_id?: string
  started_at?: string
}


// Types from admin-deposit-invoices service
export enum InvoiceViewedStatus {
  NOT_VIEWED = 'not_viewed',
  VIEWED = 'viewed'
}

export interface ListInvoicesRequest {
  status?: InvoiceViewedStatus
  limit?: number
  offset?: number
}

export interface UnmarkViewedRequest {
  deposit_invoice_id: string
}

export interface InvoiceListItem {
  deposit_invoice_id: string
  transaction_id: string
  customer_id: string
  business_name: string
  deposit_amount_cents: number
  deposit_date: Date
  file_type: string
  uploaded_at: Date
  current_status: InvoiceViewedStatus
}

export interface ListInvoicesResponse {
  deposit_invoices: InvoiceListItem[]
  total_count: number
  has_more: boolean
}

export interface GetInvoiceDetailsResponse {
  deposit_invoice_id: string
  transaction_id: string
  customer_id: string
  customer_name: string
  deposit_amount_cents: number
  deposit_date: Date
  file_type: string
  file_size_bytes: number
  uploaded_at: Date
  presigned_url: string
  audit_log: AuditLogItem[]
}

export interface AuditLogItem {
  action: DepositInvoiceEventSubtype
  employee_id: string
  employee_name: string
  created_at: Date
}


// Types from admin-document-requests service
export interface RequestDocumentRequest {
  application_id: string
  document_requests: DocumentRequestInfo[]
}

export interface DocumentRequestInfo {
  document_type: DocumentRequestType
  request_reason: DocumentRequestReason
  target_info?: DocumentRequestTargetInfo | null // Nullish if no target info is provided
}

export interface DocumentRequestTargetInfo {
  target_id: string
  target_type: DocumentRequestTarget
}

export interface RequestDocumentResponse {
  requested_document_count: number
}

export interface RejectDocumentRequest {
  rejection_reason: DocumentRejectionReason
}

export interface ReRequestDocumentRequest {}

export interface ListDocumentsForApplicationResponse {
  document_requests: DocumentRequest[]
}

export interface GetDocumentPresignedUrlResponse {
  mime_type: string
  presigned_url: string
  expires_at_utc_epoch: number
}

export interface SendDocumentsToBluePenguinRequest {
  document_request_ids: string[]
  customer_id: string
  to: string[]
  cc?: string[]
  force_resend?: boolean
}

export interface SendDocumentsToBluePenguinResponse {
  success: boolean
  document_request_ids_sent: string[]
  workflow_id: string
}

export interface UploadDocumentOnBehalfRequest {
  file_name: string
  file: string // raw base64, no `data:` prefix
  notes?: string
}

export interface UploadDocumentOnBehalfResponse {
  document_request_id: string
  status: DocumentRequestStatus
  document_s3_path: string
  application_status_synced: boolean
}

export const BLUE_PENGUIN_EMAIL_DOMAIN = 'bluepenguin.com'

export const UPLOAD_ON_BEHALF_NOTES_MAX_LENGTH = 1000


// Types from admin-emails service
export interface FetchEmailsForUserRequest {
  template_type?: string // Optional filter by template type
  status?: 'pending' | 'sent' | 'failed' // Optional filter by status
  sort_order?: 'asc' | 'desc' // Sort by created_at (default: desc)
  limit?: number // Pagination limit (default: 50, max: 100)
  offset?: number // Pagination offset (default: 0)
}

export interface AttachmentReference {
  filename: string
  s3_bucket: string
  s3_key: string
  contentType: string
}

export interface AttachmentWithPresignedUrl extends AttachmentReference {
  presigned_url: string
}

export interface EmailSendData {
  email_send_id: string
  owner_id: string | null
  entity_type: string
  email_recipient_type: string
  template_type: string
  status: string
  s3_key: string | null
  attachments: AttachmentReference[] | null
  to_address: string
  from_address: string
  bcc_addresses: string[] | null
  cc_addresses: string[] | null
  subject: string
  sent_at: Date | null
  created_at: Date
  updated_at: Date
}

export interface EmailWithPresignedUrl extends EmailSendData {
  s3_presigned_url?: string | null // Presigned URL to view the email
  attachments_with_urls?: AttachmentWithPresignedUrl[] | null // Attachments with presigned URLs
}

export interface FetchEmailsForUserResponse {
  emails: EmailWithPresignedUrl[]
  total_count: number
  has_more: boolean
}


// Types from admin-employees service
export interface EmployeeLoginRequest {
  email: string
}


// Types from admin-feature-flags service
export interface CreateFeatureFlagRequest {
  flag_key: string
  name: string
  description: string
  flag_type?: FlagType
  default_value?: boolean | string | number
  environments?: Record<string, boolean>
  tags?: string[]
  rollout_percentage?: number
  rollout_type?: RolloutType
  rollout_sticky?: boolean
}

export interface UpdateFeatureFlagRequest {
  name?: string
  description?: string
  default_value?: boolean | string | number
  environments?: Record<string, boolean>
  tags?: string[]
  rollout_percentage?: number
  rollout_type?: RolloutType
  rollout_sticky?: boolean
}

export interface CreateRolloutScheduleRequest {
  template_key?: string
  phases?: Array<{
    phase_number: number
    percentage: number
    duration_days: number
    require_approval?: boolean
    metrics_threshold?: any
  }>
}

export interface NotificationRequest {
  subject: string
  message: string
}

export interface CreateSystemAlertRequest {
  alert_type: SystemAlertType
  title: string
  message: string
  severity: SystemAlertSeverity
  affected_services?: string[]
  flag_id?: string
  target_type?: TargetType
  start_time?: Date
  end_time?: Date
}

export interface NotificationResponse {
  success: boolean
  total_recipients: number
  emails_sent: number
  emails_failed: number
  errors: Array<{
    user_id: string
    email: string
    error: string
  }>
}

export interface AffectedUsersResponse {
  flag_key: string
  flag_name: string
  total_users: number
  users: Array<{
    id: string
    email: string
    name: string
    type: 'customer' | 'driver' | 'partner'
  }>
}

export interface CreateFlagOverrideRequest {
  customer_id: string
  value: boolean | string | number
  expires_at?: string
}


// Types from admin-internal-bank-accounts service
export interface PatchInternalBankAccountAdminRequest {
  take_home_pay_sweep_enabled?: boolean
  // Basis points (3600 = 36%); null clears the override back to the global default
  minimum_take_home_pay_bps?: number | null
}


// Types from admin-marketing service
export interface PrePrequalLeadsResponse {
  leads: PrePrequalContact[]
}

export interface PrePrequalContact {
  mc_number: string
  email_primary: string | null
  email_secondary?: string
  phone_primary: string | null
  phone_secondary?: string
  pass_percentage: number
  legal_name: string
  dba_name: string | null
  connection: string | null
  dot_number: number
  rejected_fields: string[]
  dispatch_contact: {
    name: string | null
    phone: string | null
    email_address: string | null
  }
  tax_identifiers: {
    is_type: string
    value: string
    source: string
  }[]
  identifiers: {
    is_type: string
    value: string
  }[]
  email_addresses: {
    is_type: string
    value: string
  }[]
  phones: {
    is_type: string
    value: string
  }[]
  addresses: {
    is_type: string
    street1: string
    street2: string
    city: string
    postal_code: string
    state: string
    nationality: string
  }[]
}

export interface PrePrequalLeadsRequest {
  mcNumbers: string[]
  brokerId?: string
}

export interface GetCampaignPerformanceRequest {
  campaignId: string
  startDate?: string
  endDate?: string
}

export interface CampaignPerformanceResponse {
  campaign: {
    id: string
    name: string
  }
  metrics: {
    sent: number
    opened: number
    clicked: number
    bounced: number
    unsubscribed: number
    replied: number
  }
  conversionFunnel: {
    emailsSent: number
    emailsOpened: number
    emailsClicked: number
    micrositeVisits: number
    applicationStarts: number
    completedSignups: number
    openRate: number
    clickRate: number
    micrositeConversionRate: number
    signupConversionRate: number
  }
  variantPerformance?: Array<{
    variantId: string
    variantName: string
    metrics: {
      sent: number
      opened: number
      clicked: number
      converted: number
      openRate: number
      clickRate: number
      conversionRate: number
    }
  }>
  abTestResults?: {
    winner?: string
    confidence?: number
  }
}

export interface GetMarketingAnalyticsRequest {
  brokerId?: string
  startDate?: string
  endDate?: string
  groupBy?: 'campaign' | 'variant' | 'broker'
  provider?: 'lemlist' | 'activecampaign' | 'all'
}

export interface MarketingAnalyticsResponse {
  summary: {
    totalCampaigns: number
    totalLeadsSent: number
    totalLeadsEngaged: number
    averageOpenRate: number
    averageClickRate: number
    averageConversionRate: number
  }
  campaigns: Array<{
    campaignId: string
    campaignName: string
    provider: string
    brokerId: string
    brokerName: string
    metrics: {
      sent: number
      opened: number
      clicked: number
      converted: number
      openRate: number
      clickRate: number
      conversionRate: number
    }
  }>
  topPerformingVariants: Array<{
    variantId: string
    variantName: string
    conversionRate: number
    sampleSize: number
  }>
  retargetingSegments: Array<{
    segmentType: string
    leadCount: number
    averageDaysSinceLastEvent: number
  }>
}

export interface GetRetargetingSegmentsRequest {
  brokerId?: string
  maxDaysSinceContact?: number
}

export interface RetargetingSegmentsResponse {
  segments: {
    noOpen: {
      count: number
      leads: Array<{
        leadId: string
        email: string
        companyName: string
        daysSinceLastContact: number
        lastCampaignId: string
      }>
    }
    openedNoClick: {
      count: number
      leads: Array<{
        leadId: string
        email: string
        companyName: string
        daysSinceLastContact: number
        lastCampaignId: string
      }>
    }
    clickedNoSignup: {
      count: number
      leads: Array<{
        leadId: string
        email: string
        companyName: string
        daysSinceLastContact: number
        lastCampaignId: string
      }>
    }
    abandonedSignup: {
      count: number
      leads: Array<{
        leadId: string
        email: string
        companyName: string
        daysSinceLastContact: number
        applicationId: string
      }>
    }
  }
}

export interface SyncLeadsToLemlistRequest {
  brokerId?: string
  leadIds?: string[]
}

export interface SyncLeadsToLemlistResponse {
  totalLeads: number
  successful: number
  failed: number
  errors: Array<{
    leadId: string
    email: string
    error: string
  }>
}

export interface ListLemlistCampaignsRequest {
  limit?: number
  offset?: number
  status?: 'draft' | 'running' | 'paused' | 'ended' | 'archived'
}

export interface ListLemlistCampaignsResponse {
  campaigns: Campaign[]
  pagination: {
    limit: number
    offset: number
    total: number
  }
}

export interface SearchLeadsRequest {
  lead_type: 'carrier' | 'broker'
  filters?: {
    // Common filters
    lead_id?: string
    created_at_from?: string
    created_at_to?: string
    updated_at_from?: string
    updated_at_to?: string
    email?: string
    email_secondary?: string
    mobilephone?: string
    mobilephone_secondary?: string
    pass_percentage_min?: number
    pass_percentage_max?: number
    legal_name?: string
    mc_number?: string
    dot_number?: string
    owner_billing_contact_name?: string
    address_1_street_1?: string
    address_1_street_2?: string
    address_1_city?: string
    address_1_state?: string
    address_1_zip?: string
    address_1_country?: string
    address_2_street_1?: string
    address_2_street_2?: string
    address_2_city?: string
    address_2_state?: string
    address_2_zip?: string
    address_2_country?: string
    dispatch_contact_name?: string

    // ETID (email_template_id) attribution parts — carrier-only, matched case-insensitively.
    etid_lead_source?: string
    etid_referral_type?: string
    etid_referred_by?: string
    etid_campaign_source?: string
    etid_creative?: string

    // Marketing fields
    source_broker_ids?: string[]
    lemlist_lead_id?: string
    activecampaign_contact_id?: string
    activecampaign_deal_id?: string
    marketing_status?: string | string[]
    last_engagement_date_from?: string
    last_engagement_date_to?: string
    unsubscribed_at_from?: string
    unsubscribed_at_to?: string
    is_unsubscribed?: boolean

    // Carrier-specific filters
    is_qualified?: boolean
    total_trucks_min?: number
    total_trucks_max?: number

    // Broker-specific filter
    website?: string

    // Text search (searches across multiple fields)
    search_text?: string
  }
  sort_by?: string
  sort_order?: 'ASC' | 'DESC'
  page?: number
  page_size?: number
  include_marketing_events?: boolean
}

export interface ExportLeadsRequest {
  lead_type: 'carrier' | 'broker'
  filters?: SearchLeadsRequest['filters']
  sort_by?: string
  sort_order?: 'ASC' | 'DESC'
}

export interface ExportLeadsResponse {
  download_url: string
  row_count: number
  expires_in_seconds: number
}

export interface EtidOptionsRequest {
  lead_type: 'carrier' | 'broker'
}

export interface SearchLeadsResponse {
  leads: any[]
  total_count: number
  page: number
  page_size: number
  total_pages: number
}

export interface PushLeadsToCampaignRequest {
  lead_type: 'carrier' | 'broker'
  campaign_id: string
  provider: 'lemlist' | 'activecampaign'
  send_immediately?: boolean
  update_existing?: boolean

  // Option 1: Push specific leads by ID
  lead_ids?: string[]

  // Option 2: Push all leads matching filters
  push_all_filtered?: boolean
  filters?: SearchLeadsRequest['filters']
}

export interface PushLeadsToCampaignResponse {
  total_requested: number
  total_found: number
  total_with_lemlist_id: number
  successfully_added: number
  failed: number
  skipped: number
  details: {
    not_found: string[]
    missing_lemlist_id: Array<{ lead_id: string; email: string }>
    successfully_added: Array<{ lead_id: string; email: string }>
    failed_to_add: Array<{ lead_id: string; email: string; error: string }>
  }
}

export type EtidOptionColumn = (typeof ETID_OPTION_COLUMNS)[number]

export type EtidOptionsResponse = Record<EtidOptionColumn, string[]>

export const ETID_OPTION_COLUMNS = [
  'etid_lead_source',
  'etid_referral_type',
  'etid_referred_by',
  'etid_campaign_source',
  'etid_creative'
] as const


// Types from admin-monitoring service
export interface FetchFinancialHealthReportsResponse {
  reports: CustomerFinancialHealthReportResponse[]
  customer_id: string
  total_count: number
}

export interface CustomerFinancialHealthReportResponse {
  report_id: string
  created_at: Date
  customer_id: string
  report_period_start: Date
  report_period_end: Date
  // Revenue metrics (in cents)
  current_week_revenue: number
  previous_week_revenue: number
  average_weekly_revenue: number
  revenue_change_percentage: number
  // Expense metrics (in cents)
  current_week_expenses: number
  previous_week_expenses: number
  average_weekly_expenses: number
  expense_change_percentage: number
  // Cashflow metrics (in cents)
  current_week_cashflow: number
  previous_week_cashflow: number
  average_weekly_cashflow: number
  cashflow_change_percentage: number
  // Status and alerts
  status: string
  alert_triggered: boolean
  alert_reason: string | null
  weeks_of_data_analyzed: number
}

export interface TriggerFinancialHealthWorkflowResponse {
  workflow_id: string
  customer_id: string
  message: string
}

export interface FetchReportsQueryParams {
  limit: number
  offset: number
}


// Types from admin-partners service
export interface PatchPartnerAdminRequest {
  email?: string
  business_name?: string
  business_phone_number?: string
  description_of_services?: string
  address_st_number?: string
  address_st_name?: string
  address_unit?: string
  address_city?: string
  address_state?: string
  address_zip?: string
  website_url?: string
  referral_code?: string
  unique_broker_id?: string
  business_email?: string
  phone_number?: string
}

export interface GenerateBrokerLeadsUploadUrlRequest {
  file_name: string
  content_type?: string
}

export interface ProcessBrokerLeadsRequest {
  file_key: string
}


// Types from admin-transactions service
export interface VerifyDirectDepositRequest {
  transaction_id: string
  is_direct_deposit: boolean
}

export interface FetchTransactionsRequest {
  offset?: number
  limit?: number
  searchQuery?: string
  startDate?: string
  endDate?: string
  isAmountDescending?: boolean
  isDateDescending?: boolean
  category?: string
  orderBy?: string
}

export interface DashboardMetricsRequest {
  startDate: string
  endDate: string
}

export interface DashboardMetricsResponse {
  newCustomers: number
  pendingCustomerApplications: number
  pendingVendorApplications: number
  pendingPartnerApplications: number
  newPartners: number
  newVendors: number
  tachFeeRevenue: number
  totalCarrierRevenue: number
  averageCarrierRevenue: number
}

export interface CustomerSummaryCard {
  debit_card_id: string
  last_four_digits: string | null
  frozen: boolean
  is_cancelled: boolean
  activated_at: string | null
}

export interface CustomerSummaryResponse {
  account_balance_cents: number
  inflows_last_30d_cents: number
  inflows_all_time_cents: number
  card_spend_last_14d_cents: number
  card_spend_all_time_cents: number
  days_since_last_deposit: number | null
  tach_fees_collected_last_30d_cents: number
  activated_cards_count: number
  cards: CustomerSummaryCard[]
}

export type DepositRowStatus = 'pending' | 'completed' | 'failed'

export interface FetchCustomerDepositsRequest {
  customer_id: string
  limit?: number
  offset?: number
  status?: DepositRowStatus
  from?: string
  to?: string
}

export interface FetchCustomerPendingTransactionsRequest {
  customer_id: string
  limit?: number
  offset?: number
  status?: PendingTransactionStatus
  from?: string
  to?: string
}

export interface AdminPendingTransactionRow {
  pending_transaction_id: string
  amount_in_cents: number // signed: + = money in (deposit), − = money out (withdrawal)
  direction: 'in' | 'out'
  category: string
  description: string | null
  status: PendingTransactionStatus
  external_id: string | null // provider movement id (e.g. the Sila pull txn)
  idempotency_key: string | null
  failure_code: string | null
  failure_reason: string | null
  failed_at: string | null // ISO
  resulting_transaction_id: string | null
  cleared_at: string | null // ISO
  created_at: string // ISO
  updated_at: string // ISO
}

export interface FetchCustomerPendingTransactionsResponse {
  pendingTransactions: AdminPendingTransactionRow[]
  total: number
}

export type DepositRail = 'ACH' | 'WIRE' | 'LIQUIDITY' | 'INFLOW'

export interface DepositRowDTO {
  id: string
  source: 'deposit' | 'transaction'
  amount_in_cents: number
  status: 'pending' | 'completed' | 'failed'
  deposit_origin: string
  movement_type: string | null
  created_at: string
  processed_at: string | null
  deposit_landed_at: string | null
  error_type: string | null
  error_description: string | null
  rail: DepositRail
  originator_name: string | null
}

export interface FetchCustomerDepositsResponse {
  deposits: DepositRowDTO[]
  total: number
}

export interface FetchCustomerTransactionsRequest {
  customer_id: string
  from?: string
  to?: string
  limit?: number
  offset?: number
  category?: string
  type?: string
  debit_card_id?: string
  // 'all' opts out of the date window entirely (skips defaults, returns from
  // beginning to now). Used by the FE "All time" preset.
  since?: 'all'
}

export interface FetchCustomerTransactionsResponse {
  transactions: any[]
  total: number
}

export interface FetchCustomerSummaryRequest {
  customer_id: string
}

export interface FetchAllDepositsArgs {
  limit: number
  offset: number
  status?: DepositRowStatus
  needsAttention?: boolean
  from?: Date
  to?: Date
  search?: string
}

export interface AllDepositRowDTO {
  deposit_id: string
  customer_id: string
  business_name: string
  amount_in_cents: number
  status: DepositRowStatus
  deposit_origin: string
  movement_type: string | null
  rail: DepositRail
  originator_name: string | null
  created_at: string
  processed_at: string | null
  error_type: string | null
  error_description: string | null
}

export interface FetchAllDepositsResponse {
  deposits: AllDepositRowDTO[]
  total: number
}

export const DEFAULT_DEPOSITS_FEED_LIMIT = 25

export const MAX_DEPOSITS_FEED_LIMIT = 100


// Types from admin-users service
export interface FetchAllUsersResponse {
  users: UserWithType[]
}

export interface TriggerNewCustomerWorkflowRequest {
  customer_id: string
  application_id: string
  skip_sila_manual_override?: boolean
}

export interface ApproveBluePenguinDocumentsRequest {
  customer_id: string
  application_id: string
}

export type AssetType = 'truck' | 'trailer'

export interface PatchDriverAdminRequest {
  first_name?: string
  last_name?: string
  email?: string
  phone_number?: string
  ssn?: string
  address_st_number?: string
  address_st_name?: string
  address_unit?: string
  address_city?: string
  address_state?: string
  address_zip?: string
  date_of_birth?: string
  position?: string
  truck_id?: string
  drivers_license_number?: string
  drivers_license_state?: string
  business_ownership_percentage?: number
}

export interface PatchCustomerAssetRequest {
  customer_id: string
  ownership_status: OwnershipStatus
  pay_for_repairs: boolean
  tire_brand_quality: TireBrandQuality
  insurance_payment_amount: number
  vehicle_id_number?: string
  // Truck-specific fields
  truck_display_name?: string
  starting_mileage?: number
  typical_annual_mileage?: number
  is_out_of_service?: boolean
  out_of_service_reason?: string
  engine_condition?: EngineCondition
  truck_payment_amount?: number
  truck_class_number?: number
  truck_class?: TruckClassCategories
  truck_year?: number
  truck_make?: string
  truck_model?: string
  // Trailer-specific fields
  trailer_display_name?: string
  trailer_payment_amount?: number
  trailer_year?: number
  trailer_make?: string
  trailer_model?: string
}

export type CreateAssetRequestAdmin = (CreateTruckRequest | CreateTrailerRequest) & {
  asset_type: 'truck' | 'trailer'
}


// Types from admin-vendors service
export interface PatchVendorAdminRequest {
  primary_vendor_type?: VendorType
  email?: string
  business_name?: string
  business_phone_number?: string
  description_of_services?: string
  address_st_number?: string
  address_st_name?: string
  address_unit?: string
  address_city?: string
  address_state?: string
  address_zip?: string
  website_url?: string
  referral_code?: string
  alternative_phone_number?: string
  secondary_vendor_types?: VendorType[]
  business_email?: string
  phone_number?: string
}


// Types from applications service
export interface UpsertApplicationRequest {
  // Create/upsert fields
  customer_id: string
  average_annual_revenue?: number
  years_in_business?: number
  application_step?: ApplicationStep
  referral_code_used?: string
  selected_tier?: TierType
  // Update-only fields (used when updating existing application)
  application_id?: string // Used for patch operations
  id_verification_id?: string
  total_business_debt?: number
  monthly_debt_payment?: number
  debt_form_data?: DebtFormData[]
  status?: ApplicationStatus
  ancillary_ownership_submitted?: boolean
  asset_summary?: ApplicationAssetSummary
  factoring_company_name?: string | null
  eld_provider?: EldProvider | null
  eld_provider_other?: string | null
}

export interface PatchApplicationRequest {
  application_step?: ApplicationStep
  id_verification_id?: string
  total_business_debt?: number
  monthly_debt_payment?: number
  status?: ApplicationStatus
}

export interface CreateApplicationRequest {
  customer_id: string
  average_annual_revenue?: number
  years_in_business?: number
  application_step?: string
  referral_code_used?: string
}

export interface CreateApplicationResponse {
  application: Application
  isNewlyCreated: boolean
}

export interface UpsertApplicationResponse {
  application: Application
  isNewlyCreated: boolean
}

export interface UploadDocumentForRequestRequest {
  file_name: string
  fileBuffer: Buffer
}


// Types from assets service
export interface TruckWithSnapshot extends TrucksAndMostRecentOutOfServiceLog {
  mileageRequest: TruckMileageSnapshot | null
}

export type Asset = (TruckWithSnapshot | Trailer) & {
  asset_type: 'truck' | 'trailer'
}

export type CreateAssetRequest = (CreateTruckRequest | CreateTrailerRequest) & {
  asset_type: 'truck' | 'trailer'
}

export type BulkAssetCreationRequest = {
  assets: CreateAssetRequest[]
}

export interface CreateSkeletonTruckRequest {
  truck_type: TruckType
  truck_year: number
  truck_make: string
  truck_model?: string
  approximate_mileage: number
  unit_number?: string
  ownership_status: OwnershipStatus
  truck_payment_amount?: number
}

export interface CreateSkeletonTrailerRequest {
  trailer_type: TrailerType
  trailer_year: number
  trailer_make: string
  trailer_model?: string
  unit_number?: string
  ownership_status: OwnershipStatus
  trailer_payment_amount?: number
}

export type CreateSkeletonAssetRequest = (
  | CreateSkeletonTruckRequest
  | CreateSkeletonTrailerRequest
) & {
  asset_type: 'truck' | 'trailer'
}

export type BulkSkeletonAssetCreationRequest = {
  assets: CreateSkeletonAssetRequest[]
}


// Types from auth service
export interface SignupRequest {
  email: string
  password: string
}

export type SignupResponse = {
  access_token: string
  refresh_token: string
  sub_id: string
}

export interface LoginRequest {
  email: string
  password: string
}

export type LoginResponse = {
  customer: Customer
  access_token: string
  refresh_token: string
  sub_id: string
}

export type RefreshRequest = {
  refresh_token: string
}

export type RefreshAccessTokenResponse = {
  access_token: string
  refresh_token: string
}

export type LogoutRequest = {
  refresh_token: string
}

export interface ResetPasswordRequest {
  email: string
}


// Types from broker-contacts service
export interface CreateBrokerContactRequest {
  broker_name: string
  broker_email?: string
  broker_phone?: string
  broker_website?: string
}


// Types from budget-items service
export interface CreateCustomBudgetItemRequest {
  annualBudgetedAmount: number
  timeWindowInMonths: number
  categoryDisplayName: string
  emojiUnicode: string
}

export interface MonthlyBudgetMetrics extends BudgetItemComputed {
  spent: number
  saved: number
  rollover: number
  recent_transactions: Transaction[]
}

export interface PatchCustomBudgetItemRequest {
  annualBudgetedAmount?: number
  timeWindowInMonths?: number
  categoryDisplayName?: string
  emojiUnicode?: string
}

export interface PatchCustomBudgetItemParams {
  customer_id: string
  category: string
  requestBody: PatchCustomBudgetItemRequest
}

export interface DeleteCustomBudgetItemRequestParams {
  customer_id: string
  category: string
  destination_account_id?: string
}


// Types from charts service
export type ResourceItemType = 'link' | 'modal' | 'phone'

export interface BaseResourceItem {
  id: string
  name: string
  description: string
  logoUrl: string
}

export interface LinkResourceItem extends BaseResourceItem {
  type: 'link'
  url: string
}

export interface PhoneResourceItem extends BaseResourceItem {
  type: 'phone'
  phoneNumber: string
}

export interface ModalResourceItem extends BaseResourceItem {
  type: 'modal'
  modalContent: {
    longDescription: string
    cta?: { label: string; url: string }
  }
}

export type ResourceItem = LinkResourceItem | PhoneResourceItem | ModalResourceItem

export interface ResourceSection {
  id: string
  title: string
  items: readonly ResourceItem[]
}

export interface CostRevenuePerMileData {
  month: string
  year: string
  cpm: number
  rpm: number
}

export interface RevenueExpensesData {
  month: string
  revenue: number
  expenses: number
}

export interface IntervalRevenueExpensesData {
  date: string
  revenue: number
  expenses: number
}

export interface BudgetBreakdownData {
  amount: number
  category: string
  category_display_name: string
  type: 'income' | 'expense'
}

export interface CentsPerDollarSubCategory {
  name: string
  category: string
  centsPerDollar: number
  type: string
  emoji_unicode: string
}

export interface CentsPerDollarBreakdownData extends CentsPerDollarSubCategory {
  subCategories: CentsPerDollarSubCategory[]
}

export interface IncomeTransaction extends Transaction {
  truck_display_name: string
  truck_id: string
  total: number
}

export interface ExpenseTransaction extends Transaction {
  category: string
  total: number
}

export interface BudgetedVsTargetByCategoryData {
  month: string
  target: number
  actual: number
}

export interface TruckRevenueExpenseCategory {
  category: string
  amount: number
  color: string
}

export interface TruckRevenueExpenseData {
  truckId: string
  truckName: string
  truckMake: string
  truckModel: string
  truckYear: number
  revenue: number
  netTakeHome: number
  expenses: TruckRevenueExpenseCategory[]
}

export interface TruckBudgetCategory {
  category: string
  amount: number
  color: string
}

export interface TruckBudgetedVsSpentData {
  truckId: string
  truckName: string
  truckMake: string
  truckModel: string
  truckYear: number
  totalBudgeted: number
  totalSpent: number
  budgetedCategories: TruckBudgetCategory[]
  spentCategories: TruckBudgetCategory[]
}


// Types from corporate-billing service
export interface DecodedApplicationToken {
  owner_type: string
  vendor_id?: string
  customer_id?: string
  exp: number
}

export interface DecodedCreditToken {
  loan_request_id: string
  exp: number
}


// Types from credit service
export type CreateLoanRequestRequest = {
  customer_id: string
  amount: number
  reason: string
  vendor_id: string | null
  po_number: string | null
  invoice_number: string
  date_of_invoice: string
  asset_id: string | null
  asset_type: string | null
  type?: LoanType
  load_value?: number // dollars, for fuel advances
  delivery_date?: string // ISO string, for fuel advances
}

export interface LoanDetails extends Loan {
  loanRequest: {
    reason: string
    amount: number
    fuel_advance_status?: string | null
  }
  payments: Partial<Payment>[]
}

export interface LoanWithReason extends Loan {
  loanRequest: {
    reason: string
  }
  is_mock?: boolean
  decision?: string
  fuel_advance_status?: string | null
}

export type FetchLoansRequestBody = {
  customer_id: string
  status: string
  order_by?: string
  order_direction?: string
  type?: LoanType
}

export enum FetchLoansOrderBy {
  END_DATE = 'end_date',
  ORIGINATED_AT = 'originated_at',
  CURRENT_BALANCE = 'current_balance',
  CASH_TO_CUSTOMER = 'cash_to_customer'
}

export interface LoanRequestWithTerms extends LoanRequest {
  loanTermsOptions: LoanTermsOption[]
}

export interface SelectPresentedLoanOptionRequest {
  terms_id: string
}

export interface DeclineLoanOptionsRequest {
  reason?: string
}

export interface ManualCashAdvancePaymentRequest {
  amount_cents?: number
  pay_in_full?: boolean
}


// Types from customers service
export interface PatchCustomerRequest {
  phone_number?: string
  address_st_number?: string
  address_st_name?: string
  address_unit?: string
  address_city?: string
  address_state?: string
  address_zip?: string
  business_name?: string
  employer_id_number?: string
  cb_consent_given?: boolean
  state_of_registration?: string
  motor_carrier_number?: string
  dot_number?: string
  owns_their_mc_dot_number?: boolean
  other_mc_dot_number_owner_name?: string
  other_beneficial_owners?: boolean
  ancillary_ownership?: OwnershipInfoForRequest[]
  /** ETID attribution (THT-619): applied set-if-null only, see patchCustomer */
  email_template_id?: string
  /** THT-675: `fleet` replaces the per-asset insurance sum with the amount below. */
  insurance_premium_mode?: InsurancePremiumMode
  /** THT-675: monthly fleet-wide premium in integer CENTS (not dollars). */
  fleet_insurance_premium_amount_cents?: number
}

export interface CustomerWithCredit extends Customer {
  available_credit: number
}

export interface CarrierExistsRequest {
  identifier: string
  identifierType: 'mc' | 'dot'
}

export interface SignMsaRequest {
  signatureFullName: string
  agreementChecked: boolean
  signedAt: string
  version?: string
  /** Set server-side from Lambda event context — not accepted from client */
  ipAddress?: string
}

export interface SignBankAgreementRequest {
  signatureFullName: string
  agreementChecked: boolean
  signedAt: string
  version?: string
  /** Set server-side from Lambda event context — not accepted from client */
  ipAddress?: string
}

export interface CreateCustomerRequest {
  email?: string
  phone_number?: string
  email_verified: boolean
  sub_id?: string
  selected_tier?: TierType
  email_template_id?: string
  third_party_logistics_slug?: string | null
}

export interface CustomerWithDriverOnboarding extends Customer {
  driver?: Driver
  onboardingSteps?: OnboardingStep
  userType: 'customer'
  current_tier: TierType
}

export interface CreateCustomerResponse {
  customer: CustomerWithDriverOnboarding
  isNewlyCreated: boolean
}

export interface VendorUser extends Vendor {
  userType: 'vendor'
  contactInfos: VendorContactInfo[]
  logoUrl: string
}

export interface PartnerUser extends Partner {
  userType: 'partner'
}

export interface DriverUser extends Driver {
  userType: 'driver'
  customer: {
    customer_id: string
    business_name: string
  }
}

export interface PartnerAgentUser extends PartnerAgent {
  userType: 'partnerAgent'
  partner: {
    partner_id: string
    business_name: string
  }
}

export type User =
  | VendorUser
  | CustomerWithDriverOnboarding
  | PartnerUser
  | DriverUser
  | PartnerAgentUser


// Types from data-exports service

// Types from deals service
export interface CreateDealRequest {
  vendor_id: string
  deal_type: string
  title: string
  description: string
  discount_percentage?: number
  original_price?: number
  start_at: Date
  end_at?: Date
  locations: string[]
}

export interface PatchDealRequest {
  deal_type: string
  title: string
  description: string
  discount_percentage?: number
  original_price?: number
  start_at: Date
  end_at?: Date
  locations: string[]
}

export interface DealWithLocations extends Deal {
  businessLocations: VendorBusinessLocation[]
}


// Types from debit-cards service
export type CreateDebitCardRequest = CreateChildDebitCardForTruckWorkflowParams

export interface FreezeUnfreezeDebitCardRequest {
  debit_card_id: string
  is_frozen: boolean
}

export interface CancelDebitCardRequest {
  debit_card_id: string
}

export interface GetCardImageResponse {
  card_image_link: string
}

export interface PatchDebitCardRequest {
  truck_id?: string
}


// Types from deposit-invoices service
export interface GetPresignedUploadUrlRequest {
  transaction_id: string
  file_type: 'pdf' | 'png' | 'jpg' | 'jpeg' | 'heic'
}

export interface ConfirmUploadRequest {
  transaction_id: string
}

export interface GetPresignedUploadUrlResponse {
  presigned_url: string
  expires_in_seconds: number
}

export interface ConfirmUploadResponse {
  deposit_invoice_id: string
  success: boolean
}

export interface GetInvoiceForTransactionResponse {
  deposit_invoice_id: string
  presigned_url: string
  file_type: string
  uploaded_at: Date | null
  file_size_bytes: number
}


// Types from documents service
export interface DocumentUploadPresignedUrlsRequest {
  document_count: number
  document_sub_type?:
    | TruckDocumentSubType
    | TrailerDocumentSubType
    | VendorDocumentSubType
    | VendorBusinessLocationDocumentSubType
    | CashAdvanceInvoiceDocumentSubType
    | FuelAdvanceDocumentSubType
  file_extensions: string[]
}

export interface DocumentKeyResponse {
  fileKey: string
}

export interface DocumentUploadPresignedUrlsResponse {
  document_urls: PresignedUrlObject[]
}

export interface DocumentPathConfig {
  bucket: string
  path: string
  count: number
}

export interface DocumentUploadConfig {
  bucket: string
  docPath: string
  fileKey?: string
}

export interface DocumentFetchPresignedUrlsRequest {
  document_count: number
  document_sub_type?:
    | TruckDocumentSubType
    | TrailerDocumentSubType
    | VendorDocumentSubType
    | VendorBusinessLocationDocumentSubType
    | CashAdvanceInvoiceDocumentSubType
    | FuelAdvanceDocumentSubType
  document_sub_object_id?: string
}

export interface DocumentFetchPresignedUrlsResponse {
  document_urls: string[]
}

export interface CreateSignatureRequestRequest {
  role: string
  email: string
  name: string
  metadata?: Record<string, any>
  templateType: DropboxSignTemplateType
}

export interface CreateSignatureRequestResponse {
  sign_url: string
}

export interface LoanRequestWithLoanTermsOption extends LoanRequest {
  loanTermsOptions: LoanTermsOption[]
}

export interface DropboxSignWebhookEvent {
  event: {
    event_type: string
    event_time: string
    event_hash: string
  }
  signature_request: {
    signature_request_id: string
    metadata: {
      customer_id?: string
      application_id?: string
      loan_request_id?: string
      terms_id?: string
      funding_source?: string
      templateType?: string
    }
    signing_completed: boolean
    signatures: Array<{
      status_code: string
      signer_email_address: string
      signed_at: string
    }>
  }
  client_id: string
}


// Types from driver-invites service
export interface SendDriverInviteRequest {
  customer_id: string
  first_name: string
  last_name: string
  email: string
  truck_id: string
}

export interface FetchDriversRequest {
  // Optional — matches the schema below and real callers, which omit the key
  // entirely for "no filter" rather than sending ''.
  searchKeyword?: string
}

export interface AcceptDriverInviteRequest {
  invite_id: string
  sub_id?: string
  // Optional override only. The phone is normally sourced from the Auth0 profile
  // at accept (the hosted signup form already captures it), so the client sends
  // no phone. Present only for admin/back-compat callers that supply one.
  phone_number?: string // E.164 US, e.g. +15551234567
}

export interface DriverInviteJWTPayload {
  customer_id: string
  email: string
  jwt_id: string
  exp: number
}

export interface VerifyDriverInviteRequest {
  tach_token: string
}

export interface DriverOrInvite {
  object_id: string
  first_name: string
  last_name: string
  email: string
  // As stored on the Driver row (E.164 US when written via the driver-invites
  // accept path, but the admin patch endpoint doesn't enforce that format —
  // see services/admin-users). Null for pending invites and for drivers
  // without a stored number.
  phone_number: string | null
  is_primary_owner: boolean
  truck_id: string
  status: DriverInviteStatus
  is_driver: boolean
  updated_at: Date
}

export interface CancelDriverInviteRequest {
  invite_id: string
}


// Types from driver-performance service
export type ExpenseCategory = StaticBudgetCategory | string

export interface DriverRevenueData {
  driver: string // Short name for display (first name or "Average")
  fullName: string // Full name of the driver
  driverId: string | null // Driver UUID (null for "Average Driver")
  isRemoved: boolean // True for a soft-deleted driver kept for retained history (THT-789)
  revenuePerMile: number // Revenue per mile in dollars
  costPerMile: number // Cost per mile in dollars
  profitPerMile: number // Profit per mile (revenue - cost)
  totalMiles: number // Total miles driven in period
}

export interface ProfitabilityTrendData {
  month: string // Month name (e.g., "Jan", "Feb")
  year: string // Year (e.g., "2024")
  [driverName: string]: number | string // Dynamic keys for each driver's profit margin percentage
}

export interface DriverMetrics {
  driver: string // Driver full name
  driverId: string | null // Driver UUID (null for "Average Driver")
  status: 'Active' | 'Inactive'
  isRemoved: boolean // True for a soft-deleted driver kept for retained history (THT-789)
  profitMargin: number // Profit margin percentage
  profit: number // Total profit in dollars
  milesThisMonth: number // Total miles driven this month
  revenueThisMonth: number // Total revenue this month in dollars
}

export interface CategoryMetadata {
  category: string
  displayName: string
  emojiUnicode: string
  isCustom: boolean
}

export interface CostBreakdownData {
  driver: string // Driver short name or "Average"
  driverId: string | null // Driver UUID (null for "Average Driver")
  isRemoved: boolean // True for a soft-deleted driver kept for retained history (THT-789)
  // Dynamic category costs - keys are category names (static or custom_*)
  [category: string]: number | string | boolean | null
}

export interface CostBreakdownResponse {
  drivers: CostBreakdownData[] // Cost breakdown per driver
  categoryMetadata: Record<string, CategoryMetadata> // Metadata for each category (display name, emoji, etc.)
}

export interface SummaryMetrics {
  totalGrossProfit: number // Total gross profit in dollars
  avgProfitMargin: number // Average profit margin percentage
  totalRevenue: number // Total revenue in dollars
  totalExpenses: number // Total expenses in dollars
  totalMiles: number // Total miles driven
  avgRevenuePerDay: number // Average revenue per day in dollars
  avgMilesPerDay: number // Average miles per day
  driverCount: number // Number of active drivers
  businessRevenue: number // Revenue in the Business bucket (no truck) in dollars — not in totalRevenue
  businessExpenses: number // Expenses in the Business bucket (no truck) in dollars — not in totalExpenses
}

export interface DriverFinancialData {
  driverId: string
  firstName: string
  lastName: string
  status: string
  isRemoved: boolean // True for a soft-deleted driver kept for retained history (THT-789)
  totalRevenue: number // In cents
  totalExpenses: number // In cents
  expensesByCategory: Record<string, number> // In cents - supports static and custom categories
  // Monthly breakdown for trend data
  monthlyData: Map<string, MonthlyDriverData>
}

export interface MonthlyDriverData {
  revenue: number // In cents
  expenses: number // In cents
}

export interface DriverMileageData {
  driverId: string
  totalMiles: number
  monthlyMiles: Map<string, number>
}


// Types from drivers service
export interface CreateDriverRequest {
  customer_id: string
  first_name: string
  last_name: string
  address_st_number: string
  address_st_name: string
  address_unit?: string
  address_city: string
  address_state: string
  address_zip: string
  ssn: string
  phone_number: string
  email: string
  is_primary_owner: boolean
  date_of_birth: Date
  drivers_license_number: string
  drivers_license_state: string
  business_ownership_percentage: number
}

export interface UpsertPrimaryDriverResponse {
  driver: Driver
  isNewlyCreated: boolean
}

export interface ChangeDriverTruckRequestParams {
  driver_id: string
  truck_id: string
}

export interface PatchDriverRequest {
  first_name?: string
  last_name?: string
  address_st_number?: string
  address_st_name?: string
  address_unit?: string
  address_city?: string
  address_state?: string
  address_zip?: string
  ssn?: string
  phone_number?: string
  email?: string
  is_primary_owner?: boolean
  date_of_birth?: Date
}

export interface ListDriversForCustomerResponse {
  drivers: Driver[]
  total_count: number
}

export interface ListDriversQueryParams {
  status?: string
  is_primary_owner?: boolean
  limit?: number
  offset?: number
  sort_by?: 'created_at' | 'first_name' | 'last_name'
  sort_order?: 'ASC' | 'DESC'
}


// Types from electronic-logging-devices service
export interface TruckMileageSnapshotWithTruckFields extends TruckMileageSnapshot {
  truck_year: number
  truck_make: string
  truck_model: string
  truck_display_name: string
  vehicle_id_number: string
  driver: {
    first_name: string,
    last_name: string
  }
  // Previous odometer from prior completed snapshot, or truck's current_mileage as fallback
  previous_odometer?: number | null
  // Truck's current mileage included for reference
  truck?: {
    truck_year: number
    truck_make: string
    truck_model: string
    truck_display_name: string
    vehicle_id_number: string
    current_mileage?: number | null
  }
}

export interface MileageReportRequestsFilters {
  startDate?: Date | string
  endDate?: Date | string
  page?: number
  pageSize?: number
  truck_id?: string
  status?: TruckMileageSnapshotStatus
}

export interface MileageReportRequestsResponse {
  mileageReportRequests: TruckMileageSnapshotWithTruckFields[]
  // Customer-level: true when the resolved customer has a live Catena connection,
  // so the frontends can disable manual mileage submission.
  catena_connected: boolean
  pagination?: {
    totalCount: number
    hasMore: boolean
  }
}

export interface PaginationParams {
  page?: number
  pageSize?: number
  startDate?: Date
  endDate?: Date
}

export interface TruckWithDriver {
  truck_id: string
  truck_year: number
  truck_make: string
  truck_model: string | null
  truck_display_name: string
  vehicle_id_number: string | null
  eld_id: string | null
  driver?: {
    first_name: string
    last_name: string
  }
}

export interface TruckMileageSnapshotWithDriver extends TruckMileageSnapshot {
  driver: {
    first_name: string
    last_name: string
  }
}

export interface TruckWithRecentSnapshots extends TruckWithDriver {
  recentMileageSnapshots?: TruckMileageSnapshot[]
  mostRecentRequest?: TruckMileageSnapshot
  previous_odometer?: number | null
  current_mileage?: number | null
}

export interface TrucksWithoutELDResponse {
  trucks: TruckWithRecentSnapshots[]
  // Customer-level: true when the customer has a live Catena connection,
  // so the frontends can disable manual mileage submission.
  catena_connected: boolean
  pagination: {
    totalCount: number
    page: number
    pageSize: number
    totalPages: number
    hasMore: boolean
  }
}

export interface FetchSamsaraTokenRequest {
  link_code: string
  grant_type: 'authorization_code' | 'refresh_token'
}

export interface MileageReportRequestUpdate {
  snapshot_id: string
  cumulative_odometer: number
  truck_id: string
}

export interface UpdateMileageReportRequestsRequest {
  updates: MileageReportRequestUpdate[]
}

export interface FetchMotiveTokenRequest {
  link_code: string
  grant_type: 'authorization_code' | 'refresh_token'
}

export interface FetchSamsaraAccessTokenResponse {
  updatedEldInfo: SamsaraELDInfo
}

export type GenericELD = (SamsaraELDInfo | MotiveELDInfo) & {
  eld_type: 'samsara' | 'motive'
}

export interface CreateELDInfoResponse {
  eldInfo: SamsaraELDInfo | MotiveELDInfo
  isNewlyCreated: boolean
}

export interface SamsaraTokenResponseSchema {
  access_token: string
  expires_in: number
  scope: string
  token_type: string
  refresh_token: string
}

export interface MotiveTokenResponseSchema {
  access_token: string
  expires_in: number
  token_type: string
  refresh_token: string
}


// Types from emails service
export interface ReferralInviteRequest {
  owner_type: string
  owner_id: string
  recipient_email: string
  recipient_name?: string
}

export type LoadRequestPickupType = (typeof LOAD_REQUEST_PICKUP_TYPES)[number]

export interface LoadRequestPickupLocation {
  type: LoadRequestPickupType
  /** Dispatcher-facing string, e.g. "Dallas, TX" or "75201". Always present. */
  display: string
  city?: string
  state?: string
  zip?: string
  lat?: number
  lng?: number
}

export type LoadRequestCoverageTiming = (typeof LOAD_REQUEST_COVERAGE_TIMINGS)[number]

export interface LoadRequest {
  pickup_location: LoadRequestPickupLocation
  equipment_types: string[]
  /**
   * Optional for back-compat: app versions before the Find Me Freight update
   * omit it (renders as "Not specified"). Tighten to required once those
   * versions age out.
   */
  coverage_timing?: LoadRequestCoverageTiming
  /**
   * The concrete calendar date the carrier needs coverage on (ISO `yyyy-mm-dd`),
   * as picked in the app. Optional: older app versions omit it, and for
   * `same_day`/`next_day` the date is derivable — see `resolveCoverageDate`.
   */
  coverage_date?: string
  /**
   * The number the carrier confirmed dispatch should call back on (THT-753),
   * as E.164 US — see the shared {@link PHONE_E164_US} pattern.
   *
   * Optional, and `null` / `''` are accepted as EQUIVALENT TO ABSENT: a React
   * Native controlled input routinely serializes a cleared field as one of
   * those, and losing the whole load request over a cleared optional field
   * would cost the carrier the load, not just the callback number. All three
   * spellings fall back to the phone on the customer record (see
   * `resolveCallbackPhone`). A non-empty value that isn't E.164 US still 400s —
   * that is a malformed payload, not a cleared field.
   *
   * DISPLAY/CONTACT ONLY — it is never used for lookup or auth (identity stays
   * token-derived), and never written back to the customer record. Per-request
   * by design: confirming a number for one load must not silently re-point
   * every other system at it.
   */
  callback_phone?: string | null
}

export type LoadRequestPricingResponse = DispatchPricing

export interface RentalRequest {
  /** Where the carrier wants the truck, as typed/picked. e.g. "Dallas, TX". */
  location?: string
  /**
   * Equipment the carrier is after. Free-form on the wire on purpose — the UI
   * offers a dropdown, but the value is only ever RENDERED to an admin, so a
   * new dropdown option must not need a backend deploy to go out. Known enum
   * values still render as their proper labels (see `formatEquipmentType`).
   */
  equipment_type?: string
  /** Anything else the carrier wants the admin to know before they call. */
  notes?: string
}

export const LOAD_REQUEST_PICKUP_TYPES = ['current', 'manual'] as const

export const LOAD_REQUEST_COVERAGE_TIMINGS = ['same_day', 'next_day', 'future'] as const


// Types from facebook service
export interface TrackConversionMetaEventRequest {
  application_id: string // Application ID to fetch customer data
  event_name: string // "CompleteRegistration", "Lead", "SubmitApplication"
  event_source_url: string // URL where event occurred
  fbp?: string // Facebook browser pixel cookie (_fbp)
  fbc?: string // Facebook click ID cookie (_fbc)
  ip_address?: string // User's IP address (optional, will use request IP if not provided)
  user_agent?: string // Browser user agent (optional, will use request header if not provided)
}

export interface TrackConversionMetaEventResponse {
  message: string
  success: boolean
}


// Types from feature-flags service
export interface EvaluateFlagRequest {
  flagKey: string
  userId: string
  userType: Entity
  environment: 'dev' | 'staging' | 'prod'
}

export interface EvaluateBatchRequest {
  userId: string
  userType: Entity
  environment: 'dev' | 'staging' | 'prod'
  flagKeys?: string[]
}

export interface FlagEvaluation {
  flagKey: string
  value: boolean | string | number
  reason: string
  bucket?: number
}

export interface BatchEvaluationResponse {
  flags: Record<string, boolean | string | number>
  evaluations: FlagEvaluation[]
}


// Types from highway service
export interface CarrierNameLookupMatch {
  identifier_type: string
  legal_name: string
}

export interface CarrierNameLookupResponse {
  found: boolean
  legal_name?: string
  identifier_type?: string
  ambiguous?: boolean
  alternate?: CarrierNameLookupMatch
  lookup_incomplete?: boolean
}

export interface CarrierPrefillAddress {
  street_number: string
  street_name: string
  unit?: string
  city: string
  state: string
  zip: string
}

export interface CarrierPrefill {
  legal_name: string
  dba_name?: string
  address?: CarrierPrefillAddress
  phone?: string
  email?: string
  /**
   * Named for the application field it populates, but it measures AUTHORITY age —
   * whole years since the earliest carrier authority grant date Highway has on file,
   * not since the business was formed. A company that hauled intrastate for a decade
   * before getting interstate authority reads low here. Fine as an editable
   * suggestion; do not treat it as business age anywhere it is not user-confirmed.
   */
  years_in_business?: number
  owned_tractors?: number
  owned_trailers?: number
  contact_first_name?: string
  contact_last_name?: string
}

export interface CarrierPrefillResponse {
  found: boolean
  prefill?: CarrierPrefill
}

export interface HighwayAuthenticationRequest {
  code: string
  customer_id?: string
  application_id?: string
  claimed_years_in_business?: number
  claimed_annual_revenue?: number
  total_business_debt?: number
  monthly_debt_payment?: number
}

export interface PrePrequalRequest {
  mc_or_dot_number?: string
  has_confirmed_mc_or_dot_number?: boolean
  business_name?: string
  email_template_id?: string
  email?: string
}

export interface PrePrequalResponse {
  approved?: boolean
  legal_name: string
}

export interface AwaitPrequalDecisionResponse {
  result: boolean
}

export interface ConferenceLeadRequest {
  role: 'carrier' | 'broker' | 'factoring'
  first_name: string
  last_name: string
  company: string
  email: string
  mc_or_dot_number?: string
  fleet_size?: number
  reported_revenue_cents?: number
  active_clients?: number
  calculator_context: Record<string, any>
  // Optional — omitted on initial submission, provided when prospect chooses demo/signup
  action?: 'demo' | 'signup'
  // Passed on the second call (action) to thread the Slack reply and link the MarketingEvent
  lead_id?: string
  slack_message_ts?: string
}

export interface DemoLeadRequest {
  email: string
}

export interface VerificationStuckRequest {
  attempted_numbers: string[]
}

export interface VerificationStuckResponse {
  ok: boolean
}

export interface Identifier {
  is_type: string
  value: string
}

export interface TaxIdentifier {
  is_type: string
  value: string
  source: string
}

export interface AuthorityAssessment {
  rating: string
  carrier_interstate_authority_check: string
  broker_interstate_authority_check: string
  is_active_insurance: boolean
  no_out_of_service_order: boolean
  is_satisfactory_safety_rating: boolean
  is_operating_status_active: boolean
  is_inspection_history_greater_than_zero: boolean
  latest_safety_rating: string
}

export interface Authorities {
  common_authority_status: string
  continuous_authority_grant_date_common: string
  contract_authority_status: string
  continuous_authority_grant_date_contract: string
  broker_authority_status: string
  continuous_authority_grant_date_broker: string
}

export interface LatestLIAuthority {
  mx_type: string | null
  rfc_number: string | null
  common_authority: string
  pending_common_authority: string
  common_authority_revocation: string
  contract_authority: string
  pending_contract_authority: string
  contract_authority_revocation: string
  broker_authority: string
  pending_broker_authority: string
  broker_authority_revocation: string
  is_freight: boolean
  is_passenger: boolean
  is_household_goods: boolean
  is_private_check: boolean
  is_enterprise_check: boolean
  is_bipd_required: boolean
  is_cargo_required: boolean
  is_bond_surety_required: boolean
  bipd_on_file: number
  is_cargo_on_file: boolean
  is_bond_surety_on_file: boolean
  is_address_deliverable: boolean
  file_date: string
}

export interface Authority {
  authorities: Authorities
  licensed_capabilities: string[]
  latest_li_authority: LatestLIAuthority
}

export interface HighwayCarrierAddress {
  is_type: string
  street1: string
  street2: string
  city: string
  postal_code: string
  state: string
  nationality: string
}

export interface RuleResult {
  result: string
  overrides: any[]
}

export interface Rules {
  has_verified_physical_location_activity: RuleResult
  has_verified_manually_entered_identifier: RuleResult
  has_been_inspected_in_the_last_twenty_four_months: RuleResult
  has_no_published_identity_alerts: RuleResult
  has_vin_if_auto_policy_is_scheduled_autos: RuleResult
  has_mc_number: RuleResult
  has_dot_number: RuleResult
  is_authorized_for_property: RuleResult
  interstate_carrier_authority_is_active: RuleResult
  no_active_oos_orders: RuleResult
  safety_rating_satisfactory_or_unrated: RuleResult
  safer_operating_status_active: RuleResult
  authority_age_requirement: RuleResult
  bipd_requirement: RuleResult
  cargo_requirement: RuleResult
  general_liability_requirement: RuleResult
  sets_requiring_override_file: RuleResult
}

export interface Classification {
  name: string
  result: string
  rules: Rules
}

export interface Summary {
  overall_result: string
}

export interface RulesAssessment {
  overall_result: string
  summary: Summary
  classifications: Classification[]
}

export interface LatestSMSBasic {
  file_date: string
  driver_fitness_measure: string
  is_driver_fitness_acute_critical: boolean
  driver_fitness_percentile: number
  driver_fitness_over_threshold: boolean
  hos_compliance_measure: string
  is_hos_compliance_acute_critical: boolean
  hos_compliance_percentile: number
  hos_compliance_over_threshold: boolean
  substance_alcohol_measure: string
  is_substance_alcohol_acute_critical: boolean
  substance_alcohol_percentile: number | null
  substance_alcohol_over_threshold: boolean
  unsafe_driving_measure: string
  is_unsafe_driving_acute_critical: boolean
  unsafe_driving_percentile: number
  unsafe_driving_over_threshold: boolean
  vehicle_maintenance_measure: string
  is_vehicle_maintenance_acute_critical: boolean
  vehicle_maintenance_percentile: number
  vehicle_maintenance_over_threshold: boolean
}

export interface SMSBasic {
  file_date: string
  driver_fitness_measure: string
  is_driver_fitness_acute_critical: boolean
  hos_compliance_measure: string
  is_hos_compliance_acute_critical: boolean
  substance_alcohol_measure: string
  is_substance_alcohol_acute_critical: boolean
  unsafe_driving_measure: string
  is_unsafe_driving_acute_critical: boolean
  vehicle_maintenance_measure: string
  is_vehicle_maintenance_acute_critical: boolean
}

export interface Safety {
  safety_rating: string
  safety_rating_effective_date: string
  safety_rating_review_date: string
  safety_rating_review_type: string
  latest_sms_basic: LatestSMSBasic
  sms_basics: SMSBasic[]
}

export interface Certification {
  is_type: string
  external_id: string
  file_date: string
  is_verified: boolean
}

export interface VerifiedCertifications {
  carb: boolean
  carb_number: string | null
  carb_start: string | null
  carb_end: string | null
  carb_tru: boolean
  carb_tru_number: string | null
  carb_tru_start: string | null
  carb_tru_end: string | null
  hazmat: boolean
  hazmat_number: string | null
  hazmat_start: string | null
  hazmat_end: string | null
  smart_way: boolean
  smart_way_number: string
  smart_way_start: string | null
  smart_way_end: string | null
}

export interface Certifications {
  all: Certification[]
  verified: VerifiedCertifications
}

export interface Contact {
  is_type: string
  name: string
  email_address: string | null
  phone: string | null
}

export interface Phone {
  is_type: string
  value: string
}

export interface EmailAddress {
  is_type: string
  value: string
}

export interface ContactInformation {
  dispatch_contact: Contact
  line_item_contacts: Contact[]
  contacts: Contact[]
  phones: Phone[]
  email_addresses: EmailAddress[]
}

export interface Inspection {
  total_inspections: number
  driver_fitness_inspections: number
  driver_fitness_oos_inspections: number
  hazmat_inspections: number
  hazmat_oos_inspections: number
  vehicle_maintenance_inspections: number
  vehicle_maintenance_oos_inspections: number
}

export interface Crash {
  total: number
  fatal_crashes_total: number
  injury_crashes_total: number
  tow_away_crashes_total: number
}

export interface InsurancePolicy {
  status: string
  is_type: string
  number: string
  limit: string
  effective_date: string
  expiration_date: string
  cancellation_date: string | null
  insurance_certificate_id: number
  scheduled_autos: boolean
  any_auto: boolean
  owned_autos: boolean
  hired_autos: boolean
  non_owned_autos: boolean
  insurance_insurer: {
    name: string
    short_name: string
    naic: string
    street1: string
    street2: string | null
    city: string
    state: string
    phone: string
    postal_code: string
    website: string
  }
}

export interface InsuranceCertificate {
  id: number
  file: {
    id: number
    filename: string
    content_type: string
    url: string
  }
}

export interface Insurance {
  bipd_required: number
  insurance_policies: InsurancePolicy[]
  insurance_certificates: InsuranceCertificate[]
}

export interface CarrierMode {
  is_type: string
}

export interface CargoCarried {
  id: number
  name: string
}

export interface EntityType {
  id: number
  name: string
}

export interface Operations {
  mcs150_form_date: string
  mcs150_year: number
  mcs150_mileage: number
  mcsip_step_description: string | null
  mcsip_date: string | null
  classifications: string[]
  operating_status: string
  operating_status_date: string
  fleet_size: string
  cargo_carried: CargoCarried[]
  entity_types: EntityType[]
  total_power_units: number
  owned_tractors: number
  owned_trailers: number
  term_leased_tractors: number
  term_leased_trailers: number
  total_drivers: number
}

export interface EquipmentSummary {
  van_trailers: number
  reefer_trailers: number
  flatbed_trailers: number
  tanker_trailers: number
  intermodal_trailers: number
  pneumatic_trailers: number
  dumps_trailers: number
  car_hauler_trailers: number
  double_drop_trailers: number
  lowboy_trailers: number
  grain_trailers: number
  livestock_trailers: number
  heavy_haul_trailers: number
  drop_deck_trailers: number
  refuse_transfer_trailers: number
  forestry_trailers: number
  uncategorized_trailers: number
  total_observed_trailers: number
  truck_tractors: number
  cargo_vans: number
  straight_box_trucks: number
  buses: number
  uncategorized_trucks: number
  total_observed_power_units: number
}

export interface Equipment {
  summary: EquipmentSummary
}

export interface HighwayCarrierDetails {
  id: number
  legal_name: string
  dba_name: string | null
  connection: string | null
  dot_number: number
  mc_number: number
  identifiers: Identifier[]
  tax_identifiers: TaxIdentifier[]
  authority_assessment: AuthorityAssessment
  authority: Authority
  addresses: HighwayCarrierAddress[]
  rules_assessment: RulesAssessment
  safety: Safety
  certifications: Certifications
  contact_information: ContactInformation
  inspections: Inspection
  crashes: Crash
  insurance: Insurance
  carrier_modes: CarrierMode[]
  operations: Operations
  equipment: Equipment
  integrations: any | null
}


// Types from internal-bank-accounts service
export interface BalancesResponse {
  grossProfit: number
  savingPacePercentageDifference: number
  budgetedBalance: number
  pendingTransfer: number
  availableTakeHomePay: number
  cashAdvanceLimit: number
  cashAdvanceAvailable: number
  isCashAdvanceActive: boolean
  mtdRevenue: number
  momRevenuePercentageDifference: number
}


// Types from lemlist service
export type LemlistWebhookEvent = LemlistWebhookPayload


// Types from linked-accounts service
export interface PostPlaidLinkTokenRequest {
  owner_id: string
  entity: Entity
}

export interface PostPlaidReauthTokenRequest {
  owner_id: string
  entity: Entity
  linked_account_id: string
}

export interface CreateLinkedAccountRequest {
  public_token: string
  entity: Entity
}

export interface WithdrawFundsRequest extends InitiateWithdrawalParams {}

export interface DepositFundsAuthorization {
  consent_version: string
  consent_text: string
}

export interface DepositFundsRequest {
  amount: number // cents
  linked_account_id: string
  internal_bank_account_id: string
  customer_id: string
  idempotency_key: string // front-end-supplied, dedupes a submission
  authorization: DepositFundsAuthorization
}

export interface LinkedAccountDepositEligibility {
  deposit_eligible: boolean
  deposit_ineligible_reason: 'not_linked' | 'debit_disabled' | null
}

export interface CreateLinkedAccountRequest {
  public_token: string
  entity: Entity
}

export interface CreateIdVerificationSessionRequest {
  customer_id: string
  application_id: string
}

export interface CreateIdVerificationSessionResponse {
  link_token: string
}

export enum BankAccountType {
  Checking = 'depository#checking',
  Savings = 'depository#savings'
}

export interface CreateManualLinkedAccountRequest {
  account_number: string
  routing_number: string
  bank_account_type: BankAccountType
  entity: Entity
}


// Types from maintenance-records service
export interface CreateMaintenanceRecordRequest {
  asset_type: 'truck' | 'trailer'
  asset_id: string
  maintenance_type: 'repairs' | 'preventative' | 'tires'
  file_extension: string
  date_of_maintenance: Date
  description?: string
}

export interface MaintenanceRecordWithDisplayName extends MaintenanceRecord {
  asset_display_name: string
  reminder: MaintenanceReminder
}

export interface PatchMaintenanceRecordRequest {
  asset_type: 'truck' | 'trailer'
  asset_id: string
  maintenance_type: 'repairs' | 'preventative' | 'tires'
  file_extension: string
  date_of_maintenance: Date
  description?: string
  isNewFile: boolean
}


// Types from maintenance-reminders service
export interface CreateMaintenanceReminderRequest {
  asset_type: 'truck' | 'trailer'
  asset_id: string
  record_id?: string
  reminder_type: 'date' | 'days' | 'mileage'
  mileage?: number
  date?: string
  days?: number
  maintenance_type: 'repairs' | 'tires' | 'preventative'
}

export interface MaintenanceReminderWithDisplayNameVIN extends MaintenanceReminder {
  vehicle_id_number: string
  asset_display_name: string
}

export interface PatchMaintenanceReminderRequest {
  asset_type: 'truck' | 'trailer'
  asset_id: string
  record_id?: string
  reminder_type: 'date' | 'days' | 'mileage'
  mileage?: number
  date?: string
  days?: number
  maintenance_type: 'repairs' | 'tires' | 'preventative'
}


// Types from miles service
export type MilesMessageStatus = 'pending' | 'processing' | 'completed' | 'failed'

export type MilesMessageRole = 'user' | 'assistant'

export type MilesPresetCategory = 'fleet' | 'financial' | 'drivers' | 'maintenance' | 'general'

export type MilesStructuredDataType =
  | 'metric_cards'
  | 'line_chart'
  | 'bar_chart'
  | 'pie_chart'
  | 'table'
  | 'comparison_table'
  | 'forecast_chart'
  | 'insights_list'

export interface MilesMetricCard {
  label: string
  value: string | number
  change?: number
  changeLabel?: string
  icon?: string
}

export interface MilesChartDataPoint {
  label: string
  value: number
  color?: string
}

export interface MilesLineChartData {
  labels: string[]
  datasets: {
    label: string
    data: number[]
    color?: string
  }[]
}

export interface MilesBarChartData {
  labels: string[]
  datasets: {
    label: string
    data: number[]
    color?: string
  }[]
}

export interface MilesPieChartData {
  segments: {
    label: string
    value: number
    color?: string
  }[]
}

export interface MilesTableData {
  headers: string[]
  rows: (string | number)[][]
}

export interface MilesComparisonTableData {
  headers: string[]
  rows: {
    label: string
    current: string | number
    previous: string | number
    change?: number
  }[]
}

export interface MilesForecastPoint {
  date: string
  projected_balance_cents: number
  expected_income_cents: number
  expected_expenses_cents: number
}

export interface MilesForecastRecurringTransaction {
  type: 'income' | 'expense'
  frequency: string
  average_amount_cents: number
  merchant_name: string
  next_expected_date: string
}

export interface MilesForecastChartData {
  forecast_points: MilesForecastPoint[]
  starting_balance_cents: number
  projected_end_balance_cents: number
  risk_level: 'low' | 'medium' | 'high'
  risk_factors: string[]
  recurring_transactions: MilesForecastRecurringTransaction[]
}

export interface MilesInsight {
  insight_id: string
  type: 'anomaly' | 'trend' | 'optimization' | 'warning'
  severity: 'low' | 'medium' | 'high' | 'info'
  category?: string
  title: string
  description: string
  recommended_action?: string
}

export interface MilesInsightsCategory {
  category: string
  total_cents: number
  percentage_of_total: number
  trend: 'increasing' | 'decreasing' | 'stable'
}

export interface MilesInsightsListData {
  insights: MilesInsight[]
  summary: {
    total_insights: number
    high_priority_count: number
    period_days: number
    total_expenses_cents: number
  }
  top_categories: MilesInsightsCategory[]
}

export interface MilesStructuredDataBlock {
  type: MilesStructuredDataType
  title?: string
  data:
    | MilesMetricCard[]
    | MilesLineChartData
    | MilesBarChartData
    | MilesPieChartData
    | MilesTableData
    | MilesComparisonTableData
    | MilesForecastChartData
    | MilesInsightsListData
}

export interface MilesChatMessage {
  message_id: string
  role: MilesMessageRole
  content: string
  status: MilesMessageStatus
  structured_data: MilesStructuredDataBlock[] | null
  created_at: string
}

export interface MilesChatConversation {
  conversation_id: string
  title: string | null
  created_at: string
  updated_at: string
  last_message_preview?: string
}

export interface MilesChatPreset {
  preset_id: string
  category: MilesPresetCategory
  prompt_text: string
  display_text: string
  icon_name: string
  sort_order: number
  is_active: boolean
}

export interface SendMilesMessageRequest {
  conversation_id?: string
  message: string
}

export interface GetConversationsQueryParams {
  limit?: number
  offset?: number
}

export interface GetConversationMessagesQueryParams {
  limit?: number
  offset?: number
}

export interface SendMilesMessageResponse {
  message_id: string
  conversation_id: string
  status: MilesMessageStatus
}

export interface GetMilesMessageStatusResponse {
  message_id: string
  status: MilesMessageStatus
  content?: string
  structured_data?: MilesStructuredDataBlock[] | null
  error_message?: string
}

export interface GetMilesConversationsResponse {
  conversations: MilesChatConversation[]
  total_count: number
}

export interface GetMilesConversationMessagesResponse {
  conversation_id: string
  messages: MilesChatMessage[]
  total_count: number
}

export interface GetMilesPresetPromptsResponse {
  prompts: MilesChatPreset[]
}

export interface DeleteMilesConversationResponse {
  success: boolean
  message: string
}


// Types from monthly-statements service

// Types from notifications service
export interface RegisterDeviceRequest {
  device_token: string
  platform: 'ios' | 'android'
  unique_hardware_id?: string
}

export interface MarkAsViewedRequest {
  notification_ids: string[]
}


// Types from onboarding-steps service

// Types from partner-agent-invites service
export interface SendPartnerAgentInviteRequest {
  partner_id: string
  first_name: string
  last_name: string
  email: string
}

export interface FetchPartnerAgentsRequest {
  searchKeyword: string
}

export interface AcceptPartnerAgentInviteRequest {
  invite_id: string
  sub_id?: string
}

export interface PartnerAgentInviteJWTPayload {
  partner_id: string
  email: string
  jwt_id: string
  exp: number
}

export interface VerifyPartnerAgentInviteRequest {
  tach_token: string
}

export interface PartnerAgentOrInvite {
  object_id: string
  first_name: string
  last_name: string
  email: string
  status: PartnerAgentInviteStatus
  is_partner_agent: boolean
  updated_at: Date
}

export interface CancelPartnerAgentInviteRequest {
  invite_id: string
}


// Types from partner-contact-infos service
export interface PatchPartnerContactInfoRequest {
  email: string
  first_name: string
  last_name: string
  phone_number: string
  position: string
}

export interface CreatePartnerContactInfoRequest {
  email: string
  first_name: string
  last_name: string
  phone_number: string
  position: string
  partner_id: string
}

export interface CreatePartnerContactInfoResponse {
  partnerContactInfo: PartnerContactInfo
  isNewlyCreated: boolean
}


// Types from partners service
export interface PatchPartnerRequest {
  business_name?: string
  business_phone_number?: string
  business_email?: string
  website_url?: string
  address_st_number?: string
  address_st_name?: string
  address_unit?: string
  address_city?: string
  address_state?: string
  address_zip?: string
  hours_of_operation?: string
  description_of_services?: string
  mc_number?: string
  ein_number?: string
  partner_signup_step?: PartnerSignupStep
  contract_signature_full_name?: string
  contract_signature_title?: string
  contract_signed_at?: string
  contract_agreement_accepted?: boolean
}

export interface CreatePartnerRequest {
  email: string
  email_verified: boolean
  phone_number?: string
  sub_id?: string
}

export interface CreatePartnerResponse {
  partner: PartnerWithContacts
  isNewlyCreated: boolean
}

export interface PartnerWithContacts extends Partner {
  contactInfos: PartnerContactInfo[]
  logoUrl: string
}


// Types from prequal service
export enum PrequalQuestionId {
  INDEPENDENT = 'independent',
  YEARS = 'years',
  TRUCK = 'truck',
  REVENUE = 'revenue'
}

export interface PrequalQuestion {
  /**
   * The ID of the question
   */
  id: PrequalQuestionId

  /**
   * The exact question text shown to the user
   */
  question: string

  /**
   * The user's answer
   */
  answer: boolean
}

export interface TrackPrequalRequest {
  /**
   * Array of questions with their exact text and answers
   */
  questions: PrequalQuestion[]

  /**
   * Email address of the person completing prequal
   */
  email?: string

  /**
   * Business name (if provided)
   */
  businessName?: string

  /**
   * MC or DOT number (if provided)
   */
  mcDotNumber?: string

  /**
   * Legal name from FMCSA lookup (if MC/DOT was provided and confirmed)
   */
  legalName?: string

  /**
   * Timestamp when prequal was completed
   */
  completedAt?: string

  /**
   * Selected membership tier (starter, core, pro)
   */
  selectedTier?: string

  /**
   * Email template ID from cold email campaign link
   */
  emailTemplateId?: string
}

export interface TrackPrequalResponse {
  message: string
  passed: boolean
  failedQuestions?: string[]
}

export interface ContactFormRequest {
  firstName: string
  lastName: string
  companyName?: string
  email: string
  phoneNumber: string
  mcDotNumber?: string
  message?: string
  formType?: 'contact' | 'partner'
  emailTemplateId?: string
}

export interface ContactFormResponse {
  message: string
}


// Types from referrals service
export interface ReferralMetrics {
  monthlyReferralPayout: number
  activeReferralCount: number
  activatedThisMonth: number
  pendingCount: number
}

export interface ReferralPayoutObject {
  month: string
  revenue: number
}


// Types from scheduled-withdrawals service
export interface CreateScheduledWithdrawalRequest {
  amount_type: ScheduledWithdrawalAmountType
  amount_in_cents?: number
  source_bucket_category?: string
  frequency: ScheduledWithdrawalFrequency
  days_of_week?: number[]
  day_of_month?: number
  first_occurrence_date: string
  internal_bank_account_id: string
  linked_account_id: string
  label?: string
}

export type PatchScheduledWithdrawalRequest =
  | { action: 'pause' | 'resume' }
  | { amount_in_cents?: number; label?: string | null; linked_account_id?: string }
  | {
      frequency: ScheduledWithdrawalFrequency
      days_of_week?: number[]
      day_of_month?: number
      first_occurrence_date: string
    }


// Types from trailers service
export interface CreateTrailerRequest {
  customer_id: string
  vehicle_id_number: string
  trailer_display_name?: string
  trailer_make: string
  trailer_model: string
  trailer_year: number
  ownership_status: OwnershipStatus
  pay_for_repairs: boolean
  tire_brand_quality: TireBrandQuality
  insurance_payment_amount: number
  trailer_payment_amount: number
}

export interface PatchTrailerRequest {
  // TODO: Once FE and Mobile are updated to not send customer_id, remove the field entirely
  customer_id: string
  trailer_id: string
  ownership_status: OwnershipStatus
  pay_for_repairs: boolean
  tire_brand_quality: TireBrandQuality
  trailer_payment_amount: number
  insurance_payment_amount: number
  trailer_display_name: string
  show_asset_image?: boolean
}


// Types from transactions service
export interface TruckAttributionInput {
  truck_id: string
  amount: number
}

export interface PatchTransactionRequest {
  category?: string
  truck_id?: string // Deprecated: Use truck_attributions for multi-truck support
  truck_attributions?: TruckAttributionInput[]
}

export interface PatchTransactionResponse {
  category: string
  transaction_id: string
}

export interface FetchTransactionsRequest {
  offset?: number
  limit?: number
  searchQuery?: string
  startDate?: string
  endDate?: string
  isAmountDescending?: boolean
  isDateDescending?: boolean
  category?: string
  truck_id?: string
  orderBy?: string
  /**
   * Minimum transaction amount in cents (inclusive).
   * Use negative values to filter expenses.
   * @example 5000 // Transactions >= $50.00
   * @example -10000 // Expenses >= $100.00 (in magnitude)
   */
  amountMin?: number
  /**
   * Maximum transaction amount in cents (inclusive).
   * Use negative values to filter expenses.
   * @example -1 // All expenses (negative amounts)
   * @example 10000 // Transactions <= $100.00
   */
  amountMax?: number
}

export interface DownloadTransactionsRequest {
  searchQuery?: string
  startDate?: string
  endDate?: string
  isAmountDescending?: boolean
  isDateDescending?: boolean
  category?: string
  truck_id?: string
  orderBy?: string
  amountMin?: number
  amountMax?: number
  format?: 'csv' | 'qbo' | 'ofx'
}

export interface TruckAttributionWithTruck extends TransactionTruckAttribution {
  truck?: Truck
}

export interface TransactionWithPayments extends Transaction {
  payments: PaymentsWithDisplayNames[]
  truck: Truck
  truckAttributions?: TruckAttributionWithTruck[]
  debit_card?: Pick<DebitCard, 'debit_card_id' | 'last_four_digits'>
  deposit_invoice?: Pick<DepositInvoice, 'upload_confirmed' | 'uploaded_at'>
}

export interface PaymentsWithDisplayNames extends Payment {
  status_display_name: PaymentStatusDisplayNames
  payment_context_display_name: string
}

export interface PendingTransactionItem {
  pending_transaction_id: string
  amount: number
  category: string
  description: string | null
  status: string
  // ISO-8601 string, not a Date: this shape is serialized to JSON on the wire and copied verbatim to
  // the FE types, where `created_at` arrives as a string. The handler emits `.toISOString()` to match.
  created_at: string
}


// Types from trucks service
export interface CreateTruckRequest {
  customer_id: string
  vehicle_id_number?: string
  truck_display_name?: string
  truck_make: string
  truck_model: string
  truck_year: number
  ownership_status: OwnershipStatus
  truck_class_number: number
  starting_mileage: number
  typical_annual_mileage: number
  is_out_of_service: boolean
  out_of_service_reason?: string
  pay_for_repairs: boolean
  tire_brand_quality: TireBrandQuality
  engine_condition: EngineCondition
  truck_payment_amount: number
  insurance_payment_amount: number
  // Optional maintenance dates an admin can capture during onboarding (YYYY-MM-DD).
  date_of_last_pm?: string
  date_of_last_repair?: string
}

export interface PatchTruckRequest {
  // TODO: Once FE and Mobile are updated to not send customer_id, remove the field entirely
  customer_id: string
  truck_id: string
  ownership_status: OwnershipStatus
  starting_mileage: number
  typical_annual_mileage: number
  is_out_of_service: boolean
  out_of_service_reason?: string
  pay_for_repairs: boolean
  tire_brand_quality: TireBrandQuality
  engine_condition: EngineCondition
  truck_payment_amount: number
  insurance_payment_amount: number
  truck_display_name: string
  show_asset_image?: boolean
  // Optional maintenance dates (YYYY-MM-DD); empty string clears the value.
  date_of_last_pm?: string
  date_of_last_repair?: string
}


// Types from vendor-business-locations service
export interface CreateVendorBusinessLocationRequest {
  vendor_id: string
  business_phone_number: string
  email: string
  website_url?: string
  address_st_number: string
  address_st_name: string
  address_unit?: string
  address_city: string
  address_state: string
  address_zip: string
  hours_of_operation: string
  description_of_services: string
  primary_vendor_type: VendorType
  secondary_vendor_types?: VendorType[]
  location_name: string
}

export interface PatchVendorBusinessLocationRequest {
  business_phone_number: string
  email: string
  website_url?: string
  address_st_number: string
  address_st_name: string
  address_unit?: string
  address_city: string
  address_state: string
  address_zip: string
  hours_of_operation: string
  description_of_services: string
  secondary_vendor_types: VendorType[]
  primary_vendor_type: VendorType
  location_name: string
}

export interface FetchLocationsWithinRadiusRequest extends PaginatedRequest {
  radius: number
  latitude: number
  longitude: number
  searchQuery?: string
  vendorTypes?: VendorType[]
}

export interface VendorBusinessLocationWithDeals extends VendorBusinessLocation {
  imageUrl: string
  deals: Deal[]
  vendor: Vendor
}

export interface VendorLocationPin {
  location_id: string
  latitude: number
  longitude: number
  primary_vendor_type: string
  business_name: string
}


// Types from vendor-contact-infos service
export interface PatchVendorContactInfoRequest {
  email: string
  first_name: string
  last_name: string
  phone_number: string
  position: string
}

export interface CreateVendorContactInfoRequest {
  email: string
  first_name: string
  last_name: string
  phone_number: string
  position: string
  vendor_id: string
  is_primary_owner: boolean
  address_st_number: string
  address_st_name: string
  address_unit: string | null
  address_city: string
  address_state: string
  address_zip: string
}

export interface CreateVendorContactInfoResponse {
  vendorContactInfo: VendorContactInfo
  isNewlyCreated: boolean
}


// Types from vendors service
export interface PatchVendorRequest {
  business_name?: string
  business_phone_number?: string
  business_email?: string
  website_url?: string
  address_st_number?: string
  address_st_name?: string
  address_unit?: string
  address_city?: string
  address_state?: string
  address_zip?: string
  hours_of_operation?: string
  description_of_services?: string
  vendor_signup_step?: VendorSignupStep
  cb_consent_given?: boolean
  employer_id_number?: string
  years_in_business?: number
  primary_vendor_type?: VendorType
}

export interface VendorWithBusinessLocations extends Vendor {
  businessLocations: VendorBusinessLocation[]
}

export interface SearchVendorsRequest extends PaginatedRequest {
  searchQuery: string
}

export interface VendorSearchResult {
  vendor_id: string
  business_name: string
  address_st_number: string
  address_st_name: string
  address_unit: string
  address_city: string
  address_state: string
  address_zip: string
}

export interface SearchVendorsResponse {
  vendors: VendorSearchResult[]
  hasMore: boolean
}

export interface CreateVendorRequest {
  email: string
  email_verified: boolean
  phone_number?: string
  sub_id?: string
}

export interface CreateVendorResponse {
  vendor: VendorWithContacts
  isNewlyCreated: boolean
}

export interface VendorWithContacts extends Vendor {
  contactInfos: VendorContactInfo[]
  logoUrl: string
}


